/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.14.25
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AgreementCreateDto
 */
export interface AgreementCreateDto {
    /**
     * 
     * @type {string}
     * @memberof AgreementCreateDto
     */
    'version': string;
    /**
     * 
     * @type {AgreementType}
     * @memberof AgreementCreateDto
     */
    'type': AgreementType;
    /**
     * 
     * @type {string}
     * @memberof AgreementCreateDto
     */
    'content': string;
}


/**
 * 
 * @export
 * @interface AgreementDto
 */
export interface AgreementDto {
    /**
     * 
     * @type {number}
     * @memberof AgreementDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AgreementDto
     */
    'version': string;
    /**
     * 
     * @type {AgreementType}
     * @memberof AgreementDto
     */
    'type': AgreementType;
    /**
     * 
     * @type {string}
     * @memberof AgreementDto
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof AgreementDto
     */
    'content'?: string;
}


/**
 * 
 * @export
 * @interface AgreementTracking
 */
export interface AgreementTracking {
    /**
     * 
     * @type {number}
     * @memberof AgreementTracking
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AgreementTracking
     */
    'generatedUserId': string;
    /**
     * 
     * @type {number}
     * @memberof AgreementTracking
     */
    'userId': number | null;
    /**
     * 
     * @type {string}
     * @memberof AgreementTracking
     */
    'version': string;
    /**
     * 
     * @type {AgreementType}
     * @memberof AgreementTracking
     */
    'type': AgreementType;
    /**
     * 
     * @type {string}
     * @memberof AgreementTracking
     */
    'created': string;
}


/**
 * 
 * @export
 * @interface AgreementTrackingCreateDto
 */
export interface AgreementTrackingCreateDto {
    /**
     * 
     * @type {string}
     * @memberof AgreementTrackingCreateDto
     */
    'generatedUserId': string;
    /**
     * 
     * @type {number}
     * @memberof AgreementTrackingCreateDto
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgreementTrackingCreateDto
     */
    'version': string;
    /**
     * 
     * @type {AgreementType}
     * @memberof AgreementTrackingCreateDto
     */
    'type': AgreementType;
}


/**
 * 
 * @export
 * @interface AgreementTrackingStatusDto
 */
export interface AgreementTrackingStatusDto {
    /**
     * 
     * @type {string}
     * @memberof AgreementTrackingStatusDto
     */
    'version': string;
    /**
     * 
     * @type {AgreementType}
     * @memberof AgreementTrackingStatusDto
     */
    'type': AgreementType;
    /**
     * 
     * @type {number}
     * @memberof AgreementTrackingStatusDto
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgreementTrackingStatusDto
     */
    'generatedUserId': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum AgreementType {
    Tc = 'TC',
    Pp = 'PP'
}


/**
 * 
 * @export
 * @interface AgreementUserPairGetResponseDto
 */
export interface AgreementUserPairGetResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof AgreementUserPairGetResponseDto
     */
    'exist': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgreementUserPairGetResponseDto
     */
    'otherUser': boolean;
}
/**
 * 
 * @export
 * @interface AppLogEntryDto
 */
export interface AppLogEntryDto {
    /**
     * 
     * @type {string}
     * @memberof AppLogEntryDto
     */
    'date': string;
}
/**
 * 
 * @export
 * @interface AppLogsCreateDto
 */
export interface AppLogsCreateDto {
    /**
     * 
     * @type {Array<AppLogEntryDto>}
     * @memberof AppLogsCreateDto
     */
    'logs': Array<AppLogEntryDto>;
}
/**
 * 
 * @export
 * @interface AppleAuthCallbackDto
 */
export interface AppleAuthCallbackDto {
    /**
     * 
     * @type {string}
     * @memberof AppleAuthCallbackDto
     */
    'id_token'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppleAuthCallbackDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof AppleAuthCallbackDto
     */
    'state'?: string;
    /**
     * 
     * @type {object}
     * @memberof AppleAuthCallbackDto
     */
    'user'?: object;
}
/**
 * 
 * @export
 * @interface AuthTokensDto
 */
export interface AuthTokensDto {
    /**
     * 
     * @type {string}
     * @memberof AuthTokensDto
     */
    'refreshToken': string;
    /**
     * 
     * @type {string}
     * @memberof AuthTokensDto
     */
    'accessToken': string;
    /**
     * 
     * @type {boolean}
     * @memberof AuthTokensDto
     */
    'newUser': boolean;
}
/**
 * 
 * @export
 * @interface BaseRehashDto
 */
export interface BaseRehashDto {
    /**
     * 
     * @type {RehashType}
     * @memberof BaseRehashDto
     */
    'type': RehashType;
    /**
     * Title of the screen
     * @type {string}
     * @memberof BaseRehashDto
     */
    'title': string;
    /**
     * Subtitle or additional information
     * @type {string}
     * @memberof BaseRehashDto
     */
    'subtitle'?: string;
    /**
     * Wether information can be shared or not
     * @type {boolean}
     * @memberof BaseRehashDto
     */
    'shareable': boolean;
}


/**
 * 
 * @export
 * @interface CheckboxUi
 */
export interface CheckboxUi {
    /**
     * 
     * @type {string}
     * @memberof CheckboxUi
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof CheckboxUi
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckboxUi
     */
    'tag'?: string;
    /**
     * 
     * @type {UiType}
     * @memberof CheckboxUi
     */
    'type': UiType;
    /**
     * 
     * @type {number}
     * @memberof CheckboxUi
     */
    'default': CheckboxUiDefaultEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum CheckboxUiDefaultEnum {
    NUMBER_0 = 0,
    NUMBER_1 = 1
}

/**
 * 
 * @export
 * @interface ColorLight
 */
export interface ColorLight {
    /**
     * 
     * @type {string}
     * @memberof ColorLight
     */
    'color': string;
}
/**
 * 
 * @export
 * @interface ColorPickerUi
 */
export interface ColorPickerUi {
    /**
     * 
     * @type {string}
     * @memberof ColorPickerUi
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof ColorPickerUi
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof ColorPickerUi
     */
    'tag'?: string;
    /**
     * 
     * @type {UiType}
     * @memberof ColorPickerUi
     */
    'type': UiType;
    /**
     * 
     * @type {number}
     * @memberof ColorPickerUi
     */
    'min': number;
    /**
     * 
     * @type {number}
     * @memberof ColorPickerUi
     */
    'max': number;
    /**
     * 
     * @type {string}
     * @memberof ColorPickerUi
     */
    'default': string;
    /**
     * 
     * @type {{ [key: string]: ColorPickerUiColorLabelsValue; }}
     * @memberof ColorPickerUi
     */
    'colorLabels'?: { [key: string]: ColorPickerUiColorLabelsValue; };
}


/**
 * @type ColorPickerUiColorLabelsValue
 * @export
 */
export type ColorPickerUiColorLabelsValue = Array<string> | { [key: string]: Array<string>; };

/**
 * 
 * @export
 * @interface CommunityDabsDto
 */
export interface CommunityDabsDto {
    /**
     * 
     * @type {RehashType}
     * @memberof CommunityDabsDto
     */
    'type': RehashType;
    /**
     * Title of the screen
     * @type {string}
     * @memberof CommunityDabsDto
     */
    'title': string;
    /**
     * Subtitle or additional information
     * @type {string}
     * @memberof CommunityDabsDto
     */
    'subtitle'?: string;
    /**
     * Wether information can be shared or not
     * @type {boolean}
     * @memberof CommunityDabsDto
     */
    'shareable': boolean;
    /**
     * Count of dabs
     * @type {number}
     * @memberof CommunityDabsDto
     */
    'dabCount': number;
    /**
     * User’s rank based on dabs
     * @type {number}
     * @memberof CommunityDabsDto
     */
    'rank': number;
}


/**
 * 
 * @export
 * @interface CommunityMoodlightRuntimeDto
 */
export interface CommunityMoodlightRuntimeDto {
    /**
     * 
     * @type {RehashType}
     * @memberof CommunityMoodlightRuntimeDto
     */
    'type': RehashType;
    /**
     * Title of the screen
     * @type {string}
     * @memberof CommunityMoodlightRuntimeDto
     */
    'title': string;
    /**
     * Subtitle or additional information
     * @type {string}
     * @memberof CommunityMoodlightRuntimeDto
     */
    'subtitle'?: string;
    /**
     * Wether information can be shared or not
     * @type {boolean}
     * @memberof CommunityMoodlightRuntimeDto
     */
    'shareable': boolean;
    /**
     * Total duration of community moodlight usage
     * @type {number}
     * @memberof CommunityMoodlightRuntimeDto
     */
    'duration': number;
    /**
     * Unit of duration
     * @type {string}
     * @memberof CommunityMoodlightRuntimeDto
     */
    'unit': string;
}


/**
 * 
 * @export
 * @interface ContextDto
 */
export interface ContextDto {
    /**
     * Enabled features
     * @type {{ [key: string]: Feature; }}
     * @memberof ContextDto
     */
    'features': { [key: string]: Feature; };
}
/**
 * 
 * @export
 * @interface CreateSupportTicketDto
 */
export interface CreateSupportTicketDto {
    /**
     * 
     * @type {Request}
     * @memberof CreateSupportTicketDto
     */
    'request': Request;
    /**
     * 
     * @type {Array<CreateSupportTicketDtoCustomFieldsInner>}
     * @memberof CreateSupportTicketDto
     */
    'customFields': Array<CreateSupportTicketDtoCustomFieldsInner>;
    /**
     * 
     * @type {string}
     * @memberof CreateSupportTicketDto
     */
    'token'?: string;
}
/**
 * 
 * @export
 * @interface CreateSupportTicketDtoCustomFieldsInner
 */
export interface CreateSupportTicketDtoCustomFieldsInner {
    /**
     * 
     * @type {CreateSupportTicketDtoCustomFieldsInnerId}
     * @memberof CreateSupportTicketDtoCustomFieldsInner
     */
    'id'?: CreateSupportTicketDtoCustomFieldsInnerId;
    /**
     * 
     * @type {CreateSupportTicketDtoCustomFieldsInnerId}
     * @memberof CreateSupportTicketDtoCustomFieldsInner
     */
    'value'?: CreateSupportTicketDtoCustomFieldsInnerId;
}
/**
 * @type CreateSupportTicketDtoCustomFieldsInnerId
 * @export
 */
export type CreateSupportTicketDtoCustomFieldsInnerId = number | string;

/**
 * 
 * @export
 * @interface DabHistoryCreateDto
 */
export interface DabHistoryCreateDto {
    /**
     * 
     * @type {string}
     * @memberof DabHistoryCreateDto
     */
    'peakDeviceSerialNumber'?: string;
    /**
     * 
     * @type {Array<DabHistoryCreateDtoDataInner>}
     * @memberof DabHistoryCreateDto
     */
    'data': Array<DabHistoryCreateDtoDataInner>;
}
/**
 * @type DabHistoryCreateDtoDataInner
 * @export
 */
export type DabHistoryCreateDtoDataInner = DabHistoryDataDto | DabHistoryMoodLightDataDto;

/**
 * 
 * @export
 * @interface DabHistoryDataDto
 */
export interface DabHistoryDataDto {
    /**
     * 
     * @type {string}
     * @memberof DabHistoryDataDto
     */
    'dabAt': string;
    /**
     * 
     * @type {number}
     * @memberof DabHistoryDataDto
     */
    'duration': number;
    /**
     * 
     * @type {number}
     * @memberof DabHistoryDataDto
     */
    'temperature': number;
}
/**
 * 
 * @export
 * @interface DabHistoryMoodLightDataDto
 */
export interface DabHistoryMoodLightDataDto {
    /**
     * 
     * @type {string}
     * @memberof DabHistoryMoodLightDataDto
     */
    'moodLightIdHex': string;
    /**
     * 
     * @type {string}
     * @memberof DabHistoryMoodLightDataDto
     */
    'dabEnd': string;
}
/**
 * 
 * @export
 * @interface DabSummaryDabHistoryDto
 */
export interface DabSummaryDabHistoryDto {
    /**
     * 
     * @type {string}
     * @memberof DabSummaryDabHistoryDto
     */
    'dateTimeStr': string;
    /**
     * 
     * @type {number}
     * @memberof DabSummaryDabHistoryDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof DabSummaryDabHistoryDto
     */
    'totalDuration': number;
}
/**
 * 
 * @export
 * @interface DabSummaryGetDto
 */
export interface DabSummaryGetDto {
    /**
     * 
     * @type {number}
     * @memberof DabSummaryGetDto
     */
    'totalHits': number;
    /**
     * 
     * @type {Array<DabSummaryDabHistoryDto>}
     * @memberof DabSummaryGetDto
     */
    'dabHistory': Array<DabSummaryDabHistoryDto>;
    /**
     * 
     * @type {number}
     * @memberof DabSummaryGetDto
     */
    'durationSummaryAvg': number;
    /**
     * 
     * @type {string}
     * @memberof DabSummaryGetDto
     */
    'temperatureSummaryMode'?: string;
    /**
     * 
     * @type {MoodLight}
     * @memberof DabSummaryGetDto
     */
    'popularMoodLight'?: MoodLight;
    /**
     * 
     * @type {MoodLightDto}
     * @memberof DabSummaryGetDto
     */
    'moodLight'?: MoodLightDto;
    /**
     * 
     * @type {number}
     * @memberof DabSummaryGetDto
     */
    'peakCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof DabSummaryGetDto
     */
    'hasDabHistory': boolean;
}
/**
 * 
 * @export
 * @interface DateRangeType
 */
export interface DateRangeType {
    /**
     * 
     * @type {number}
     * @memberof DateRangeType
     */
    'startYear': number;
    /**
     * 
     * @type {number}
     * @memberof DateRangeType
     */
    'startWeek': number;
    /**
     * 
     * @type {number}
     * @memberof DateRangeType
     */
    'startSequence': number;
    /**
     * 
     * @type {number}
     * @memberof DateRangeType
     */
    'endYear': number;
    /**
     * 
     * @type {number}
     * @memberof DateRangeType
     */
    'endWeek': number;
    /**
     * 
     * @type {number}
     * @memberof DateRangeType
     */
    'endSequence': number;
}
/**
 * 
 * @export
 * @interface DeviceLogDto
 */
export interface DeviceLogDto {
    /**
     * 
     * @type {DeviceLogType}
     * @memberof DeviceLogDto
     */
    'type': DeviceLogType;
    /**
     * 
     * @type {number}
     * @memberof DeviceLogDto
     */
    'code'?: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceLogDto
     */
    'offset': number;
    /**
     * 
     * @type {string}
     * @memberof DeviceLogDto
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceLogDto
     */
    'timestamp': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceLogDto
     */
    'details': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum DeviceLogType {
    Audit = 'audit',
    Fault = 'fault'
}


/**
 * 
 * @export
 * @interface EmailDto
 */
export interface EmailDto {
    /**
     * 
     * @type {string}
     * @memberof EmailDto
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface ExclusiveMoodLightCreateDto
 */
export interface ExclusiveMoodLightCreateDto {
    /**
     * 
     * @type {string}
     * @memberof ExclusiveMoodLightCreateDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ExclusiveMoodLightCreateDto
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof ExclusiveMoodLightCreateDto
     */
    'active'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExclusiveMoodLightCreateDto
     */
    'models'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ExclusiveMoodLightCreateDto
     */
    'fullScreenImageUrl': string;
    /**
     * 
     * @type {string}
     * @memberof ExclusiveMoodLightCreateDto
     */
    'cardImageUrl': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExclusiveMoodLightCreateDto
     */
    'colors': Array<string>;
    /**
     * 
     * @type {object}
     * @memberof ExclusiveMoodLightCreateDto
     */
    'projector': object;
}
/**
 * 
 * @export
 * @interface ExclusiveMoodLightDto
 */
export interface ExclusiveMoodLightDto {
    /**
     * 
     * @type {string}
     * @memberof ExclusiveMoodLightDto
     */
    'tableColor': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExclusiveMoodLightDto
     */
    'colors': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExclusiveMoodLightDto
     */
    'colorArray': Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ExclusiveMoodLightDto
     */
    'offsetArray': Array<number>;
    /**
     * 
     * @type {Array<MoodAnimationJson>}
     * @memberof ExclusiveMoodLightDto
     */
    'animationArray'?: Array<MoodAnimationJson>;
    /**
     * 
     * @type {string}
     * @memberof ExclusiveMoodLightDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ExclusiveMoodLightDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ExclusiveMoodLightDto
     */
    'description': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExclusiveMoodLightDto
     */
    'models'?: Array<string>;
    /**
     * 
     * @type {MediaDto}
     * @memberof ExclusiveMoodLightDto
     */
    'fullscreenMedia': MediaDto;
    /**
     * 
     * @type {MediaDto}
     * @memberof ExclusiveMoodLightDto
     */
    'cardMedia': MediaDto;
}
/**
 * 
 * @export
 * @interface FavoriteDabTimeDto
 */
export interface FavoriteDabTimeDto {
    /**
     * 
     * @type {RehashType}
     * @memberof FavoriteDabTimeDto
     */
    'type': RehashType;
    /**
     * Title of the screen
     * @type {string}
     * @memberof FavoriteDabTimeDto
     */
    'title': string;
    /**
     * Subtitle or additional information
     * @type {string}
     * @memberof FavoriteDabTimeDto
     */
    'subtitle'?: string;
    /**
     * Wether information can be shared or not
     * @type {boolean}
     * @memberof FavoriteDabTimeDto
     */
    'shareable': boolean;
    /**
     * 
     * @type {TimeSlug}
     * @memberof FavoriteDabTimeDto
     */
    'slug': TimeSlug;
    /**
     * This percentage of all dabs were made at this time
     * @type {number}
     * @memberof FavoriteDabTimeDto
     */
    'percentage': number;
}


/**
 * 
 * @export
 * @interface FavoriteDeviceDto
 */
export interface FavoriteDeviceDto {
    /**
     * 
     * @type {RehashType}
     * @memberof FavoriteDeviceDto
     */
    'type': RehashType;
    /**
     * Title of the screen
     * @type {string}
     * @memberof FavoriteDeviceDto
     */
    'title': string;
    /**
     * Subtitle or additional information
     * @type {string}
     * @memberof FavoriteDeviceDto
     */
    'subtitle'?: string;
    /**
     * Wether information can be shared or not
     * @type {boolean}
     * @memberof FavoriteDeviceDto
     */
    'shareable': boolean;
    /**
     * Count of dabs
     * @type {number}
     * @memberof FavoriteDeviceDto
     */
    'dabCount': number;
    /**
     * Device name
     * @type {string}
     * @memberof FavoriteDeviceDto
     */
    'deviceName': string;
    /**
     * Device product
     * @type {string}
     * @memberof FavoriteDeviceDto
     */
    'deviceModel': string;
}


/**
 * 
 * @export
 * @interface FavoriteMoodlightDto
 */
export interface FavoriteMoodlightDto {
    /**
     * 
     * @type {RehashType}
     * @memberof FavoriteMoodlightDto
     */
    'type': RehashType;
    /**
     * Title of the screen
     * @type {string}
     * @memberof FavoriteMoodlightDto
     */
    'title': string;
    /**
     * Subtitle or additional information
     * @type {string}
     * @memberof FavoriteMoodlightDto
     */
    'subtitle'?: string;
    /**
     * Wether information can be shared or not
     * @type {boolean}
     * @memberof FavoriteMoodlightDto
     */
    'shareable': boolean;
    /**
     * Count of dabs
     * @type {number}
     * @memberof FavoriteMoodlightDto
     */
    'dabCount': number;
    /**
     * Moodlight id
     * @type {string}
     * @memberof FavoriteMoodlightDto
     */
    'moodLightId': string;
    /**
     * Moodlight name
     * @type {string}
     * @memberof FavoriteMoodlightDto
     */
    'moodlightName': string;
    /**
     * Array of moodlight colors
     * @type {Array<string>}
     * @memberof FavoriteMoodlightDto
     */
    'moodlightColors': Array<string>;
}


/**
 * 
 * @export
 * @interface Feature
 */
export interface Feature {
    /**
     * Feature options
     * @type {string}
     * @memberof Feature
     */
    'label'?: string;
}
/**
 * 
 * @export
 * @interface GeolocationCountryDto
 */
export interface GeolocationCountryDto {
    /**
     * 
     * @type {string}
     * @memberof GeolocationCountryDto
     */
    'ipcountry': string;
}
/**
 * 
 * @export
 * @interface GetHeatProfilesResponse
 */
export interface GetHeatProfilesResponse {
    /**
     * 
     * @type {Array<HeatProfileDtoV1>}
     * @memberof GetHeatProfilesResponse
     */
    'items': Array<HeatProfileDtoV1>;
}
/**
 * 
 * @export
 * @interface GetMoodLightsResponse
 */
export interface GetMoodLightsResponse {
    /**
     * 
     * @type {Array<MoodLightDto>}
     * @memberof GetMoodLightsResponse
     */
    'items': Array<MoodLightDto>;
    /**
     * 
     * @type {number}
     * @memberof GetMoodLightsResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof GetMoodLightsResponse
     */
    'size': number;
    /**
     * 
     * @type {boolean}
     * @memberof GetMoodLightsResponse
     */
    'more': boolean;
}
/**
 * 
 * @export
 * @interface GetRehash200Response
 */
export interface GetRehash200Response {
    /**
     * 
     * @type {Array<GetRehash200ResponseItemsInner>}
     * @memberof GetRehash200Response
     */
    'items': Array<GetRehash200ResponseItemsInner>;
}
/**
 * @type GetRehash200ResponseItemsInner
 * @export
 */
export type GetRehash200ResponseItemsInner = BaseRehashDto | CommunityDabsDto | CommunityMoodlightRuntimeDto | FavoriteDabTimeDto | FavoriteDeviceDto | FavoriteMoodlightDto | UserDabsDto | ViralMoodlightDto;

/**
 * @type GetUserByIdIdParameter
 * @export
 */
export type GetUserByIdIdParameter = number | string;

/**
 * 
 * @export
 * @interface HeatProfileCreateShareDto
 */
export interface HeatProfileCreateShareDto {
    /**
     * 
     * @type {string}
     * @memberof HeatProfileCreateShareDto
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface HeatProfileDtoV1
 */
export interface HeatProfileDtoV1 {
    /**
     * 
     * @type {string}
     * @memberof HeatProfileDtoV1
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof HeatProfileDtoV1
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof HeatProfileDtoV1
     */
    'temperature': number;
    /**
     * 
     * @type {TemperatureUnit}
     * @memberof HeatProfileDtoV1
     */
    'units': TemperatureUnit;
    /**
     * 
     * @type {number}
     * @memberof HeatProfileDtoV1
     */
    'duration': number;
    /**
     * 
     * @type {ProfileVersion}
     * @memberof HeatProfileDtoV1
     */
    'version': ProfileVersion;
    /**
     * 
     * @type {number}
     * @memberof HeatProfileDtoV1
     */
    'vaporSetting'?: number;
    /**
     * 
     * @type {number}
     * @memberof HeatProfileDtoV1
     */
    'order': number;
    /**
     * 
     * @type {object}
     * @memberof HeatProfileDtoV1
     */
    'user'?: object;
    /**
     * 
     * @type {number}
     * @memberof HeatProfileDtoV1
     */
    'lighting'?: number;
    /**
     * 
     * @type {string}
     * @memberof HeatProfileDtoV1
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof HeatProfileDtoV1
     */
    'modified': string;
    /**
     * 
     * @type {HeatProfileDtoV1Light}
     * @memberof HeatProfileDtoV1
     */
    'light': HeatProfileDtoV1Light;
}


/**
 * @type HeatProfileDtoV1Light
 * @export
 */
export type HeatProfileDtoV1Light = ColorLight | MoodLightDto;

/**
 * 
 * @export
 * @interface HeatProfileShareResultDto
 */
export interface HeatProfileShareResultDto {
    /**
     * 
     * @type {string}
     * @memberof HeatProfileShareResultDto
     */
    'shareId': string;
}
/**
 * 
 * @export
 * @interface HeatProfileSnapshotDto
 */
export interface HeatProfileSnapshotDto {
    /**
     * 
     * @type {string}
     * @memberof HeatProfileSnapshotDto
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof HeatProfileSnapshotDto
     */
    'temperature': number;
    /**
     * 
     * @type {number}
     * @memberof HeatProfileSnapshotDto
     */
    'duration': number;
    /**
     * 
     * @type {string}
     * @memberof HeatProfileSnapshotDto
     */
    'color': string;
    /**
     * 
     * @type {TemperatureUnit}
     * @memberof HeatProfileSnapshotDto
     */
    'units': TemperatureUnit;
    /**
     * 
     * @type {ProfileVersion}
     * @memberof HeatProfileSnapshotDto
     */
    'version': ProfileVersion;
    /**
     * 
     * @type {number}
     * @memberof HeatProfileSnapshotDto
     */
    'vaporSetting'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof HeatProfileSnapshotDto
     */
    'isMoodLight'?: boolean;
    /**
     * 
     * @type {MoodLightDto}
     * @memberof HeatProfileSnapshotDto
     */
    'moodLight'?: MoodLightDto;
}


/**
 * 
 * @export
 * @interface HeatProfileUpdateDto
 */
export interface HeatProfileUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof HeatProfileUpdateDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof HeatProfileUpdateDto
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof HeatProfileUpdateDto
     */
    'temperature'?: number;
    /**
     * 
     * @type {TemperatureUnit}
     * @memberof HeatProfileUpdateDto
     */
    'units'?: TemperatureUnit;
    /**
     * 
     * @type {number}
     * @memberof HeatProfileUpdateDto
     */
    'duration'?: number;
    /**
     * 
     * @type {number}
     * @memberof HeatProfileUpdateDto
     */
    'vaporSetting'?: number;
    /**
     * 
     * @type {string}
     * @memberof HeatProfileUpdateDto
     */
    'color'?: string;
    /**
     * 
     * @type {number}
     * @memberof HeatProfileUpdateDto
     */
    'lighting'?: number;
    /**
     * 
     * @type {number}
     * @memberof HeatProfileUpdateDto
     */
    'order'?: number;
    /**
     * 
     * @type {number}
     * @memberof HeatProfileUpdateDto
     */
    'userId': number;
    /**
     * 
     * @type {boolean}
     * @memberof HeatProfileUpdateDto
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HeatProfileUpdateDto
     */
    'shareId'?: string;
    /**
     * 
     * @type {number}
     * @memberof HeatProfileUpdateDto
     */
    'modified'?: number;
    /**
     * 
     * @type {string}
     * @memberof HeatProfileUpdateDto
     */
    'version'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HeatProfileUpdateDto
     */
    'isMoodLight'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HeatProfileUpdateDto
     */
    'moodLightId'?: string;
    /**
     * 
     * @type {MoodLightCreateDto}
     * @memberof HeatProfileUpdateDto
     */
    'moodLight'?: MoodLightCreateDto;
}


/**
 * 
 * @export
 * @interface Interstitial
 */
export interface Interstitial {
    /**
     * 
     * @type {number}
     * @memberof Interstitial
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Interstitial
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof Interstitial
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof Interstitial
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof Interstitial
     */
    'endDate': string;
    /**
     * 
     * @type {string}
     * @memberof Interstitial
     */
    'minVersion'?: string;
    /**
     * 
     * @type {string}
     * @memberof Interstitial
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof Interstitial
     */
    'modified': string;
}
/**
 * 
 * @export
 * @interface InterstitialActiveResultDto
 */
export interface InterstitialActiveResultDto {
    /**
     * 
     * @type {number}
     * @memberof InterstitialActiveResultDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof InterstitialActiveResultDto
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface InterstitialCreateDto
 */
export interface InterstitialCreateDto {
    /**
     * 
     * @type {string}
     * @memberof InterstitialCreateDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof InterstitialCreateDto
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof InterstitialCreateDto
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof InterstitialCreateDto
     */
    'endDate': string;
}
/**
 * 
 * @export
 * @interface InterstitialUpdateDto
 */
export interface InterstitialUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof InterstitialUpdateDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof InterstitialUpdateDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof InterstitialUpdateDto
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof InterstitialUpdateDto
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof InterstitialUpdateDto
     */
    'endDate': string;
}
/**
 * 
 * @export
 * @interface KeyReference
 */
export interface KeyReference {
    /**
     * 
     * @type {string}
     * @memberof KeyReference
     */
    '_key': string;
    /**
     * 
     * @type {string}
     * @memberof KeyReference
     */
    '_format'?: string;
}
/**
 * 
 * @export
 * @interface Lamp
 */
export interface Lamp {
    /**
     * 
     * @type {string}
     * @memberof Lamp
     */
    'name': string;
    /**
     * 
     * @type {LampParam}
     * @memberof Lamp
     */
    'param': LampParam;
}
/**
 * 
 * @export
 * @interface LampParam
 */
export interface LampParam {
    [key: string]: any;

    /**
     * 
     * @type {LampParamBright}
     * @memberof LampParam
     */
    'bright'?: LampParamBright;
    /**
     * 
     * @type {LampParamBright}
     * @memberof LampParam
     */
    'speed'?: LampParamBright;
    /**
     * 
     * @type {number}
     * @memberof LampParam
     */
    'anim'?: number;
    /**
     * 
     * @type {LampParamBright}
     * @memberof LampParam
     */
    'plNum'?: LampParamBright;
    /**
     * 
     * @type {LampParamBright}
     * @memberof LampParam
     */
    'plDenom'?: LampParamBright;
    /**
     * 
     * @type {LampParamOffset}
     * @memberof LampParam
     */
    'offset'?: LampParamOffset;
    /**
     * 
     * @type {LampParamOffset}
     * @memberof LampParam
     */
    'color'?: LampParamOffset;
    /**
     * 
     * @type {LampParamBright}
     * @memberof LampParam
     */
    'colorLen'?: LampParamBright;
}
/**
 * @type LampParamBright
 * @export
 */
export type LampParamBright = KeyReference | number;

/**
 * @type LampParamOffset
 * @export
 */
export type LampParamOffset = Array<number> | KeyReference;

/**
 * 
 * @export
 * @interface Led3MetaDto
 */
export interface Led3MetaDto {
    /**
     * 
     * @type {string}
     * @memberof Led3MetaDto
     */
    'name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Led3MetaDto
     */
    'userColors': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof Led3MetaDto
     */
    'tempoFrac'?: number;
    /**
     * 
     * @type {number}
     * @memberof Led3MetaDto
     */
    'dynamicInhale'?: number;
}
/**
 * 
 * @export
 * @interface LedApi3LightDto
 */
export interface LedApi3LightDto {
    /**
     * 
     * @type {string}
     * @memberof LedApi3LightDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof LedApi3LightDto
     */
    'desc': string;
    /**
     * 
     * @type {string}
     * @memberof LedApi3LightDto
     */
    'tag'?: string;
    /**
     * 
     * @type {LedApi3LightDtoAssets}
     * @memberof LedApi3LightDto
     */
    'assets': LedApi3LightDtoAssets;
    /**
     * 
     * @type {Array<LedApi3LightDtoUiInner>}
     * @memberof LedApi3LightDto
     */
    'ui': Array<LedApi3LightDtoUiInner>;
    /**
     * 
     * @type {object}
     * @memberof LedApi3LightDto
     */
    'mappings': object;
    /**
     * 
     * @type {Projector}
     * @memberof LedApi3LightDto
     */
    'projector': Projector;
}
/**
 * 
 * @export
 * @interface LedApi3LightDtoAssets
 */
export interface LedApi3LightDtoAssets {
    /**
     * 
     * @type {Array<object>}
     * @memberof LedApi3LightDtoAssets
     */
    'lamps'?: Array<object>;
    /**
     * 
     * @type {string}
     * @memberof LedApi3LightDtoAssets
     */
    'card'?: string;
    /**
     * 
     * @type {string}
     * @memberof LedApi3LightDtoAssets
     */
    'background'?: string;
}
/**
 * @type LedApi3LightDtoUiInner
 * @export
 */
export type LedApi3LightDtoUiInner = CheckboxUi | ColorPickerUi | MenuUi | SliderUi;

/**
 * 
 * @export
 * @interface LegacyAppLogsCreateDto
 */
export interface LegacyAppLogsCreateDto {
    /**
     * 
     * @type {string}
     * @memberof LegacyAppLogsCreateDto
     */
    'deviceSerialNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyAppLogsCreateDto
     */
    'platform'?: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyAppLogsCreateDto
     */
    'userAgent'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LegacyAppLogsCreateDto
     */
    'logsArray'?: Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum MarketOptIn {
    Email = 'Email',
    Phone = 'Phone',
    All = 'All'
}


/**
 * 
 * @export
 * @interface MediaCreateDto
 */
export interface MediaCreateDto {
    /**
     * 
     * @type {string}
     * @memberof MediaCreateDto
     */
    'filename': string;
    /**
     * 
     * @type {string}
     * @memberof MediaCreateDto
     */
    'originalUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaCreateDto
     */
    'smallUrl': string;
    /**
     * 
     * @type {string}
     * @memberof MediaCreateDto
     */
    'mediumUrl': string;
    /**
     * 
     * @type {string}
     * @memberof MediaCreateDto
     */
    'largeUrl': string;
}
/**
 * 
 * @export
 * @interface MediaDto
 */
export interface MediaDto {
    /**
     * 
     * @type {number}
     * @memberof MediaDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof MediaDto
     */
    'filename': string;
    /**
     * 
     * @type {string}
     * @memberof MediaDto
     */
    'originalUrl': string;
    /**
     * 
     * @type {string}
     * @memberof MediaDto
     */
    'smallUrl': string;
    /**
     * 
     * @type {string}
     * @memberof MediaDto
     */
    'mediumUrl': string;
    /**
     * 
     * @type {string}
     * @memberof MediaDto
     */
    'largeUrl': string;
    /**
     * 
     * @type {string}
     * @memberof MediaDto
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof MediaDto
     */
    'modified': string;
}
/**
 * 
 * @export
 * @interface MediaUpdateDto
 */
export interface MediaUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof MediaUpdateDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof MediaUpdateDto
     */
    'filename'?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaUpdateDto
     */
    'originalUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaUpdateDto
     */
    'smallUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaUpdateDto
     */
    'mediumUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaUpdateDto
     */
    'largeUrl'?: string;
}
/**
 * 
 * @export
 * @interface MediaUploadResponseDto
 */
export interface MediaUploadResponseDto {
    /**
     * 
     * @type {string}
     * @memberof MediaUploadResponseDto
     */
    'path': string;
}
/**
 * 
 * @export
 * @interface MenuUi
 */
export interface MenuUi {
    /**
     * 
     * @type {string}
     * @memberof MenuUi
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof MenuUi
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuUi
     */
    'tag'?: string;
    /**
     * 
     * @type {UiType}
     * @memberof MenuUi
     */
    'type': UiType;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof MenuUi
     */
    'encoding'?: { [key: string]: string; };
    /**
     * 
     * @type {number}
     * @memberof MenuUi
     */
    'default': number;
    /**
     * 
     * @type {string}
     * @memberof MenuUi
     */
    'group'?: string;
}


/**
 * 
 * @export
 * @interface MessageCreateDto
 */
export interface MessageCreateDto {
    /**
     * 
     * @type {string}
     * @memberof MessageCreateDto
     */
    'content': string;
}
/**
 * 
 * @export
 * @interface MessageDto
 */
export interface MessageDto {
    /**
     * 
     * @type {number}
     * @memberof MessageDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof MessageDto
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof MessageDto
     */
    'created': string;
}
/**
 * 
 * @export
 * @interface MoodAnimationJson
 */
export interface MoodAnimationJson {
    /**
     * 
     * @type {number}
     * @memberof MoodAnimationJson
     */
    'time': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof MoodAnimationJson
     */
    'luma': Array<number>;
}
/**
 * 
 * @export
 * @interface MoodLight
 */
export interface MoodLight {
    /**
     * 
     * @type {string}
     * @memberof MoodLight
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MoodLight
     */
    'name': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MoodLight
     */
    'colors': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof MoodLight
     */
    'type': number;
    /**
     * 
     * @type {number}
     * @memberof MoodLight
     */
    'tempo': number;
    /**
     * 
     * @type {Led3MetaDto}
     * @memberof MoodLight
     */
    'led3Meta'?: Led3MetaDto;
    /**
     * 
     * @type {MoodLightCategory}
     * @memberof MoodLight
     */
    'category': MoodLightCategory;
    /**
     * 
     * @type {string}
     * @memberof MoodLight
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof MoodLight
     */
    'modified': string;
    /**
     * 
     * @type {number}
     * @memberof MoodLight
     */
    'userId': number;
    /**
     * 
     * @type {UserGetResponseDto}
     * @memberof MoodLight
     */
    'user': UserGetResponseDto;
    /**
     * 
     * @type {string}
     * @memberof MoodLight
     */
    'originalMoodLightId': string;
    /**
     * 
     * @type {boolean}
     * @memberof MoodLight
     */
    'isDeleted': boolean;
    /**
     * 
     * @type {string}
     * @memberof MoodLight
     */
    'idHex'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum MoodLightCategory {
    Custom = 'custom',
    Exclusive = 'exclusive'
}


/**
 * 
 * @export
 * @interface MoodLightCreateDto
 */
export interface MoodLightCreateDto {
    /**
     * 
     * @type {string}
     * @memberof MoodLightCreateDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MoodLightCreateDto
     */
    'name': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MoodLightCreateDto
     */
    'colors': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof MoodLightCreateDto
     */
    'type': number;
    /**
     * 
     * @type {number}
     * @memberof MoodLightCreateDto
     */
    'tempo': number;
    /**
     * 
     * @type {Led3MetaDto}
     * @memberof MoodLightCreateDto
     */
    'led3Meta'?: Led3MetaDto;
    /**
     * 
     * @type {MoodLightCategory}
     * @memberof MoodLightCreateDto
     */
    'category': MoodLightCategory;
    /**
     * 
     * @type {string}
     * @memberof MoodLightCreateDto
     */
    'originalMoodLightId': string;
    /**
     * 
     * @type {number}
     * @memberof MoodLightCreateDto
     */
    'userId'?: number;
}


/**
 * 
 * @export
 * @interface MoodLightCreateShareDto
 */
export interface MoodLightCreateShareDto {
    /**
     * 
     * @type {string}
     * @memberof MoodLightCreateShareDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MoodLightCreateShareDto
     */
    'name': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MoodLightCreateShareDto
     */
    'colors': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof MoodLightCreateShareDto
     */
    'type': number;
    /**
     * 
     * @type {number}
     * @memberof MoodLightCreateShareDto
     */
    'tempo': number;
    /**
     * 
     * @type {Led3MetaDto}
     * @memberof MoodLightCreateShareDto
     */
    'led3Meta'?: Led3MetaDto;
    /**
     * 
     * @type {MoodLightCategory}
     * @memberof MoodLightCreateShareDto
     */
    'category': MoodLightCategory;
    /**
     * 
     * @type {string}
     * @memberof MoodLightCreateShareDto
     */
    'originalMoodLightId': string;
    /**
     * 
     * @type {number}
     * @memberof MoodLightCreateShareDto
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof MoodLightCreateShareDto
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof MoodLightCreateShareDto
     */
    'modified'?: string;
}


/**
 * 
 * @export
 * @interface MoodLightCreatorUsernamesDto
 */
export interface MoodLightCreatorUsernamesDto {
    /**
     * 
     * @type {string}
     * @memberof MoodLightCreatorUsernamesDto
     */
    'moodLightId': string;
    /**
     * 
     * @type {string}
     * @memberof MoodLightCreatorUsernamesDto
     */
    'username': string;
}
/**
 * 
 * @export
 * @interface MoodLightDto
 */
export interface MoodLightDto {
    /**
     * 
     * @type {string}
     * @memberof MoodLightDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MoodLightDto
     */
    'desc': string;
    /**
     * 
     * @type {string}
     * @memberof MoodLightDto
     */
    'tag'?: string;
    /**
     * 
     * @type {LedApi3LightDtoAssets}
     * @memberof MoodLightDto
     */
    'assets': LedApi3LightDtoAssets;
    /**
     * 
     * @type {Array<LedApi3LightDtoUiInner>}
     * @memberof MoodLightDto
     */
    'ui': Array<LedApi3LightDtoUiInner>;
    /**
     * 
     * @type {object}
     * @memberof MoodLightDto
     */
    'mappings': object;
    /**
     * 
     * @type {Projector}
     * @memberof MoodLightDto
     */
    'projector': Projector;
    /**
     * 
     * @type {string}
     * @memberof MoodLightDto
     */
    'id': string;
    /**
     * 
     * @type {MoodLightCategory}
     * @memberof MoodLightDto
     */
    'category': MoodLightCategory;
    /**
     * 
     * @type {string}
     * @memberof MoodLightDto
     */
    'format': string;
    /**
     * 
     * @type {string}
     * @memberof MoodLightDto
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof MoodLightDto
     */
    'modified': string;
    /**
     * 
     * @type {MoodLightDtoUser}
     * @memberof MoodLightDto
     */
    'user'?: MoodLightDtoUser;
    /**
     * 
     * @type {Array<string>}
     * @memberof MoodLightDto
     */
    'productCodes'?: Array<string>;
}


/**
 * 
 * @export
 * @interface MoodLightDtoUser
 */
export interface MoodLightDtoUser {
    /**
     * 
     * @type {number}
     * @memberof MoodLightDtoUser
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof MoodLightDtoUser
     */
    'username'?: string;
}
/**
 * 
 * @export
 * @interface MoodLightId
 */
export interface MoodLightId {
    /**
     * 
     * @type {string}
     * @memberof MoodLightId
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface MoodLightShareResultDto
 */
export interface MoodLightShareResultDto {
    /**
     * 
     * @type {string}
     * @memberof MoodLightShareResultDto
     */
    'shareMoodLightId': string;
    /**
     * 
     * @type {string}
     * @memberof MoodLightShareResultDto
     */
    'moodLightName': string;
}
/**
 * 
 * @export
 * @interface MoodLightUpdateDto
 */
export interface MoodLightUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof MoodLightUpdateDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MoodLightUpdateDto
     */
    'name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MoodLightUpdateDto
     */
    'colors'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof MoodLightUpdateDto
     */
    'type'?: number;
    /**
     * 
     * @type {number}
     * @memberof MoodLightUpdateDto
     */
    'tempo'?: number;
    /**
     * 
     * @type {Led3MetaDto}
     * @memberof MoodLightUpdateDto
     */
    'led3Meta'?: Led3MetaDto;
    /**
     * 
     * @type {MoodLightCategory}
     * @memberof MoodLightUpdateDto
     */
    'category'?: MoodLightCategory;
    /**
     * 
     * @type {number}
     * @memberof MoodLightUpdateDto
     */
    'userId': number;
    /**
     * 
     * @type {boolean}
     * @memberof MoodLightUpdateDto
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MoodLightUpdateDto
     */
    'modified'?: string;
    /**
     * 
     * @type {string}
     * @memberof MoodLightUpdateDto
     */
    'originalMoodLightId': string;
}


/**
 * 
 * @export
 * @interface OffsetMaxDto
 */
export interface OffsetMaxDto {
    /**
     * 
     * @type {number}
     * @memberof OffsetMaxDto
     */
    'audit'?: number;
    /**
     * 
     * @type {number}
     * @memberof OffsetMaxDto
     */
    'fault'?: number;
}
/**
 * 
 * @export
 * @interface OtaCreateDto
 */
export interface OtaCreateDto {
    /**
     * 
     * @type {string}
     * @memberof OtaCreateDto
     */
    'releaseNotes'?: string;
    /**
     * 
     * @type {string}
     * @memberof OtaCreateDto
     */
    'version': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OtaCreateDto
     */
    'models'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof OtaCreateDto
     */
    'rolloutPercentage': number;
    /**
     * 
     * @type {Array<DateRangeType>}
     * @memberof OtaCreateDto
     */
    'dateRange'?: Array<DateRangeType>;
    /**
     * 
     * @type {number}
     * @memberof OtaCreateDto
     */
    'supersedes'?: number;
    /**
     * 
     * @type {string}
     * @memberof OtaCreateDto
     */
    'internalNotes'?: string;
    /**
     * 
     * @type {string}
     * @memberof OtaCreateDto
     */
    'filename': string;
    /**
     * 
     * @type {string}
     * @memberof OtaCreateDto
     */
    'originalUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof OtaCreateDto
     */
    'smallUrl': string;
    /**
     * 
     * @type {string}
     * @memberof OtaCreateDto
     */
    'mediumUrl': string;
    /**
     * 
     * @type {string}
     * @memberof OtaCreateDto
     */
    'largeUrl': string;
}
/**
 * 
 * @export
 * @interface OtaDto
 */
export interface OtaDto {
    /**
     * 
     * @type {number}
     * @memberof OtaDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof OtaDto
     */
    'releaseNotes': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OtaDto
     */
    'models': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OtaDto
     */
    'version': string;
    /**
     * 
     * @type {MediaDto}
     * @memberof OtaDto
     */
    'fileMedia': MediaDto;
    /**
     * 
     * @type {number}
     * @memberof OtaDto
     */
    'rolloutPercentage': number;
    /**
     * 
     * @type {number}
     * @memberof OtaDto
     */
    'supersedes': number;
    /**
     * 
     * @type {Array<DateRangeType>}
     * @memberof OtaDto
     */
    'dateRange': Array<DateRangeType>;
    /**
     * 
     * @type {string}
     * @memberof OtaDto
     */
    'internalNotes': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum OtaEvent {
    Started = 'started',
    Succeeded = 'succeeded',
    Failed = 'failed'
}


/**
 * 
 * @export
 * @interface OtaInfoDto
 */
export interface OtaInfoDto {
    /**
     * 
     * @type {number}
     * @memberof OtaInfoDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof OtaInfoDto
     */
    'releaseNotes': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OtaInfoDto
     */
    'models': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OtaInfoDto
     */
    'version': string;
    /**
     * 
     * @type {MediaDto}
     * @memberof OtaInfoDto
     */
    'fileMedia': MediaDto;
    /**
     * 
     * @type {number}
     * @memberof OtaInfoDto
     */
    'rolloutPercentage': number;
    /**
     * 
     * @type {number}
     * @memberof OtaInfoDto
     */
    'supersedes': number;
    /**
     * 
     * @type {Array<DateRangeType>}
     * @memberof OtaInfoDto
     */
    'dateRange': Array<DateRangeType>;
    /**
     * 
     * @type {string}
     * @memberof OtaInfoDto
     */
    'internalNotes': string;
    /**
     * 
     * @type {OtaTrackingInfo}
     * @memberof OtaInfoDto
     */
    'otaTracking': OtaTrackingInfo;
}
/**
 * 
 * @export
 * @interface OtaLatestGetResponse
 */
export interface OtaLatestGetResponse {
    /**
     * 
     * @type {number}
     * @memberof OtaLatestGetResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof OtaLatestGetResponse
     */
    'releaseNotes': string;
    /**
     * 
     * @type {string}
     * @memberof OtaLatestGetResponse
     */
    'version': string;
    /**
     * 
     * @type {MediaDto}
     * @memberof OtaLatestGetResponse
     */
    'fileMedia': MediaDto;
}
/**
 * 
 * @export
 * @interface OtaTrackingCreateDto
 */
export interface OtaTrackingCreateDto {
    /**
     * 
     * @type {OtaTrackingProperty}
     * @memberof OtaTrackingCreateDto
     */
    'otaTracking': OtaTrackingProperty;
    /**
     * 
     * @type {OtaTrackingDevice}
     * @memberof OtaTrackingCreateDto
     */
    'device': OtaTrackingDevice;
}
/**
 * 
 * @export
 * @interface OtaTrackingDevice
 */
export interface OtaTrackingDevice {
    /**
     * 
     * @type {string}
     * @memberof OtaTrackingDevice
     */
    'serialNumber': string;
}
/**
 * 
 * @export
 * @interface OtaTrackingInfo
 */
export interface OtaTrackingInfo {
    /**
     * 
     * @type {number}
     * @memberof OtaTrackingInfo
     */
    'devicesRollout': number;
    /**
     * 
     * @type {number}
     * @memberof OtaTrackingInfo
     */
    'attempts': number;
    /**
     * 
     * @type {number}
     * @memberof OtaTrackingInfo
     */
    'successes': number;
    /**
     * 
     * @type {number}
     * @memberof OtaTrackingInfo
     */
    'failures': number;
    /**
     * 
     * @type {number}
     * @memberof OtaTrackingInfo
     */
    'devicesRunning': number;
    /**
     * 
     * @type {number}
     * @memberof OtaTrackingInfo
     */
    'devicesTargeted': number;
}
/**
 * 
 * @export
 * @interface OtaTrackingProperty
 */
export interface OtaTrackingProperty {
    /**
     * 
     * @type {number}
     * @memberof OtaTrackingProperty
     */
    'otaId': number;
    /**
     * 
     * @type {OtaEvent}
     * @memberof OtaTrackingProperty
     */
    'event': OtaEvent;
}


/**
 * 
 * @export
 * @interface OtaUpdateDto
 */
export interface OtaUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof OtaUpdateDto
     */
    'releaseNotes'?: string;
    /**
     * 
     * @type {string}
     * @memberof OtaUpdateDto
     */
    'version'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OtaUpdateDto
     */
    'models'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof OtaUpdateDto
     */
    'rolloutPercentage'?: number;
    /**
     * 
     * @type {Array<DateRangeType>}
     * @memberof OtaUpdateDto
     */
    'dateRange'?: Array<DateRangeType>;
    /**
     * 
     * @type {number}
     * @memberof OtaUpdateDto
     */
    'supersedes'?: number;
    /**
     * 
     * @type {string}
     * @memberof OtaUpdateDto
     */
    'internalNotes'?: string;
    /**
     * 
     * @type {string}
     * @memberof OtaUpdateDto
     */
    'filename'?: string;
    /**
     * 
     * @type {string}
     * @memberof OtaUpdateDto
     */
    'originalUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof OtaUpdateDto
     */
    'smallUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof OtaUpdateDto
     */
    'mediumUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof OtaUpdateDto
     */
    'largeUrl'?: string;
}
/**
 * 
 * @export
 * @interface PeakDevice
 */
export interface PeakDevice {
    /**
     * 
     * @type {number}
     * @memberof PeakDevice
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof PeakDevice
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PeakDevice
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PeakDevice
     */
    'serialNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PeakDevice
     */
    'model': string;
    /**
     * 
     * @type {string}
     * @memberof PeakDevice
     */
    'firmware': string;
    /**
     * 
     * @type {string}
     * @memberof PeakDevice
     */
    'dob': string;
    /**
     * 
     * @type {string}
     * @memberof PeakDevice
     */
    'gitHash': string;
    /**
     * 
     * @type {number}
     * @memberof PeakDevice
     */
    'batteryCapacity': number;
    /**
     * 
     * @type {number}
     * @memberof PeakDevice
     */
    'hitCount': number;
    /**
     * 
     * @type {number}
     * @memberof PeakDevice
     */
    'totalRuntime': number;
    /**
     * 
     * @type {number}
     * @memberof PeakDevice
     */
    'lastCleanReminderDabCount': number;
    /**
     * 
     * @type {number}
     * @memberof PeakDevice
     */
    'cleaningReminderDabs': number;
    /**
     * 
     * @type {number}
     * @memberof PeakDevice
     */
    'cleaningReminderLastUpdated': number;
    /**
     * 
     * @type {number}
     * @memberof PeakDevice
     */
    'snoozeDabs': number;
    /**
     * 
     * @type {number}
     * @memberof PeakDevice
     */
    'delay': number;
    /**
     * 
     * @type {string}
     * @memberof PeakDevice
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof PeakDevice
     */
    'modified': string;
}
/**
 * 
 * @export
 * @interface PeakDeviceAppSettingsDto
 */
export interface PeakDeviceAppSettingsDto {
    /**
     * 
     * @type {number}
     * @memberof PeakDeviceAppSettingsDto
     */
    'lastCleanReminderDabCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeakDeviceAppSettingsDto
     */
    'cleaningReminderDabs'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeakDeviceAppSettingsDto
     */
    'snoozeDabs'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeakDeviceAppSettingsDto
     */
    'delay'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeakDeviceAppSettingsDto
     */
    'cleaningReminderLastUpdated'?: number;
}
/**
 * 
 * @export
 * @interface PeakDeviceGetResponseDto
 */
export interface PeakDeviceGetResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PeakDeviceGetResponseDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PeakDeviceGetResponseDto
     */
    'serialNumberString': string;
    /**
     * 
     * @type {string}
     * @memberof PeakDeviceGetResponseDto
     */
    'model'?: string;
    /**
     * 
     * @type {string}
     * @memberof PeakDeviceGetResponseDto
     */
    'firmware'?: string;
    /**
     * 
     * @type {string}
     * @memberof PeakDeviceGetResponseDto
     */
    'gitHash'?: string;
    /**
     * 
     * @type {string}
     * @memberof PeakDeviceGetResponseDto
     */
    'dob'?: string;
    /**
     * 
     * @type {number}
     * @memberof PeakDeviceGetResponseDto
     */
    'batteryCapacity'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeakDeviceGetResponseDto
     */
    'hitCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeakDeviceGetResponseDto
     */
    'totalRuntime'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeakDeviceGetResponseDto
     */
    'userId'?: number;
    /**
     * 
     * @type {PeakDeviceAppSettingsDto}
     * @memberof PeakDeviceGetResponseDto
     */
    'appSettings'?: PeakDeviceAppSettingsDto;
}
/**
 * 
 * @export
 * @interface PeakDeviceIngestLogsDto
 */
export interface PeakDeviceIngestLogsDto {
    /**
     * 
     * @type {string}
     * @memberof PeakDeviceIngestLogsDto
     * @deprecated
     */
    'serialNumber'?: string;
    /**
     * 
     * @type {Array<DeviceLogDto>}
     * @memberof PeakDeviceIngestLogsDto
     */
    'deviceLogs': Array<DeviceLogDto>;
}
/**
 * 
 * @export
 * @interface PeakDeviceUpsertDto
 */
export interface PeakDeviceUpsertDto {
    /**
     * 
     * @type {number}
     * @memberof PeakDeviceUpsertDto
     * @deprecated
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PeakDeviceUpsertDto
     * @deprecated
     */
    'serialNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof PeakDeviceUpsertDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PeakDeviceUpsertDto
     */
    'model': string;
    /**
     * 
     * @type {string}
     * @memberof PeakDeviceUpsertDto
     */
    'firmware': string;
    /**
     * 
     * @type {string}
     * @memberof PeakDeviceUpsertDto
     */
    'gitHash': string;
    /**
     * 
     * @type {string}
     * @memberof PeakDeviceUpsertDto
     */
    'dob': string;
    /**
     * 
     * @type {number}
     * @memberof PeakDeviceUpsertDto
     */
    'batteryCapacity': number;
    /**
     * 
     * @type {number}
     * @memberof PeakDeviceUpsertDto
     */
    'hitCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeakDeviceUpsertDto
     */
    'totalRuntime'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeakDeviceUpsertDto
     */
    'lastCleanReminderDabCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeakDeviceUpsertDto
     */
    'cleaningReminderDabs'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeakDeviceUpsertDto
     */
    'snoozeDabs'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeakDeviceUpsertDto
     */
    'delay'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeakDeviceUpsertDto
     */
    'cleaningReminderLastUpdated'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ProfileVersion {
    PreT = 'Pre-T',
    T = 'T'
}


/**
 * 
 * @export
 * @interface Projector
 */
export interface Projector {
    /**
     * 
     * @type {Lamp}
     * @memberof Projector
     */
    'lamp': Lamp;
    /**
     * 
     * @type {ProjectorMeta}
     * @memberof Projector
     */
    'meta': ProjectorMeta;
}
/**
 * 
 * @export
 * @interface ProjectorMeta
 */
export interface ProjectorMeta {
    [key: string]: ProjectorMetaValue | any;

    /**
     * 
     * @type {number}
     * @memberof ProjectorMeta
     */
    'bgBright'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectorMeta
     */
    'density'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectorMeta
     */
    'dynamicInhale'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectorMeta
     */
    'tempoFrac'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProjectorMeta
     */
    'userColors'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ProjectorMeta
     */
    'moodType'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectorMeta
     */
    'originalMoodLightId'?: string;
}
/**
 * @type ProjectorMetaValue
 * @export
 */
export type ProjectorMetaValue = Array<string> | number | string;

/**
 * 
 * @export
 * @interface ReferraLinkDto
 */
export interface ReferraLinkDto {
    /**
     * 
     * @type {string}
     * @memberof ReferraLinkDto
     */
    'referralLink': string;
}
/**
 * 
 * @export
 * @interface ReferralConfigDto
 */
export interface ReferralConfigDto {
    /**
     * 
     * @type {string}
     * @memberof ReferralConfigDto
     */
    'amount': string;
    /**
     * 
     * @type {string}
     * @memberof ReferralConfigDto
     */
    'cartMinimum': string;
}
/**
 * 
 * @export
 * @interface ReferralDto
 */
export interface ReferralDto {
    /**
     * 
     * @type {string}
     * @memberof ReferralDto
     */
    'code': string;
    /**
     * 
     * @type {boolean}
     * @memberof ReferralDto
     */
    'isUsed': boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum RehashType {
    Intro = 'intro',
    Empty = 'empty',
    UserDabs = 'userDabs',
    FavoriteDevice = 'favoriteDevice',
    FavoriteMoodlight = 'favoriteMoodlight',
    FavoriteDabTime = 'favoriteDabTime',
    CommunityIntro = 'communityIntro',
    CommunityDabs = 'communityDabs',
    CommunityMoodlightRuntime = 'communityMoodlightRuntime',
    ViralMoodlight = 'viralMoodlight',
    Outro = 'outro',
    CreateAccount = 'createAccount'
}


/**
 * 
 * @export
 * @interface Request
 */
export interface Request {
    /**
     * 
     * @type {string}
     * @memberof Request
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof Request
     */
    'deviceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Request
     */
    'subject': string;
    /**
     * 
     * @type {RequestRequester}
     * @memberof Request
     */
    'requester': RequestRequester;
}
/**
 * 
 * @export
 * @interface RequestRequester
 */
export interface RequestRequester {
    /**
     * 
     * @type {string}
     * @memberof RequestRequester
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestRequester
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface ResetPasswordDto
 */
export interface ResetPasswordDto {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface Role
 */
export interface Role {
    /**
     * 
     * @type {number}
     * @memberof Role
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Role
     */
    'name': string;
    /**
     * 
     * @type {Array<object>}
     * @memberof Role
     */
    'users': Array<object>;
}
/**
 * 
 * @export
 * @interface ShareSnapshotDto
 */
export interface ShareSnapshotDto {
    /**
     * 
     * @type {ShareSnapshotDtoHeatProfileSnapshot}
     * @memberof ShareSnapshotDto
     */
    'heatProfileSnapshot'?: ShareSnapshotDtoHeatProfileSnapshot;
    /**
     * 
     * @type {ShareSnapshotDtoHeatProfileSnapshot}
     * @memberof ShareSnapshotDto
     */
    'moodLightSnapshot'?: ShareSnapshotDtoHeatProfileSnapshot;
}
/**
 * 
 * @export
 * @interface ShareSnapshotDtoHeatProfileSnapshot
 */
export interface ShareSnapshotDtoHeatProfileSnapshot {
    /**
     * 
     * @type {string}
     * @memberof ShareSnapshotDtoHeatProfileSnapshot
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface SliderUi
 */
export interface SliderUi {
    /**
     * 
     * @type {string}
     * @memberof SliderUi
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof SliderUi
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof SliderUi
     */
    'tag'?: string;
    /**
     * 
     * @type {UiType}
     * @memberof SliderUi
     */
    'type': UiType;
    /**
     * 
     * @type {number}
     * @memberof SliderUi
     */
    'min': number;
    /**
     * 
     * @type {number}
     * @memberof SliderUi
     */
    'max': number;
    /**
     * 
     * @type {number}
     * @memberof SliderUi
     */
    'default': number;
    /**
     * 
     * @type {number}
     * @memberof SliderUi
     */
    'step'?: number;
}


/**
 * 
 * @export
 * @interface SmsOptInSubscribeDto
 */
export interface SmsOptInSubscribeDto {
    /**
     * 
     * @type {string}
     * @memberof SmsOptInSubscribeDto
     */
    'phoneNumber': string;
}
/**
 * 
 * @export
 * @interface SyncStatusDto
 */
export interface SyncStatusDto {
    /**
     * 
     * @type {string}
     * @memberof SyncStatusDto
     */
    'lastDab'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum TemperatureUnit {
    Fahrenheit = 'Fahrenheit',
    Celsius = 'Celsius'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum TimeFilterPeriod {
    D = 'd',
    W = 'w',
    M = 'm',
    Y = 'y',
    All = 'all'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum TimeSlug {
    WakeBaker = 'Wake & Baker',
    HighNooner = 'High Nooner',
    NightToker = 'Night Toker',
    WeekendRipper = 'Weekend Ripper'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum UiType {
    Colors = 'colors',
    Slider = 'slider',
    Checkbox = 'checkbox',
    Menu = 'menu'
}


/**
 * 
 * @export
 * @interface UpserMoodLightProjectorMeta
 */
export interface UpserMoodLightProjectorMeta {
    /**
     * 
     * @type {ProjectorMeta}
     * @memberof UpserMoodLightProjectorMeta
     */
    'meta': ProjectorMeta;
}
/**
 * 
 * @export
 * @interface UpsertHeatProfileDto
 */
export interface UpsertHeatProfileDto {
    /**
     * 
     * @type {string}
     * @memberof UpsertHeatProfileDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertHeatProfileDto
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof UpsertHeatProfileDto
     */
    'temperature': number;
    /**
     * 
     * @type {TemperatureUnit}
     * @memberof UpsertHeatProfileDto
     */
    'units': TemperatureUnit;
    /**
     * 
     * @type {number}
     * @memberof UpsertHeatProfileDto
     */
    'duration': number;
    /**
     * 
     * @type {ProfileVersion}
     * @memberof UpsertHeatProfileDto
     */
    'version'?: ProfileVersion;
    /**
     * 
     * @type {number}
     * @memberof UpsertHeatProfileDto
     */
    'vaporSetting'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertHeatProfileDto
     */
    'order': number;
    /**
     * 
     * @type {number}
     * @memberof UpsertHeatProfileDto
     */
    'lighting'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpsertHeatProfileDto
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertHeatProfileDto
     */
    'modified'?: string;
    /**
     * 
     * @type {UpsertHeatProfileDtoLight}
     * @memberof UpsertHeatProfileDto
     */
    'light': UpsertHeatProfileDtoLight;
}


/**
 * @type UpsertHeatProfileDtoLight
 * @export
 */
export type UpsertHeatProfileDtoLight = ColorLight | MoodLightId;

/**
 * 
 * @export
 * @interface UpsertHeatProfilesBody
 */
export interface UpsertHeatProfilesBody {
    /**
     * 
     * @type {Array<UpsertHeatProfileDto>}
     * @memberof UpsertHeatProfilesBody
     */
    'items': Array<UpsertHeatProfileDto>;
}
/**
 * 
 * @export
 * @interface UpsertMoodLightDto
 */
export interface UpsertMoodLightDto {
    /**
     * 
     * @type {string}
     * @memberof UpsertMoodLightDto
     */
    'name': string;
    /**
     * 
     * @type {MoodLightCategory}
     * @memberof UpsertMoodLightDto
     */
    'category': MoodLightCategory;
    /**
     * 
     * @type {UpserMoodLightProjectorMeta}
     * @memberof UpsertMoodLightDto
     */
    'projector': UpserMoodLightProjectorMeta;
    /**
     * 
     * @type {string}
     * @memberof UpsertMoodLightDto
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertMoodLightDto
     */
    'modified'?: string;
}


/**
 * 
 * @export
 * @interface UserAppleAuthDto
 */
export interface UserAppleAuthDto {
    /**
     * 
     * @type {string}
     * @memberof UserAppleAuthDto
     */
    'code': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserAppleAuthDto
     */
    'legacy'?: boolean;
}
/**
 * 
 * @export
 * @interface UserDabsDto
 */
export interface UserDabsDto {
    /**
     * 
     * @type {RehashType}
     * @memberof UserDabsDto
     */
    'type': RehashType;
    /**
     * Title of the screen
     * @type {string}
     * @memberof UserDabsDto
     */
    'title': string;
    /**
     * Subtitle or additional information
     * @type {string}
     * @memberof UserDabsDto
     */
    'subtitle'?: string;
    /**
     * Wether information can be shared or not
     * @type {boolean}
     * @memberof UserDabsDto
     */
    'shareable': boolean;
    /**
     * Count of dabs
     * @type {number}
     * @memberof UserDabsDto
     */
    'dabCount': number;
}


/**
 * 
 * @export
 * @interface UserGetResponseDto
 */
export interface UserGetResponseDto {
    /**
     * 
     * @type {number}
     * @memberof UserGetResponseDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UserGetResponseDto
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof UserGetResponseDto
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof UserGetResponseDto
     */
    'username': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserGetResponseDto
     */
    'defaultUsername': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserGetResponseDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserGetResponseDto
     */
    'newPassword'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGetResponseDto
     */
    'currentPassword'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGetResponseDto
     */
    'tempPreference': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserGetResponseDto
     */
    'pushNotifications': boolean;
    /**
     * 
     * @type {MediaDto}
     * @memberof UserGetResponseDto
     */
    'profileMedia': MediaDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserGetResponseDto
     */
    'roles': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UserGetResponseDto
     */
    'verified': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserGetResponseDto
     */
    'locked'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserGetResponseDto
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof UserGetResponseDto
     */
    'modified': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserGetResponseDto
     */
    'enableBugfender': boolean;
}
/**
 * 
 * @export
 * @interface UserGoogleAuthDto
 */
export interface UserGoogleAuthDto {
    /**
     * 
     * @type {string}
     * @memberof UserGoogleAuthDto
     */
    'code': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserGoogleAuthDto
     */
    'isWeb'?: boolean;
}
/**
 * 
 * @export
 * @interface UserLoginDto
 */
export interface UserLoginDto {
    /**
     * 
     * @type {string}
     * @memberof UserLoginDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserLoginDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface UserRegisterDto
 */
export interface UserRegisterDto {
    /**
     * 
     * @type {string}
     * @memberof UserRegisterDto
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRegisterDto
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRegisterDto
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRegisterDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserRegisterDto
     */
    'password': string;
    /**
     * 
     * @type {MediaDto}
     * @memberof UserRegisterDto
     */
    'profileMedia'?: MediaDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserRegisterDto
     */
    'roles'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UserRegisterDto
     */
    'verified'?: boolean;
    /**
     * 
     * @type {MarketOptIn}
     * @memberof UserRegisterDto
     */
    'marketOptIn'?: MarketOptIn;
}


/**
 * 
 * @export
 * @interface UserRequestResetPasswordDto
 */
export interface UserRequestResetPasswordDto {
    /**
     * 
     * @type {string}
     * @memberof UserRequestResetPasswordDto
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface UserTokensDto
 */
export interface UserTokensDto {
    /**
     * 
     * @type {string}
     * @memberof UserTokensDto
     */
    'refreshToken': string;
    /**
     * 
     * @type {string}
     * @memberof UserTokensDto
     */
    'accessToken': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum UserType {
    Anonymous = 'anonymous',
    Existing = 'existing'
}


/**
 * 
 * @export
 * @interface UserUpdateDto
 */
export interface UserUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof UserUpdateDto
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateDto
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateDto
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateDto
     */
    'newPassword'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdateDto
     */
    'currentPassword'?: string;
    /**
     * 
     * @type {TemperatureUnit}
     * @memberof UserUpdateDto
     */
    'tempPreference'?: TemperatureUnit;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdateDto
     */
    'pushNotifications'?: boolean;
    /**
     * 
     * @type {MarketOptIn}
     * @memberof UserUpdateDto
     */
    'marketOptIn'?: MarketOptIn;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdateDto
     */
    'batteryPreservation'?: boolean;
    /**
     * 
     * @type {MediaDto}
     * @memberof UserUpdateDto
     */
    'profileMedia'?: MediaDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserUpdateDto
     */
    'roles'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdateDto
     */
    'verified'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdateDto
     */
    'peakAnimation'?: boolean;
}


/**
 * 
 * @export
 * @interface UserValidateFieldsDto
 */
export interface UserValidateFieldsDto {
    /**
     * 
     * @type {string}
     * @memberof UserValidateFieldsDto
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserValidateFieldsDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserValidateFieldsDto
     */
    'password'?: string;
}
/**
 * 
 * @export
 * @interface UsernameUpdateDto
 */
export interface UsernameUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof UsernameUpdateDto
     */
    'username': string;
}
/**
 * 
 * @export
 * @interface ValidateFieldsResponse
 */
export interface ValidateFieldsResponse {
    /**
     * 
     * @type {string}
     * @memberof ValidateFieldsResponse
     */
    'username'?: ValidateFieldsResponseUsernameEnum;
    /**
     * 
     * @type {string}
     * @memberof ValidateFieldsResponse
     */
    'email'?: ValidateFieldsResponseEmailEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ValidateFieldsResponse
     */
    'password'?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum ValidateFieldsResponseUsernameEnum {
    Ok = 'ok',
    Blank = 'blank',
    Offensive = 'offensive',
    Taken = 'taken'
}
/**
    * @export
    * @enum {string}
    */
export enum ValidateFieldsResponseEmailEnum {
    Ok = 'ok',
    Invalid = 'invalid',
    Taken = 'taken'
}

/**
 * 
 * @export
 * @interface ViralMoodlightDto
 */
export interface ViralMoodlightDto {
    /**
     * 
     * @type {RehashType}
     * @memberof ViralMoodlightDto
     */
    'type': RehashType;
    /**
     * Title of the screen
     * @type {string}
     * @memberof ViralMoodlightDto
     */
    'title': string;
    /**
     * Subtitle or additional information
     * @type {string}
     * @memberof ViralMoodlightDto
     */
    'subtitle'?: string;
    /**
     * Wether information can be shared or not
     * @type {boolean}
     * @memberof ViralMoodlightDto
     */
    'shareable': boolean;
    /**
     * Count of dabs
     * @type {number}
     * @memberof ViralMoodlightDto
     */
    'dabCount': number;
    /**
     * Moodlight id
     * @type {string}
     * @memberof ViralMoodlightDto
     */
    'moodLightId': string;
    /**
     * Moodlight name
     * @type {string}
     * @memberof ViralMoodlightDto
     */
    'moodlightName': string;
    /**
     * Array of moodlight colors
     * @type {Array<string>}
     * @memberof ViralMoodlightDto
     */
    'moodlightColors': Array<string>;
    /**
     * Id of the shared moodlight
     * @type {string}
     * @memberof ViralMoodlightDto
     */
    'moodLightShareId'?: string;
    /**
     * Username of the the viral moodlight creator
     * @type {string}
     * @memberof ViralMoodlightDto
     */
    'username': string;
}



/**
 * AgreementApi - axios parameter creator
 * @export
 */
export const AgreementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AgreementCreateDto} agreementCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNewAgreement: async (agreementCreateDto: AgreementCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementCreateDto' is not null or undefined
            assertParamExists('addNewAgreement', 'agreementCreateDto', agreementCreateDto)
            const localVarPath = `/api/agreement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agreementCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgreement: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAgreement', 'id', id)
            const localVarPath = `/api/agreement/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [type] 
         * @param {string} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgreementCount: async (type?: string, version?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/agreement/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} limit 
         * @param {string} [type] 
         * @param {string} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAgreements: async (page: number, limit: number, type?: string, version?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getAllAgreements', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getAllAgreements', 'limit', limit)
            const localVarPath = `/api/agreement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestAgreement: async (type: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getLatestAgreement', 'type', type)
            const localVarPath = `/api/agreement/latest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgreementApi - functional programming interface
 * @export
 */
export const AgreementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgreementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AgreementCreateDto} agreementCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addNewAgreement(agreementCreateDto: AgreementCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgreementDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addNewAgreement(agreementCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementApi.addNewAgreement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgreement(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgreementDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgreement(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementApi.getAgreement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [type] 
         * @param {string} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgreementCount(type?: string, version?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgreementCount(type, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementApi.getAgreementCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} limit 
         * @param {string} [type] 
         * @param {string} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAgreements(page: number, limit: number, type?: string, version?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AgreementDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAgreements(page, limit, type, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementApi.getAllAgreements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestAgreement(type: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgreementDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestAgreement(type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementApi.getLatestAgreement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AgreementApi - factory interface
 * @export
 */
export const AgreementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgreementApiFp(configuration)
    return {
        /**
         * 
         * @param {AgreementApiAddNewAgreementRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNewAgreement(requestParameters: AgreementApiAddNewAgreementRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgreementDto> {
            return localVarFp.addNewAgreement(requestParameters.agreementCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AgreementApiGetAgreementRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgreement(requestParameters: AgreementApiGetAgreementRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgreementDto> {
            return localVarFp.getAgreement(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AgreementApiGetAgreementCountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgreementCount(requestParameters: AgreementApiGetAgreementCountRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getAgreementCount(requestParameters.type, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AgreementApiGetAllAgreementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAgreements(requestParameters: AgreementApiGetAllAgreementsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AgreementDto>> {
            return localVarFp.getAllAgreements(requestParameters.page, requestParameters.limit, requestParameters.type, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AgreementApiGetLatestAgreementRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestAgreement(requestParameters: AgreementApiGetLatestAgreementRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgreementDto> {
            return localVarFp.getLatestAgreement(requestParameters.type, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addNewAgreement operation in AgreementApi.
 * @export
 * @interface AgreementApiAddNewAgreementRequest
 */
export interface AgreementApiAddNewAgreementRequest {
    /**
     * 
     * @type {AgreementCreateDto}
     * @memberof AgreementApiAddNewAgreement
     */
    readonly agreementCreateDto: AgreementCreateDto
}

/**
 * Request parameters for getAgreement operation in AgreementApi.
 * @export
 * @interface AgreementApiGetAgreementRequest
 */
export interface AgreementApiGetAgreementRequest {
    /**
     * 
     * @type {number}
     * @memberof AgreementApiGetAgreement
     */
    readonly id: number
}

/**
 * Request parameters for getAgreementCount operation in AgreementApi.
 * @export
 * @interface AgreementApiGetAgreementCountRequest
 */
export interface AgreementApiGetAgreementCountRequest {
    /**
     * 
     * @type {string}
     * @memberof AgreementApiGetAgreementCount
     */
    readonly type?: string

    /**
     * 
     * @type {string}
     * @memberof AgreementApiGetAgreementCount
     */
    readonly version?: string
}

/**
 * Request parameters for getAllAgreements operation in AgreementApi.
 * @export
 * @interface AgreementApiGetAllAgreementsRequest
 */
export interface AgreementApiGetAllAgreementsRequest {
    /**
     * 
     * @type {number}
     * @memberof AgreementApiGetAllAgreements
     */
    readonly page: number

    /**
     * 
     * @type {number}
     * @memberof AgreementApiGetAllAgreements
     */
    readonly limit: number

    /**
     * 
     * @type {string}
     * @memberof AgreementApiGetAllAgreements
     */
    readonly type?: string

    /**
     * 
     * @type {string}
     * @memberof AgreementApiGetAllAgreements
     */
    readonly version?: string
}

/**
 * Request parameters for getLatestAgreement operation in AgreementApi.
 * @export
 * @interface AgreementApiGetLatestAgreementRequest
 */
export interface AgreementApiGetLatestAgreementRequest {
    /**
     * 
     * @type {string}
     * @memberof AgreementApiGetLatestAgreement
     */
    readonly type: string
}

/**
 * AgreementApi - object-oriented interface
 * @export
 * @class AgreementApi
 * @extends {BaseAPI}
 */
export class AgreementApi extends BaseAPI {
    /**
     * 
     * @param {AgreementApiAddNewAgreementRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementApi
     */
    public addNewAgreement(requestParameters: AgreementApiAddNewAgreementRequest, options?: RawAxiosRequestConfig) {
        return AgreementApiFp(this.configuration).addNewAgreement(requestParameters.agreementCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AgreementApiGetAgreementRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementApi
     */
    public getAgreement(requestParameters: AgreementApiGetAgreementRequest, options?: RawAxiosRequestConfig) {
        return AgreementApiFp(this.configuration).getAgreement(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AgreementApiGetAgreementCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementApi
     */
    public getAgreementCount(requestParameters: AgreementApiGetAgreementCountRequest = {}, options?: RawAxiosRequestConfig) {
        return AgreementApiFp(this.configuration).getAgreementCount(requestParameters.type, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AgreementApiGetAllAgreementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementApi
     */
    public getAllAgreements(requestParameters: AgreementApiGetAllAgreementsRequest, options?: RawAxiosRequestConfig) {
        return AgreementApiFp(this.configuration).getAllAgreements(requestParameters.page, requestParameters.limit, requestParameters.type, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AgreementApiGetLatestAgreementRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementApi
     */
    public getLatestAgreement(requestParameters: AgreementApiGetLatestAgreementRequest, options?: RawAxiosRequestConfig) {
        return AgreementApiFp(this.configuration).getLatestAgreement(requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AgreementTrackingApi - axios parameter creator
 * @export
 */
export const AgreementTrackingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AgreementTrackingCreateDto} agreementTrackingCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNewAgreementTracking: async (agreementTrackingCreateDto: AgreementTrackingCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementTrackingCreateDto' is not null or undefined
            assertParamExists('addNewAgreementTracking', 'agreementTrackingCreateDto', agreementTrackingCreateDto)
            const localVarPath = `/api/agreement-tracking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agreementTrackingCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {UserType} userType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkUserLatestAgreementStatus: async (userId: string, userType: UserType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('checkUserLatestAgreementStatus', 'userId', userId)
            // verify required parameter 'userType' is not null or undefined
            assertParamExists('checkUserLatestAgreementStatus', 'userType', userType)
            const localVarPath = `/api/agreement-tracking/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (userType !== undefined) {
                localVarQueryParameter['userType'] = userType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [type] 
         * @param {string} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgreementTrackingCount: async (type?: string, version?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/agreement-tracking/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} limit 
         * @param {string} [type] 
         * @param {string} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAgreementTrackings: async (page: number, limit: number, type?: string, version?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getAllAgreementTrackings', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getAllAgreementTrackings', 'limit', limit)
            const localVarPath = `/api/agreement-tracking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} generatedUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgreementTracking: async (generatedUserId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generatedUserId' is not null or undefined
            assertParamExists('updateAgreementTracking', 'generatedUserId', generatedUserId)
            const localVarPath = `/api/agreement-tracking/{generatedUserId}/link`
                .replace(`{${"generatedUserId"}}`, encodeURIComponent(String(generatedUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgreementTrackingApi - functional programming interface
 * @export
 */
export const AgreementTrackingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgreementTrackingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AgreementTrackingCreateDto} agreementTrackingCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addNewAgreementTracking(agreementTrackingCreateDto: AgreementTrackingCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgreementTracking>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addNewAgreementTracking(agreementTrackingCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementTrackingApi.addNewAgreementTracking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {UserType} userType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkUserLatestAgreementStatus(userId: string, userType: UserType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AgreementTrackingStatusDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkUserLatestAgreementStatus(userId, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementTrackingApi.checkUserLatestAgreementStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [type] 
         * @param {string} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgreementTrackingCount(type?: string, version?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgreementTrackingCount(type, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementTrackingApi.getAgreementTrackingCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} limit 
         * @param {string} [type] 
         * @param {string} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAgreementTrackings(page: number, limit: number, type?: string, version?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AgreementTracking>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAgreementTrackings(page, limit, type, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementTrackingApi.getAllAgreementTrackings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} generatedUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAgreementTracking(generatedUserId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAgreementTracking(generatedUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementTrackingApi.updateAgreementTracking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AgreementTrackingApi - factory interface
 * @export
 */
export const AgreementTrackingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgreementTrackingApiFp(configuration)
    return {
        /**
         * 
         * @param {AgreementTrackingApiAddNewAgreementTrackingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNewAgreementTracking(requestParameters: AgreementTrackingApiAddNewAgreementTrackingRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgreementTracking> {
            return localVarFp.addNewAgreementTracking(requestParameters.agreementTrackingCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AgreementTrackingApiCheckUserLatestAgreementStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkUserLatestAgreementStatus(requestParameters: AgreementTrackingApiCheckUserLatestAgreementStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AgreementTrackingStatusDto>> {
            return localVarFp.checkUserLatestAgreementStatus(requestParameters.userId, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AgreementTrackingApiGetAgreementTrackingCountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgreementTrackingCount(requestParameters: AgreementTrackingApiGetAgreementTrackingCountRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getAgreementTrackingCount(requestParameters.type, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AgreementTrackingApiGetAllAgreementTrackingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAgreementTrackings(requestParameters: AgreementTrackingApiGetAllAgreementTrackingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AgreementTracking>> {
            return localVarFp.getAllAgreementTrackings(requestParameters.page, requestParameters.limit, requestParameters.type, requestParameters.version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AgreementTrackingApiUpdateAgreementTrackingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgreementTracking(requestParameters: AgreementTrackingApiUpdateAgreementTrackingRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateAgreementTracking(requestParameters.generatedUserId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addNewAgreementTracking operation in AgreementTrackingApi.
 * @export
 * @interface AgreementTrackingApiAddNewAgreementTrackingRequest
 */
export interface AgreementTrackingApiAddNewAgreementTrackingRequest {
    /**
     * 
     * @type {AgreementTrackingCreateDto}
     * @memberof AgreementTrackingApiAddNewAgreementTracking
     */
    readonly agreementTrackingCreateDto: AgreementTrackingCreateDto
}

/**
 * Request parameters for checkUserLatestAgreementStatus operation in AgreementTrackingApi.
 * @export
 * @interface AgreementTrackingApiCheckUserLatestAgreementStatusRequest
 */
export interface AgreementTrackingApiCheckUserLatestAgreementStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof AgreementTrackingApiCheckUserLatestAgreementStatus
     */
    readonly userId: string

    /**
     * 
     * @type {UserType}
     * @memberof AgreementTrackingApiCheckUserLatestAgreementStatus
     */
    readonly userType: UserType
}

/**
 * Request parameters for getAgreementTrackingCount operation in AgreementTrackingApi.
 * @export
 * @interface AgreementTrackingApiGetAgreementTrackingCountRequest
 */
export interface AgreementTrackingApiGetAgreementTrackingCountRequest {
    /**
     * 
     * @type {string}
     * @memberof AgreementTrackingApiGetAgreementTrackingCount
     */
    readonly type?: string

    /**
     * 
     * @type {string}
     * @memberof AgreementTrackingApiGetAgreementTrackingCount
     */
    readonly version?: string
}

/**
 * Request parameters for getAllAgreementTrackings operation in AgreementTrackingApi.
 * @export
 * @interface AgreementTrackingApiGetAllAgreementTrackingsRequest
 */
export interface AgreementTrackingApiGetAllAgreementTrackingsRequest {
    /**
     * 
     * @type {number}
     * @memberof AgreementTrackingApiGetAllAgreementTrackings
     */
    readonly page: number

    /**
     * 
     * @type {number}
     * @memberof AgreementTrackingApiGetAllAgreementTrackings
     */
    readonly limit: number

    /**
     * 
     * @type {string}
     * @memberof AgreementTrackingApiGetAllAgreementTrackings
     */
    readonly type?: string

    /**
     * 
     * @type {string}
     * @memberof AgreementTrackingApiGetAllAgreementTrackings
     */
    readonly version?: string
}

/**
 * Request parameters for updateAgreementTracking operation in AgreementTrackingApi.
 * @export
 * @interface AgreementTrackingApiUpdateAgreementTrackingRequest
 */
export interface AgreementTrackingApiUpdateAgreementTrackingRequest {
    /**
     * 
     * @type {string}
     * @memberof AgreementTrackingApiUpdateAgreementTracking
     */
    readonly generatedUserId: string
}

/**
 * AgreementTrackingApi - object-oriented interface
 * @export
 * @class AgreementTrackingApi
 * @extends {BaseAPI}
 */
export class AgreementTrackingApi extends BaseAPI {
    /**
     * 
     * @param {AgreementTrackingApiAddNewAgreementTrackingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementTrackingApi
     */
    public addNewAgreementTracking(requestParameters: AgreementTrackingApiAddNewAgreementTrackingRequest, options?: RawAxiosRequestConfig) {
        return AgreementTrackingApiFp(this.configuration).addNewAgreementTracking(requestParameters.agreementTrackingCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AgreementTrackingApiCheckUserLatestAgreementStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementTrackingApi
     */
    public checkUserLatestAgreementStatus(requestParameters: AgreementTrackingApiCheckUserLatestAgreementStatusRequest, options?: RawAxiosRequestConfig) {
        return AgreementTrackingApiFp(this.configuration).checkUserLatestAgreementStatus(requestParameters.userId, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AgreementTrackingApiGetAgreementTrackingCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementTrackingApi
     */
    public getAgreementTrackingCount(requestParameters: AgreementTrackingApiGetAgreementTrackingCountRequest = {}, options?: RawAxiosRequestConfig) {
        return AgreementTrackingApiFp(this.configuration).getAgreementTrackingCount(requestParameters.type, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AgreementTrackingApiGetAllAgreementTrackingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementTrackingApi
     */
    public getAllAgreementTrackings(requestParameters: AgreementTrackingApiGetAllAgreementTrackingsRequest, options?: RawAxiosRequestConfig) {
        return AgreementTrackingApiFp(this.configuration).getAllAgreementTrackings(requestParameters.page, requestParameters.limit, requestParameters.type, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AgreementTrackingApiUpdateAgreementTrackingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementTrackingApi
     */
    public updateAgreementTracking(requestParameters: AgreementTrackingApiUpdateAgreementTrackingRequest, options?: RawAxiosRequestConfig) {
        return AgreementTrackingApiFp(this.configuration).updateAgreementTracking(requestParameters.generatedUserId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AppLogsApi - axios parameter creator
 * @export
 */
export const AppLogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AppLogsCreateDto} appLogsCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppLog: async (appLogsCreateDto: AppLogsCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appLogsCreateDto' is not null or undefined
            assertParamExists('createAppLog', 'appLogsCreateDto', appLogsCreateDto)
            const localVarPath = `/api/v1/app-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appLogsCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {LegacyAppLogsCreateDto} legacyAppLogsCreateDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        legacyCreateAppLog: async (legacyAppLogsCreateDto: LegacyAppLogsCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'legacyAppLogsCreateDto' is not null or undefined
            assertParamExists('legacyCreateAppLog', 'legacyAppLogsCreateDto', legacyAppLogsCreateDto)
            const localVarPath = `/api/app-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(legacyAppLogsCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppLogsApi - functional programming interface
 * @export
 */
export const AppLogsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppLogsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AppLogsCreateDto} appLogsCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAppLog(appLogsCreateDto: AppLogsCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAppLog(appLogsCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppLogsApi.createAppLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {LegacyAppLogsCreateDto} legacyAppLogsCreateDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async legacyCreateAppLog(legacyAppLogsCreateDto: LegacyAppLogsCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.legacyCreateAppLog(legacyAppLogsCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppLogsApi.legacyCreateAppLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AppLogsApi - factory interface
 * @export
 */
export const AppLogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppLogsApiFp(configuration)
    return {
        /**
         * 
         * @param {AppLogsApiCreateAppLogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppLog(requestParameters: AppLogsApiCreateAppLogRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createAppLog(requestParameters.appLogsCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {AppLogsApiLegacyCreateAppLogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        legacyCreateAppLog(requestParameters: AppLogsApiLegacyCreateAppLogRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.legacyCreateAppLog(requestParameters.legacyAppLogsCreateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createAppLog operation in AppLogsApi.
 * @export
 * @interface AppLogsApiCreateAppLogRequest
 */
export interface AppLogsApiCreateAppLogRequest {
    /**
     * 
     * @type {AppLogsCreateDto}
     * @memberof AppLogsApiCreateAppLog
     */
    readonly appLogsCreateDto: AppLogsCreateDto
}

/**
 * Request parameters for legacyCreateAppLog operation in AppLogsApi.
 * @export
 * @interface AppLogsApiLegacyCreateAppLogRequest
 */
export interface AppLogsApiLegacyCreateAppLogRequest {
    /**
     * 
     * @type {LegacyAppLogsCreateDto}
     * @memberof AppLogsApiLegacyCreateAppLog
     */
    readonly legacyAppLogsCreateDto: LegacyAppLogsCreateDto
}

/**
 * AppLogsApi - object-oriented interface
 * @export
 * @class AppLogsApi
 * @extends {BaseAPI}
 */
export class AppLogsApi extends BaseAPI {
    /**
     * 
     * @param {AppLogsApiCreateAppLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppLogsApi
     */
    public createAppLog(requestParameters: AppLogsApiCreateAppLogRequest, options?: RawAxiosRequestConfig) {
        return AppLogsApiFp(this.configuration).createAppLog(requestParameters.appLogsCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {AppLogsApiLegacyCreateAppLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AppLogsApi
     */
    public legacyCreateAppLog(requestParameters: AppLogsApiLegacyCreateAppLogRequest, options?: RawAxiosRequestConfig) {
        return AppLogsApiFp(this.configuration).legacyCreateAppLog(requestParameters.legacyAppLogsCreateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ContextApi - axios parameter creator
 * @export
 */
export const ContextApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContext: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/context`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContextApi - functional programming interface
 * @export
 */
export const ContextApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContextApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContext(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContextDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContext(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContextApi.getContext']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContextApi - factory interface
 * @export
 */
export const ContextApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContextApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContext(options?: RawAxiosRequestConfig): AxiosPromise<ContextDto> {
            return localVarFp.getContext(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContextApi - object-oriented interface
 * @export
 * @class ContextApi
 * @extends {BaseAPI}
 */
export class ContextApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContextApi
     */
    public getContext(options?: RawAxiosRequestConfig) {
        return ContextApiFp(this.configuration).getContext(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealth: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHealth(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHealth(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getHealth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealth(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getHealth(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getHealth(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getHealth(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DeviceTokensApi - axios parameter creator
 * @export
 */
export const DeviceTokensApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invalidateDeviceToken: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('invalidateDeviceToken', 'token', token)
            const localVarPath = `/api/device-tokens/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceToken: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('updateDeviceToken', 'token', token)
            const localVarPath = `/api/device-tokens/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeviceTokensApi - functional programming interface
 * @export
 */
export const DeviceTokensApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeviceTokensApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invalidateDeviceToken(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invalidateDeviceToken(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceTokensApi.invalidateDeviceToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDeviceToken(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDeviceToken(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceTokensApi.updateDeviceToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DeviceTokensApi - factory interface
 * @export
 */
export const DeviceTokensApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeviceTokensApiFp(configuration)
    return {
        /**
         * 
         * @param {DeviceTokensApiInvalidateDeviceTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invalidateDeviceToken(requestParameters: DeviceTokensApiInvalidateDeviceTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.invalidateDeviceToken(requestParameters.token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeviceTokensApiUpdateDeviceTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceToken(requestParameters: DeviceTokensApiUpdateDeviceTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateDeviceToken(requestParameters.token, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for invalidateDeviceToken operation in DeviceTokensApi.
 * @export
 * @interface DeviceTokensApiInvalidateDeviceTokenRequest
 */
export interface DeviceTokensApiInvalidateDeviceTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof DeviceTokensApiInvalidateDeviceToken
     */
    readonly token: string
}

/**
 * Request parameters for updateDeviceToken operation in DeviceTokensApi.
 * @export
 * @interface DeviceTokensApiUpdateDeviceTokenRequest
 */
export interface DeviceTokensApiUpdateDeviceTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof DeviceTokensApiUpdateDeviceToken
     */
    readonly token: string
}

/**
 * DeviceTokensApi - object-oriented interface
 * @export
 * @class DeviceTokensApi
 * @extends {BaseAPI}
 */
export class DeviceTokensApi extends BaseAPI {
    /**
     * 
     * @param {DeviceTokensApiInvalidateDeviceTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceTokensApi
     */
    public invalidateDeviceToken(requestParameters: DeviceTokensApiInvalidateDeviceTokenRequest, options?: RawAxiosRequestConfig) {
        return DeviceTokensApiFp(this.configuration).invalidateDeviceToken(requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeviceTokensApiUpdateDeviceTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceTokensApi
     */
    public updateDeviceToken(requestParameters: DeviceTokensApiUpdateDeviceTokenRequest, options?: RawAxiosRequestConfig) {
        return DeviceTokensApiFp(this.configuration).updateDeviceToken(requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GeolocationApi - axios parameter creator
 * @export
 */
export const GeolocationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountry: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/geolocation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeolocationApi - functional programming interface
 * @export
 */
export const GeolocationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeolocationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountry(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeolocationCountryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountry(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeolocationApi.getCountry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GeolocationApi - factory interface
 * @export
 */
export const GeolocationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeolocationApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountry(options?: RawAxiosRequestConfig): AxiosPromise<GeolocationCountryDto> {
            return localVarFp.getCountry(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GeolocationApi - object-oriented interface
 * @export
 * @class GeolocationApi
 * @extends {BaseAPI}
 */
export class GeolocationApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeolocationApi
     */
    public getCountry(options?: RawAxiosRequestConfig) {
        return GeolocationApiFp(this.configuration).getCountry(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HeatProfileApi - axios parameter creator
 * @export
 */
export const HeatProfileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deleteProfileLegacy: async (profileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('deleteProfileLegacy', 'profileId', profileId)
            const localVarPath = `/api/heat-profile/{profileId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {Array<HeatProfileUpdateDto>} heatProfileUpdateDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateProfiles: async (heatProfileUpdateDto: Array<HeatProfileUpdateDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'heatProfileUpdateDto' is not null or undefined
            assertParamExists('updateProfiles', 'heatProfileUpdateDto', heatProfileUpdateDto)
            const localVarPath = `/api/heat-profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(heatProfileUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HeatProfileApi - functional programming interface
 * @export
 */
export const HeatProfileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HeatProfileApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async deleteProfileLegacy(profileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProfileLegacy(profileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HeatProfileApi.deleteProfileLegacy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {Array<HeatProfileUpdateDto>} heatProfileUpdateDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async updateProfiles(heatProfileUpdateDto: Array<HeatProfileUpdateDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProfiles(heatProfileUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HeatProfileApi.updateProfiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HeatProfileApi - factory interface
 * @export
 */
export const HeatProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HeatProfileApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {HeatProfileApiDeleteProfileLegacyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deleteProfileLegacy(requestParameters: HeatProfileApiDeleteProfileLegacyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteProfileLegacy(requestParameters.profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {HeatProfileApiUpdateProfilesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        updateProfiles(requestParameters: HeatProfileApiUpdateProfilesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProfiles(requestParameters.heatProfileUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteProfileLegacy operation in HeatProfileApi.
 * @export
 * @interface HeatProfileApiDeleteProfileLegacyRequest
 */
export interface HeatProfileApiDeleteProfileLegacyRequest {
    /**
     * 
     * @type {string}
     * @memberof HeatProfileApiDeleteProfileLegacy
     */
    readonly profileId: string
}

/**
 * Request parameters for updateProfiles operation in HeatProfileApi.
 * @export
 * @interface HeatProfileApiUpdateProfilesRequest
 */
export interface HeatProfileApiUpdateProfilesRequest {
    /**
     * 
     * @type {Array<HeatProfileUpdateDto>}
     * @memberof HeatProfileApiUpdateProfiles
     */
    readonly heatProfileUpdateDto: Array<HeatProfileUpdateDto>
}

/**
 * HeatProfileApi - object-oriented interface
 * @export
 * @class HeatProfileApi
 * @extends {BaseAPI}
 */
export class HeatProfileApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {HeatProfileApiDeleteProfileLegacyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof HeatProfileApi
     */
    public deleteProfileLegacy(requestParameters: HeatProfileApiDeleteProfileLegacyRequest, options?: RawAxiosRequestConfig) {
        return HeatProfileApiFp(this.configuration).deleteProfileLegacy(requestParameters.profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {HeatProfileApiUpdateProfilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof HeatProfileApi
     */
    public updateProfiles(requestParameters: HeatProfileApiUpdateProfilesRequest, options?: RawAxiosRequestConfig) {
        return HeatProfileApiFp(this.configuration).updateProfiles(requestParameters.heatProfileUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HeatProfilesApi - axios parameter creator
 * @export
 */
export const HeatProfilesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHeatProfile: async (profileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('deleteHeatProfile', 'profileId', profileId)
            const localVarPath = `/api/v1/heat-profiles/{profileId}`
                .replace(`{${"profileId"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetHeatProfilesOrderEnum} [order] 
         * @param {GetHeatProfilesSortEnum} [sort] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHeatProfiles: async (order?: GetHeatProfilesOrderEnum, sort?: GetHeatProfilesSortEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/heat-profiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertHeatProfilesBody} upsertHeatProfilesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertHeatProfiles: async (upsertHeatProfilesBody: UpsertHeatProfilesBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'upsertHeatProfilesBody' is not null or undefined
            assertParamExists('upsertHeatProfiles', 'upsertHeatProfilesBody', upsertHeatProfilesBody)
            const localVarPath = `/api/v1/heat-profiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertHeatProfilesBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HeatProfilesApi - functional programming interface
 * @export
 */
export const HeatProfilesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HeatProfilesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} profileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteHeatProfile(profileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteHeatProfile(profileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HeatProfilesApi.deleteHeatProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetHeatProfilesOrderEnum} [order] 
         * @param {GetHeatProfilesSortEnum} [sort] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHeatProfiles(order?: GetHeatProfilesOrderEnum, sort?: GetHeatProfilesSortEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetHeatProfilesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHeatProfiles(order, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HeatProfilesApi.getHeatProfiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertHeatProfilesBody} upsertHeatProfilesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertHeatProfiles(upsertHeatProfilesBody: UpsertHeatProfilesBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetHeatProfilesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertHeatProfiles(upsertHeatProfilesBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HeatProfilesApi.upsertHeatProfiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HeatProfilesApi - factory interface
 * @export
 */
export const HeatProfilesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HeatProfilesApiFp(configuration)
    return {
        /**
         * 
         * @param {HeatProfilesApiDeleteHeatProfileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHeatProfile(requestParameters: HeatProfilesApiDeleteHeatProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteHeatProfile(requestParameters.profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {HeatProfilesApiGetHeatProfilesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHeatProfiles(requestParameters: HeatProfilesApiGetHeatProfilesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetHeatProfilesResponse> {
            return localVarFp.getHeatProfiles(requestParameters.order, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {HeatProfilesApiUpsertHeatProfilesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertHeatProfiles(requestParameters: HeatProfilesApiUpsertHeatProfilesRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetHeatProfilesResponse> {
            return localVarFp.upsertHeatProfiles(requestParameters.upsertHeatProfilesBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteHeatProfile operation in HeatProfilesApi.
 * @export
 * @interface HeatProfilesApiDeleteHeatProfileRequest
 */
export interface HeatProfilesApiDeleteHeatProfileRequest {
    /**
     * 
     * @type {string}
     * @memberof HeatProfilesApiDeleteHeatProfile
     */
    readonly profileId: string
}

/**
 * Request parameters for getHeatProfiles operation in HeatProfilesApi.
 * @export
 * @interface HeatProfilesApiGetHeatProfilesRequest
 */
export interface HeatProfilesApiGetHeatProfilesRequest {
    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof HeatProfilesApiGetHeatProfiles
     */
    readonly order?: GetHeatProfilesOrderEnum

    /**
     * 
     * @type {'created' | 'order'}
     * @memberof HeatProfilesApiGetHeatProfiles
     */
    readonly sort?: GetHeatProfilesSortEnum
}

/**
 * Request parameters for upsertHeatProfiles operation in HeatProfilesApi.
 * @export
 * @interface HeatProfilesApiUpsertHeatProfilesRequest
 */
export interface HeatProfilesApiUpsertHeatProfilesRequest {
    /**
     * 
     * @type {UpsertHeatProfilesBody}
     * @memberof HeatProfilesApiUpsertHeatProfiles
     */
    readonly upsertHeatProfilesBody: UpsertHeatProfilesBody
}

/**
 * HeatProfilesApi - object-oriented interface
 * @export
 * @class HeatProfilesApi
 * @extends {BaseAPI}
 */
export class HeatProfilesApi extends BaseAPI {
    /**
     * 
     * @param {HeatProfilesApiDeleteHeatProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HeatProfilesApi
     */
    public deleteHeatProfile(requestParameters: HeatProfilesApiDeleteHeatProfileRequest, options?: RawAxiosRequestConfig) {
        return HeatProfilesApiFp(this.configuration).deleteHeatProfile(requestParameters.profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {HeatProfilesApiGetHeatProfilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HeatProfilesApi
     */
    public getHeatProfiles(requestParameters: HeatProfilesApiGetHeatProfilesRequest = {}, options?: RawAxiosRequestConfig) {
        return HeatProfilesApiFp(this.configuration).getHeatProfiles(requestParameters.order, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {HeatProfilesApiUpsertHeatProfilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HeatProfilesApi
     */
    public upsertHeatProfiles(requestParameters: HeatProfilesApiUpsertHeatProfilesRequest, options?: RawAxiosRequestConfig) {
        return HeatProfilesApiFp(this.configuration).upsertHeatProfiles(requestParameters.upsertHeatProfilesBody, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
  * @export
  * @enum {string}
  */
export enum GetHeatProfilesOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
  * @export
  * @enum {string}
  */
export enum GetHeatProfilesSortEnum {
    Created = 'created',
    Order = 'order'
}


/**
 * InterstitialApi - axios parameter creator
 * @export
 */
export const InterstitialApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {InterstitialCreateDto} interstitialCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addInterstitial: async (interstitialCreateDto: InterstitialCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'interstitialCreateDto' is not null or undefined
            assertParamExists('addInterstitial', 'interstitialCreateDto', interstitialCreateDto)
            const localVarPath = `/api/interstitials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(interstitialCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInterstitial: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteInterstitial', 'id', id)
            const localVarPath = `/api/interstitials/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} xAppVersion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActive: async (xAppVersion: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xAppVersion' is not null or undefined
            assertParamExists('getActive', 'xAppVersion', xAppVersion)
            const localVarPath = `/api/interstitials/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xAppVersion != null) {
                localVarHeaderParameter['x-app-version'] = String(xAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sort] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInterstitials: async (page?: number, limit?: number, sort?: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/interstitials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInterstitial: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getInterstitial', 'id', id)
            const localVarPath = `/api/interstitials/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInterstitialCount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/interstitials/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {InterstitialUpdateDto} interstitialUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInterstitial: async (id: number, interstitialUpdateDto: InterstitialUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateInterstitial', 'id', id)
            // verify required parameter 'interstitialUpdateDto' is not null or undefined
            assertParamExists('updateInterstitial', 'interstitialUpdateDto', interstitialUpdateDto)
            const localVarPath = `/api/interstitials/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(interstitialUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InterstitialApi - functional programming interface
 * @export
 */
export const InterstitialApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InterstitialApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {InterstitialCreateDto} interstitialCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addInterstitial(interstitialCreateDto: InterstitialCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Interstitial>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addInterstitial(interstitialCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterstitialApi.addInterstitial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteInterstitial(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteInterstitial(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterstitialApi.deleteInterstitial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} xAppVersion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActive(xAppVersion: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InterstitialActiveResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActive(xAppVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterstitialApi.getActive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [sort] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllInterstitials(page?: number, limit?: number, sort?: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Interstitial>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllInterstitials(page, limit, sort, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterstitialApi.getAllInterstitials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInterstitial(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Interstitial>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInterstitial(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterstitialApi.getInterstitial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInterstitialCount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInterstitialCount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterstitialApi.getInterstitialCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {InterstitialUpdateDto} interstitialUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInterstitial(id: number, interstitialUpdateDto: InterstitialUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Interstitial>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInterstitial(id, interstitialUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterstitialApi.updateInterstitial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InterstitialApi - factory interface
 * @export
 */
export const InterstitialApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InterstitialApiFp(configuration)
    return {
        /**
         * 
         * @param {InterstitialApiAddInterstitialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addInterstitial(requestParameters: InterstitialApiAddInterstitialRequest, options?: RawAxiosRequestConfig): AxiosPromise<Interstitial> {
            return localVarFp.addInterstitial(requestParameters.interstitialCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterstitialApiDeleteInterstitialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInterstitial(requestParameters: InterstitialApiDeleteInterstitialRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.deleteInterstitial(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterstitialApiGetActiveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActive(requestParameters: InterstitialApiGetActiveRequest, options?: RawAxiosRequestConfig): AxiosPromise<InterstitialActiveResultDto> {
            return localVarFp.getActive(requestParameters.xAppVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterstitialApiGetAllInterstitialsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllInterstitials(requestParameters: InterstitialApiGetAllInterstitialsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<Interstitial>> {
            return localVarFp.getAllInterstitials(requestParameters.page, requestParameters.limit, requestParameters.sort, requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterstitialApiGetInterstitialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInterstitial(requestParameters: InterstitialApiGetInterstitialRequest, options?: RawAxiosRequestConfig): AxiosPromise<Interstitial> {
            return localVarFp.getInterstitial(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInterstitialCount(options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getInterstitialCount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InterstitialApiUpdateInterstitialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInterstitial(requestParameters: InterstitialApiUpdateInterstitialRequest, options?: RawAxiosRequestConfig): AxiosPromise<Interstitial> {
            return localVarFp.updateInterstitial(requestParameters.id, requestParameters.interstitialUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addInterstitial operation in InterstitialApi.
 * @export
 * @interface InterstitialApiAddInterstitialRequest
 */
export interface InterstitialApiAddInterstitialRequest {
    /**
     * 
     * @type {InterstitialCreateDto}
     * @memberof InterstitialApiAddInterstitial
     */
    readonly interstitialCreateDto: InterstitialCreateDto
}

/**
 * Request parameters for deleteInterstitial operation in InterstitialApi.
 * @export
 * @interface InterstitialApiDeleteInterstitialRequest
 */
export interface InterstitialApiDeleteInterstitialRequest {
    /**
     * 
     * @type {number}
     * @memberof InterstitialApiDeleteInterstitial
     */
    readonly id: number
}

/**
 * Request parameters for getActive operation in InterstitialApi.
 * @export
 * @interface InterstitialApiGetActiveRequest
 */
export interface InterstitialApiGetActiveRequest {
    /**
     * 
     * @type {string}
     * @memberof InterstitialApiGetActive
     */
    readonly xAppVersion: string
}

/**
 * Request parameters for getAllInterstitials operation in InterstitialApi.
 * @export
 * @interface InterstitialApiGetAllInterstitialsRequest
 */
export interface InterstitialApiGetAllInterstitialsRequest {
    /**
     * 
     * @type {number}
     * @memberof InterstitialApiGetAllInterstitials
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof InterstitialApiGetAllInterstitials
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof InterstitialApiGetAllInterstitials
     */
    readonly sort?: string

    /**
     * 
     * @type {string}
     * @memberof InterstitialApiGetAllInterstitials
     */
    readonly search?: string
}

/**
 * Request parameters for getInterstitial operation in InterstitialApi.
 * @export
 * @interface InterstitialApiGetInterstitialRequest
 */
export interface InterstitialApiGetInterstitialRequest {
    /**
     * 
     * @type {number}
     * @memberof InterstitialApiGetInterstitial
     */
    readonly id: number
}

/**
 * Request parameters for updateInterstitial operation in InterstitialApi.
 * @export
 * @interface InterstitialApiUpdateInterstitialRequest
 */
export interface InterstitialApiUpdateInterstitialRequest {
    /**
     * 
     * @type {number}
     * @memberof InterstitialApiUpdateInterstitial
     */
    readonly id: number

    /**
     * 
     * @type {InterstitialUpdateDto}
     * @memberof InterstitialApiUpdateInterstitial
     */
    readonly interstitialUpdateDto: InterstitialUpdateDto
}

/**
 * InterstitialApi - object-oriented interface
 * @export
 * @class InterstitialApi
 * @extends {BaseAPI}
 */
export class InterstitialApi extends BaseAPI {
    /**
     * 
     * @param {InterstitialApiAddInterstitialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterstitialApi
     */
    public addInterstitial(requestParameters: InterstitialApiAddInterstitialRequest, options?: RawAxiosRequestConfig) {
        return InterstitialApiFp(this.configuration).addInterstitial(requestParameters.interstitialCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterstitialApiDeleteInterstitialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterstitialApi
     */
    public deleteInterstitial(requestParameters: InterstitialApiDeleteInterstitialRequest, options?: RawAxiosRequestConfig) {
        return InterstitialApiFp(this.configuration).deleteInterstitial(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterstitialApiGetActiveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterstitialApi
     */
    public getActive(requestParameters: InterstitialApiGetActiveRequest, options?: RawAxiosRequestConfig) {
        return InterstitialApiFp(this.configuration).getActive(requestParameters.xAppVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterstitialApiGetAllInterstitialsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterstitialApi
     */
    public getAllInterstitials(requestParameters: InterstitialApiGetAllInterstitialsRequest = {}, options?: RawAxiosRequestConfig) {
        return InterstitialApiFp(this.configuration).getAllInterstitials(requestParameters.page, requestParameters.limit, requestParameters.sort, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterstitialApiGetInterstitialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterstitialApi
     */
    public getInterstitial(requestParameters: InterstitialApiGetInterstitialRequest, options?: RawAxiosRequestConfig) {
        return InterstitialApiFp(this.configuration).getInterstitial(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterstitialApi
     */
    public getInterstitialCount(options?: RawAxiosRequestConfig) {
        return InterstitialApiFp(this.configuration).getInterstitialCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InterstitialApiUpdateInterstitialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterstitialApi
     */
    public updateInterstitial(requestParameters: InterstitialApiUpdateInterstitialRequest, options?: RawAxiosRequestConfig) {
        return InterstitialApiFp(this.configuration).updateInterstitial(requestParameters.id, requestParameters.interstitialUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MarketingOptInApi - axios parameter creator
 * @export
 */
export const MarketingOptInApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {EmailDto} emailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeEmail: async (emailDto: EmailDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailDto' is not null or undefined
            assertParamExists('subscribeEmail', 'emailDto', emailDto)
            const localVarPath = `/api/opt-in/subscribe-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SmsOptInSubscribeDto} smsOptInSubscribeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeSms: async (smsOptInSubscribeDto: SmsOptInSubscribeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'smsOptInSubscribeDto' is not null or undefined
            assertParamExists('subscribeSms', 'smsOptInSubscribeDto', smsOptInSubscribeDto)
            const localVarPath = `/api/opt-in/subscribe-sms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(smsOptInSubscribeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MarketingOptInApi - functional programming interface
 * @export
 */
export const MarketingOptInApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MarketingOptInApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {EmailDto} emailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribeEmail(emailDto: EmailDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscribeEmail(emailDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MarketingOptInApi.subscribeEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SmsOptInSubscribeDto} smsOptInSubscribeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribeSms(smsOptInSubscribeDto: SmsOptInSubscribeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscribeSms(smsOptInSubscribeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MarketingOptInApi.subscribeSms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MarketingOptInApi - factory interface
 * @export
 */
export const MarketingOptInApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MarketingOptInApiFp(configuration)
    return {
        /**
         * 
         * @param {MarketingOptInApiSubscribeEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeEmail(requestParameters: MarketingOptInApiSubscribeEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.subscribeEmail(requestParameters.emailDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MarketingOptInApiSubscribeSmsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeSms(requestParameters: MarketingOptInApiSubscribeSmsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.subscribeSms(requestParameters.smsOptInSubscribeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for subscribeEmail operation in MarketingOptInApi.
 * @export
 * @interface MarketingOptInApiSubscribeEmailRequest
 */
export interface MarketingOptInApiSubscribeEmailRequest {
    /**
     * 
     * @type {EmailDto}
     * @memberof MarketingOptInApiSubscribeEmail
     */
    readonly emailDto: EmailDto
}

/**
 * Request parameters for subscribeSms operation in MarketingOptInApi.
 * @export
 * @interface MarketingOptInApiSubscribeSmsRequest
 */
export interface MarketingOptInApiSubscribeSmsRequest {
    /**
     * 
     * @type {SmsOptInSubscribeDto}
     * @memberof MarketingOptInApiSubscribeSms
     */
    readonly smsOptInSubscribeDto: SmsOptInSubscribeDto
}

/**
 * MarketingOptInApi - object-oriented interface
 * @export
 * @class MarketingOptInApi
 * @extends {BaseAPI}
 */
export class MarketingOptInApi extends BaseAPI {
    /**
     * 
     * @param {MarketingOptInApiSubscribeEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketingOptInApi
     */
    public subscribeEmail(requestParameters: MarketingOptInApiSubscribeEmailRequest, options?: RawAxiosRequestConfig) {
        return MarketingOptInApiFp(this.configuration).subscribeEmail(requestParameters.emailDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MarketingOptInApiSubscribeSmsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketingOptInApi
     */
    public subscribeSms(requestParameters: MarketingOptInApiSubscribeSmsRequest, options?: RawAxiosRequestConfig) {
        return MarketingOptInApiFp(this.configuration).subscribeSms(requestParameters.smsOptInSubscribeDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MediaApi - axios parameter creator
 * @export
 */
export const MediaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {MediaCreateDto} mediaCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMedia: async (mediaCreateDto: MediaCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mediaCreateDto' is not null or undefined
            assertParamExists('createMedia', 'mediaCreateDto', mediaCreateDto)
            const localVarPath = `/api/media`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mediaCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} limit 
         * @param {string} sort 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMedia: async (page: number, limit: number, sort: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getAllMedia', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getAllMedia', 'limit', limit)
            // verify required parameter 'sort' is not null or undefined
            assertParamExists('getAllMedia', 'sort', sort)
            const localVarPath = `/api/media`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMediaById', 'id', id)
            const localVarPath = `/api/media/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaCount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/media/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/api/media/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {MediaUpdateDto} mediaUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMediaById: async (id: number, mediaUpdateDto: MediaUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateMediaById', 'id', id)
            // verify required parameter 'mediaUpdateDto' is not null or undefined
            assertParamExists('updateMediaById', 'mediaUpdateDto', mediaUpdateDto)
            const localVarPath = `/api/media/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mediaUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/media/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MediaApi - functional programming interface
 * @export
 */
export const MediaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MediaApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {MediaCreateDto} mediaCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMedia(mediaCreateDto: MediaCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MediaDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMedia(mediaCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaApi.createMedia']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} limit 
         * @param {string} sort 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllMedia(page: number, limit: number, sort: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllMedia(page, limit, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaApi.getAllMedia']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMediaById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MediaDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMediaById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaApi.getMediaById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMediaCount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMediaCount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaApi.getMediaCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {MediaUpdateDto} mediaUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMediaById(id: number, mediaUpdateDto: MediaUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MediaDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMediaById(id, mediaUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaApi.updateMediaById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upload(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MediaUploadResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upload(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MediaApi.upload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MediaApi - factory interface
 * @export
 */
export const MediaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MediaApiFp(configuration)
    return {
        /**
         * 
         * @param {MediaApiCreateMediaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMedia(requestParameters: MediaApiCreateMediaRequest, options?: RawAxiosRequestConfig): AxiosPromise<MediaDto> {
            return localVarFp.createMedia(requestParameters.mediaCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MediaApiGetAllMediaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMedia(requestParameters: MediaApiGetAllMediaRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.getAllMedia(requestParameters.page, requestParameters.limit, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MediaApiGetMediaByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaById(requestParameters: MediaApiGetMediaByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<MediaDto> {
            return localVarFp.getMediaById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMediaCount(options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getMediaCount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MediaApiRemoveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(requestParameters: MediaApiRemoveRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.remove(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MediaApiUpdateMediaByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMediaById(requestParameters: MediaApiUpdateMediaByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<MediaDto> {
            return localVarFp.updateMediaById(requestParameters.id, requestParameters.mediaUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload(options?: RawAxiosRequestConfig): AxiosPromise<MediaUploadResponseDto> {
            return localVarFp.upload(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createMedia operation in MediaApi.
 * @export
 * @interface MediaApiCreateMediaRequest
 */
export interface MediaApiCreateMediaRequest {
    /**
     * 
     * @type {MediaCreateDto}
     * @memberof MediaApiCreateMedia
     */
    readonly mediaCreateDto: MediaCreateDto
}

/**
 * Request parameters for getAllMedia operation in MediaApi.
 * @export
 * @interface MediaApiGetAllMediaRequest
 */
export interface MediaApiGetAllMediaRequest {
    /**
     * 
     * @type {number}
     * @memberof MediaApiGetAllMedia
     */
    readonly page: number

    /**
     * 
     * @type {number}
     * @memberof MediaApiGetAllMedia
     */
    readonly limit: number

    /**
     * 
     * @type {string}
     * @memberof MediaApiGetAllMedia
     */
    readonly sort: string
}

/**
 * Request parameters for getMediaById operation in MediaApi.
 * @export
 * @interface MediaApiGetMediaByIdRequest
 */
export interface MediaApiGetMediaByIdRequest {
    /**
     * 
     * @type {number}
     * @memberof MediaApiGetMediaById
     */
    readonly id: number
}

/**
 * Request parameters for remove operation in MediaApi.
 * @export
 * @interface MediaApiRemoveRequest
 */
export interface MediaApiRemoveRequest {
    /**
     * 
     * @type {number}
     * @memberof MediaApiRemove
     */
    readonly id: number
}

/**
 * Request parameters for updateMediaById operation in MediaApi.
 * @export
 * @interface MediaApiUpdateMediaByIdRequest
 */
export interface MediaApiUpdateMediaByIdRequest {
    /**
     * 
     * @type {number}
     * @memberof MediaApiUpdateMediaById
     */
    readonly id: number

    /**
     * 
     * @type {MediaUpdateDto}
     * @memberof MediaApiUpdateMediaById
     */
    readonly mediaUpdateDto: MediaUpdateDto
}

/**
 * MediaApi - object-oriented interface
 * @export
 * @class MediaApi
 * @extends {BaseAPI}
 */
export class MediaApi extends BaseAPI {
    /**
     * 
     * @param {MediaApiCreateMediaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    public createMedia(requestParameters: MediaApiCreateMediaRequest, options?: RawAxiosRequestConfig) {
        return MediaApiFp(this.configuration).createMedia(requestParameters.mediaCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MediaApiGetAllMediaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    public getAllMedia(requestParameters: MediaApiGetAllMediaRequest, options?: RawAxiosRequestConfig) {
        return MediaApiFp(this.configuration).getAllMedia(requestParameters.page, requestParameters.limit, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MediaApiGetMediaByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    public getMediaById(requestParameters: MediaApiGetMediaByIdRequest, options?: RawAxiosRequestConfig) {
        return MediaApiFp(this.configuration).getMediaById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    public getMediaCount(options?: RawAxiosRequestConfig) {
        return MediaApiFp(this.configuration).getMediaCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MediaApiRemoveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    public remove(requestParameters: MediaApiRemoveRequest, options?: RawAxiosRequestConfig) {
        return MediaApiFp(this.configuration).remove(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MediaApiUpdateMediaByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    public updateMediaById(requestParameters: MediaApiUpdateMediaByIdRequest, options?: RawAxiosRequestConfig) {
        return MediaApiFp(this.configuration).updateMediaById(requestParameters.id, requestParameters.mediaUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    public upload(options?: RawAxiosRequestConfig) {
        return MediaApiFp(this.configuration).upload(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MessagesApi - axios parameter creator
 * @export
 */
export const MessagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {MessageCreateDto} messageCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMessage: async (messageCreateDto: MessageCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messageCreateDto' is not null or undefined
            assertParamExists('createMessage', 'messageCreateDto', messageCreateDto)
            const localVarPath = `/api/messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(messageCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} limit 
         * @param {string} sort 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMessages: async (page: number, limit: number, sort: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getAllMessages', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getAllMessages', 'limit', limit)
            // verify required parameter 'sort' is not null or undefined
            assertParamExists('getAllMessages', 'sort', sort)
            const localVarPath = `/api/messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageCount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/messages/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MessagesApi - functional programming interface
 * @export
 */
export const MessagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MessagesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {MessageCreateDto} messageCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMessage(messageCreateDto: MessageCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMessage(messageCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessagesApi.createMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} limit 
         * @param {string} sort 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllMessages(page: number, limit: number, sort: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MessageDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllMessages(page, limit, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessagesApi.getAllMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMessageCount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMessageCount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessagesApi.getMessageCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MessagesApi - factory interface
 * @export
 */
export const MessagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MessagesApiFp(configuration)
    return {
        /**
         * 
         * @param {MessagesApiCreateMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMessage(requestParameters: MessagesApiCreateMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<MessageDto> {
            return localVarFp.createMessage(requestParameters.messageCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MessagesApiGetAllMessagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMessages(requestParameters: MessagesApiGetAllMessagesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<MessageDto>> {
            return localVarFp.getAllMessages(requestParameters.page, requestParameters.limit, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageCount(options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getMessageCount(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createMessage operation in MessagesApi.
 * @export
 * @interface MessagesApiCreateMessageRequest
 */
export interface MessagesApiCreateMessageRequest {
    /**
     * 
     * @type {MessageCreateDto}
     * @memberof MessagesApiCreateMessage
     */
    readonly messageCreateDto: MessageCreateDto
}

/**
 * Request parameters for getAllMessages operation in MessagesApi.
 * @export
 * @interface MessagesApiGetAllMessagesRequest
 */
export interface MessagesApiGetAllMessagesRequest {
    /**
     * 
     * @type {number}
     * @memberof MessagesApiGetAllMessages
     */
    readonly page: number

    /**
     * 
     * @type {number}
     * @memberof MessagesApiGetAllMessages
     */
    readonly limit: number

    /**
     * 
     * @type {string}
     * @memberof MessagesApiGetAllMessages
     */
    readonly sort: string
}

/**
 * MessagesApi - object-oriented interface
 * @export
 * @class MessagesApi
 * @extends {BaseAPI}
 */
export class MessagesApi extends BaseAPI {
    /**
     * 
     * @param {MessagesApiCreateMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    public createMessage(requestParameters: MessagesApiCreateMessageRequest, options?: RawAxiosRequestConfig) {
        return MessagesApiFp(this.configuration).createMessage(requestParameters.messageCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MessagesApiGetAllMessagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    public getAllMessages(requestParameters: MessagesApiGetAllMessagesRequest, options?: RawAxiosRequestConfig) {
        return MessagesApiFp(this.configuration).getAllMessages(requestParameters.page, requestParameters.limit, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    public getMessageCount(options?: RawAxiosRequestConfig) {
        return MessagesApiFp(this.configuration).getMessageCount(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MoodLightApi - axios parameter creator
 * @export
 */
export const MoodLightApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 
         * @param {ExclusiveMoodLightCreateDto} exclusiveMoodLightCreateDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        createExclusiveMoodLight: async (exclusiveMoodLightCreateDto: ExclusiveMoodLightCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exclusiveMoodLightCreateDto' is not null or undefined
            assertParamExists('createExclusiveMoodLight', 'exclusiveMoodLightCreateDto', exclusiveMoodLightCreateDto)
            const localVarPath = `/api/mood-light/exclusive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exclusiveMoodLightCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} moodLightId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMoodLight: async (moodLightId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moodLightId' is not null or undefined
            assertParamExists('deleteMoodLight', 'moodLightId', moodLightId)
            const localVarPath = `/api/mood-light/{moodLightId}`
                .replace(`{${"moodLightId"}}`, encodeURIComponent(String(moodLightId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getActiveExclusiveMoodLights: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mood-light/exclusive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoodLightCreatorUsernamesBulk: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('getMoodLightCreatorUsernamesBulk', 'requestBody', requestBody)
            const localVarPath = `/api/mood-light/usernames`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<MoodLightUpdateDto>} moodLightUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMoodLight: async (moodLightUpdateDto: Array<MoodLightUpdateDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moodLightUpdateDto' is not null or undefined
            assertParamExists('updateMoodLight', 'moodLightUpdateDto', moodLightUpdateDto)
            const localVarPath = `/api/mood-light`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moodLightUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} moodLightId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useMoodLight: async (moodLightId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moodLightId' is not null or undefined
            assertParamExists('useMoodLight', 'moodLightId', moodLightId)
            const localVarPath = `/api/mood-light/{moodLightId}/use`
                .replace(`{${"moodLightId"}}`, encodeURIComponent(String(moodLightId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MoodLightApi - functional programming interface
 * @export
 */
export const MoodLightApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MoodLightApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {ExclusiveMoodLightCreateDto} exclusiveMoodLightCreateDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async createExclusiveMoodLight(exclusiveMoodLightCreateDto: ExclusiveMoodLightCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MoodLightDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createExclusiveMoodLight(exclusiveMoodLightCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MoodLightApi.createExclusiveMoodLight']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} moodLightId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMoodLight(moodLightId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMoodLight(moodLightId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MoodLightApi.deleteMoodLight']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getActiveExclusiveMoodLights(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExclusiveMoodLightDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveExclusiveMoodLights(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MoodLightApi.getActiveExclusiveMoodLights']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMoodLightCreatorUsernamesBulk(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MoodLightCreatorUsernamesDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMoodLightCreatorUsernamesBulk(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MoodLightApi.getMoodLightCreatorUsernamesBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<MoodLightUpdateDto>} moodLightUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMoodLight(moodLightUpdateDto: Array<MoodLightUpdateDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MoodLight>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMoodLight(moodLightUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MoodLightApi.updateMoodLight']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} moodLightId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async useMoodLight(moodLightId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.useMoodLight(moodLightId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MoodLightApi.useMoodLight']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MoodLightApi - factory interface
 * @export
 */
export const MoodLightApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MoodLightApiFp(configuration)
    return {
        /**
         * 
         * @summary 
         * @param {MoodLightApiCreateExclusiveMoodLightRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        createExclusiveMoodLight(requestParameters: MoodLightApiCreateExclusiveMoodLightRequest, options?: RawAxiosRequestConfig): AxiosPromise<MoodLightDto> {
            return localVarFp.createExclusiveMoodLight(requestParameters.exclusiveMoodLightCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MoodLightApiDeleteMoodLightRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMoodLight(requestParameters: MoodLightApiDeleteMoodLightRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteMoodLight(requestParameters.moodLightId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getActiveExclusiveMoodLights(options?: RawAxiosRequestConfig): AxiosPromise<Array<ExclusiveMoodLightDto>> {
            return localVarFp.getActiveExclusiveMoodLights(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MoodLightApiGetMoodLightCreatorUsernamesBulkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoodLightCreatorUsernamesBulk(requestParameters: MoodLightApiGetMoodLightCreatorUsernamesBulkRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<MoodLightCreatorUsernamesDto>> {
            return localVarFp.getMoodLightCreatorUsernamesBulk(requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MoodLightApiUpdateMoodLightRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMoodLight(requestParameters: MoodLightApiUpdateMoodLightRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<MoodLight>> {
            return localVarFp.updateMoodLight(requestParameters.moodLightUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MoodLightApiUseMoodLightRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        useMoodLight(requestParameters: MoodLightApiUseMoodLightRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.useMoodLight(requestParameters.moodLightId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createExclusiveMoodLight operation in MoodLightApi.
 * @export
 * @interface MoodLightApiCreateExclusiveMoodLightRequest
 */
export interface MoodLightApiCreateExclusiveMoodLightRequest {
    /**
     * 
     * @type {ExclusiveMoodLightCreateDto}
     * @memberof MoodLightApiCreateExclusiveMoodLight
     */
    readonly exclusiveMoodLightCreateDto: ExclusiveMoodLightCreateDto
}

/**
 * Request parameters for deleteMoodLight operation in MoodLightApi.
 * @export
 * @interface MoodLightApiDeleteMoodLightRequest
 */
export interface MoodLightApiDeleteMoodLightRequest {
    /**
     * 
     * @type {string}
     * @memberof MoodLightApiDeleteMoodLight
     */
    readonly moodLightId: string
}

/**
 * Request parameters for getMoodLightCreatorUsernamesBulk operation in MoodLightApi.
 * @export
 * @interface MoodLightApiGetMoodLightCreatorUsernamesBulkRequest
 */
export interface MoodLightApiGetMoodLightCreatorUsernamesBulkRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof MoodLightApiGetMoodLightCreatorUsernamesBulk
     */
    readonly requestBody: Array<string>
}

/**
 * Request parameters for updateMoodLight operation in MoodLightApi.
 * @export
 * @interface MoodLightApiUpdateMoodLightRequest
 */
export interface MoodLightApiUpdateMoodLightRequest {
    /**
     * 
     * @type {Array<MoodLightUpdateDto>}
     * @memberof MoodLightApiUpdateMoodLight
     */
    readonly moodLightUpdateDto: Array<MoodLightUpdateDto>
}

/**
 * Request parameters for useMoodLight operation in MoodLightApi.
 * @export
 * @interface MoodLightApiUseMoodLightRequest
 */
export interface MoodLightApiUseMoodLightRequest {
    /**
     * 
     * @type {string}
     * @memberof MoodLightApiUseMoodLight
     */
    readonly moodLightId: string
}

/**
 * MoodLightApi - object-oriented interface
 * @export
 * @class MoodLightApi
 * @extends {BaseAPI}
 */
export class MoodLightApi extends BaseAPI {
    /**
     * 
     * @summary 
     * @param {MoodLightApiCreateExclusiveMoodLightRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof MoodLightApi
     */
    public createExclusiveMoodLight(requestParameters: MoodLightApiCreateExclusiveMoodLightRequest, options?: RawAxiosRequestConfig) {
        return MoodLightApiFp(this.configuration).createExclusiveMoodLight(requestParameters.exclusiveMoodLightCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MoodLightApiDeleteMoodLightRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MoodLightApi
     */
    public deleteMoodLight(requestParameters: MoodLightApiDeleteMoodLightRequest, options?: RawAxiosRequestConfig) {
        return MoodLightApiFp(this.configuration).deleteMoodLight(requestParameters.moodLightId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof MoodLightApi
     */
    public getActiveExclusiveMoodLights(options?: RawAxiosRequestConfig) {
        return MoodLightApiFp(this.configuration).getActiveExclusiveMoodLights(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MoodLightApiGetMoodLightCreatorUsernamesBulkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MoodLightApi
     */
    public getMoodLightCreatorUsernamesBulk(requestParameters: MoodLightApiGetMoodLightCreatorUsernamesBulkRequest, options?: RawAxiosRequestConfig) {
        return MoodLightApiFp(this.configuration).getMoodLightCreatorUsernamesBulk(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MoodLightApiUpdateMoodLightRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MoodLightApi
     */
    public updateMoodLight(requestParameters: MoodLightApiUpdateMoodLightRequest, options?: RawAxiosRequestConfig) {
        return MoodLightApiFp(this.configuration).updateMoodLight(requestParameters.moodLightUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MoodLightApiUseMoodLightRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MoodLightApi
     */
    public useMoodLight(requestParameters: MoodLightApiUseMoodLightRequest, options?: RawAxiosRequestConfig) {
        return MoodLightApiFp(this.configuration).useMoodLight(requestParameters.moodLightId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MoodLightsApi - axios parameter creator
 * @export
 */
export const MoodLightsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {GetMoodLightsOrderEnum} [order] 
         * @param {GetMoodLightsSortEnum} [sort] 
         * @param {MoodLightCategory} [category] 
         * @param {string} [serialNumber] 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoodLights: async (page?: number, size?: number, order?: GetMoodLightsOrderEnum, sort?: GetMoodLightsSortEnum, category?: MoodLightCategory, serialNumber?: string, ids?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/mood-lights`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (serialNumber !== undefined) {
                localVarQueryParameter['serialNumber'] = serialNumber;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} moodLightId 
         * @param {UpsertMoodLightDto} upsertMoodLightDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertMoodLight: async (moodLightId: string, upsertMoodLightDto: UpsertMoodLightDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moodLightId' is not null or undefined
            assertParamExists('upsertMoodLight', 'moodLightId', moodLightId)
            // verify required parameter 'upsertMoodLightDto' is not null or undefined
            assertParamExists('upsertMoodLight', 'upsertMoodLightDto', upsertMoodLightDto)
            const localVarPath = `/api/v1/mood-lights/{moodLightId}`
                .replace(`{${"moodLightId"}}`, encodeURIComponent(String(moodLightId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertMoodLightDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MoodLightsApi - functional programming interface
 * @export
 */
export const MoodLightsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MoodLightsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {GetMoodLightsOrderEnum} [order] 
         * @param {GetMoodLightsSortEnum} [sort] 
         * @param {MoodLightCategory} [category] 
         * @param {string} [serialNumber] 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMoodLights(page?: number, size?: number, order?: GetMoodLightsOrderEnum, sort?: GetMoodLightsSortEnum, category?: MoodLightCategory, serialNumber?: string, ids?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMoodLightsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMoodLights(page, size, order, sort, category, serialNumber, ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MoodLightsApi.getMoodLights']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} moodLightId 
         * @param {UpsertMoodLightDto} upsertMoodLightDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertMoodLight(moodLightId: string, upsertMoodLightDto: UpsertMoodLightDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MoodLightDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertMoodLight(moodLightId, upsertMoodLightDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MoodLightsApi.upsertMoodLight']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MoodLightsApi - factory interface
 * @export
 */
export const MoodLightsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MoodLightsApiFp(configuration)
    return {
        /**
         * 
         * @param {MoodLightsApiGetMoodLightsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoodLights(requestParameters: MoodLightsApiGetMoodLightsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetMoodLightsResponse> {
            return localVarFp.getMoodLights(requestParameters.page, requestParameters.size, requestParameters.order, requestParameters.sort, requestParameters.category, requestParameters.serialNumber, requestParameters.ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MoodLightsApiUpsertMoodLightRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertMoodLight(requestParameters: MoodLightsApiUpsertMoodLightRequest, options?: RawAxiosRequestConfig): AxiosPromise<MoodLightDto> {
            return localVarFp.upsertMoodLight(requestParameters.moodLightId, requestParameters.upsertMoodLightDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getMoodLights operation in MoodLightsApi.
 * @export
 * @interface MoodLightsApiGetMoodLightsRequest
 */
export interface MoodLightsApiGetMoodLightsRequest {
    /**
     * 
     * @type {number}
     * @memberof MoodLightsApiGetMoodLights
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof MoodLightsApiGetMoodLights
     */
    readonly size?: number

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof MoodLightsApiGetMoodLights
     */
    readonly order?: GetMoodLightsOrderEnum

    /**
     * 
     * @type {'created' | 'order'}
     * @memberof MoodLightsApiGetMoodLights
     */
    readonly sort?: GetMoodLightsSortEnum

    /**
     * 
     * @type {MoodLightCategory}
     * @memberof MoodLightsApiGetMoodLights
     */
    readonly category?: MoodLightCategory

    /**
     * 
     * @type {string}
     * @memberof MoodLightsApiGetMoodLights
     */
    readonly serialNumber?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof MoodLightsApiGetMoodLights
     */
    readonly ids?: Array<string>
}

/**
 * Request parameters for upsertMoodLight operation in MoodLightsApi.
 * @export
 * @interface MoodLightsApiUpsertMoodLightRequest
 */
export interface MoodLightsApiUpsertMoodLightRequest {
    /**
     * 
     * @type {string}
     * @memberof MoodLightsApiUpsertMoodLight
     */
    readonly moodLightId: string

    /**
     * 
     * @type {UpsertMoodLightDto}
     * @memberof MoodLightsApiUpsertMoodLight
     */
    readonly upsertMoodLightDto: UpsertMoodLightDto
}

/**
 * MoodLightsApi - object-oriented interface
 * @export
 * @class MoodLightsApi
 * @extends {BaseAPI}
 */
export class MoodLightsApi extends BaseAPI {
    /**
     * 
     * @param {MoodLightsApiGetMoodLightsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MoodLightsApi
     */
    public getMoodLights(requestParameters: MoodLightsApiGetMoodLightsRequest = {}, options?: RawAxiosRequestConfig) {
        return MoodLightsApiFp(this.configuration).getMoodLights(requestParameters.page, requestParameters.size, requestParameters.order, requestParameters.sort, requestParameters.category, requestParameters.serialNumber, requestParameters.ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MoodLightsApiUpsertMoodLightRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MoodLightsApi
     */
    public upsertMoodLight(requestParameters: MoodLightsApiUpsertMoodLightRequest, options?: RawAxiosRequestConfig) {
        return MoodLightsApiFp(this.configuration).upsertMoodLight(requestParameters.moodLightId, requestParameters.upsertMoodLightDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
  * @export
  * @enum {string}
  */
export enum GetMoodLightsOrderEnum {
    Asc = 'asc',
    Desc = 'desc'
}
/**
  * @export
  * @enum {string}
  */
export enum GetMoodLightsSortEnum {
    Created = 'created',
    Order = 'order'
}


/**
 * OtaApi - axios parameter creator
 * @export
 */
export const OtaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {OtaCreateDto} otaCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOta: async (otaCreateDto: OtaCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'otaCreateDto' is not null or undefined
            assertParamExists('createOta', 'otaCreateDto', otaCreateDto)
            const localVarPath = `/api/ota`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(otaCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportDownload: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('exportDownload', 'id', id)
            const localVarPath = `/api/ota/{id}/export`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} rolloutPercentage 
         * @param {number} [id] 
         * @param {string} [dateRange] 
         * @param {Array<string>} [models] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPreview: async (rolloutPercentage: number, id?: number, dateRange?: string, models?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rolloutPercentage' is not null or undefined
            assertParamExists('exportPreview', 'rolloutPercentage', rolloutPercentage)
            const localVarPath = `/api/ota/preview/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (rolloutPercentage !== undefined) {
                localVarQueryParameter['rolloutPercentage'] = rolloutPercentage;
            }

            if (dateRange !== undefined) {
                localVarQueryParameter['dateRange'] = dateRange;
            }

            if (models) {
                localVarQueryParameter['models'] = models;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} limit 
         * @param {string} sort 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOta: async (page: number, limit: number, sort: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getAllOta', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getAllOta', 'limit', limit)
            // verify required parameter 'sort' is not null or undefined
            assertParamExists('getAllOta', 'sort', sort)
            const localVarPath = `/api/ota`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [xAppVersion] 
         * @param {string} [serialNumber] 
         * @param {string} [model] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestOta: async (xAppVersion?: string, serialNumber?: string, model?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ota/latest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (serialNumber !== undefined) {
                localVarQueryParameter['serialNumber'] = serialNumber;
            }

            if (model !== undefined) {
                localVarQueryParameter['model'] = model;
            }

            if (xAppVersion != null) {
                localVarHeaderParameter['x-app-version'] = String(xAppVersion);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOtaById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOtaById', 'id', id)
            const localVarPath = `/api/ota/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOtaCount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ota/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OtaTrackingCreateDto} otaTrackingCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTracking: async (otaTrackingCreateDto: OtaTrackingCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'otaTrackingCreateDto' is not null or undefined
            assertParamExists('saveTracking', 'otaTrackingCreateDto', otaTrackingCreateDto)
            const localVarPath = `/api/ota/tracking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(otaTrackingCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {OtaUpdateDto} otaUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOtaById: async (id: number, otaUpdateDto: OtaUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOtaById', 'id', id)
            // verify required parameter 'otaUpdateDto' is not null or undefined
            assertParamExists('updateOtaById', 'otaUpdateDto', otaUpdateDto)
            const localVarPath = `/api/ota/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(otaUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OtaApi - functional programming interface
 * @export
 */
export const OtaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OtaApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {OtaCreateDto} otaCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOta(otaCreateDto: OtaCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OtaDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOta(otaCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OtaApi.createOta']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportDownload(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportDownload(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OtaApi.exportDownload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} rolloutPercentage 
         * @param {number} [id] 
         * @param {string} [dateRange] 
         * @param {Array<string>} [models] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportPreview(rolloutPercentage: number, id?: number, dateRange?: string, models?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportPreview(rolloutPercentage, id, dateRange, models, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OtaApi.exportPreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} limit 
         * @param {string} sort 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllOta(page: number, limit: number, sort: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OtaDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllOta(page, limit, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OtaApi.getAllOta']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [xAppVersion] 
         * @param {string} [serialNumber] 
         * @param {string} [model] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestOta(xAppVersion?: string, serialNumber?: string, model?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OtaLatestGetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestOta(xAppVersion, serialNumber, model, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OtaApi.getLatestOta']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOtaById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OtaInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOtaById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OtaApi.getOtaById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOtaCount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOtaCount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OtaApi.getOtaCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {OtaTrackingCreateDto} otaTrackingCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveTracking(otaTrackingCreateDto: OtaTrackingCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveTracking(otaTrackingCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OtaApi.saveTracking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {OtaUpdateDto} otaUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOtaById(id: number, otaUpdateDto: OtaUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OtaDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOtaById(id, otaUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OtaApi.updateOtaById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OtaApi - factory interface
 * @export
 */
export const OtaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OtaApiFp(configuration)
    return {
        /**
         * 
         * @param {OtaApiCreateOtaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOta(requestParameters: OtaApiCreateOtaRequest, options?: RawAxiosRequestConfig): AxiosPromise<OtaDto> {
            return localVarFp.createOta(requestParameters.otaCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OtaApiExportDownloadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportDownload(requestParameters: OtaApiExportDownloadRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.exportDownload(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OtaApiExportPreviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPreview(requestParameters: OtaApiExportPreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.exportPreview(requestParameters.rolloutPercentage, requestParameters.id, requestParameters.dateRange, requestParameters.models, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OtaApiGetAllOtaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOta(requestParameters: OtaApiGetAllOtaRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<OtaDto>> {
            return localVarFp.getAllOta(requestParameters.page, requestParameters.limit, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OtaApiGetLatestOtaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestOta(requestParameters: OtaApiGetLatestOtaRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OtaLatestGetResponse> {
            return localVarFp.getLatestOta(requestParameters.xAppVersion, requestParameters.serialNumber, requestParameters.model, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OtaApiGetOtaByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOtaById(requestParameters: OtaApiGetOtaByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<OtaInfoDto> {
            return localVarFp.getOtaById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOtaCount(options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getOtaCount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OtaApiSaveTrackingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTracking(requestParameters: OtaApiSaveTrackingRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.saveTracking(requestParameters.otaTrackingCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OtaApiUpdateOtaByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOtaById(requestParameters: OtaApiUpdateOtaByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<OtaDto> {
            return localVarFp.updateOtaById(requestParameters.id, requestParameters.otaUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createOta operation in OtaApi.
 * @export
 * @interface OtaApiCreateOtaRequest
 */
export interface OtaApiCreateOtaRequest {
    /**
     * 
     * @type {OtaCreateDto}
     * @memberof OtaApiCreateOta
     */
    readonly otaCreateDto: OtaCreateDto
}

/**
 * Request parameters for exportDownload operation in OtaApi.
 * @export
 * @interface OtaApiExportDownloadRequest
 */
export interface OtaApiExportDownloadRequest {
    /**
     * 
     * @type {number}
     * @memberof OtaApiExportDownload
     */
    readonly id: number
}

/**
 * Request parameters for exportPreview operation in OtaApi.
 * @export
 * @interface OtaApiExportPreviewRequest
 */
export interface OtaApiExportPreviewRequest {
    /**
     * 
     * @type {number}
     * @memberof OtaApiExportPreview
     */
    readonly rolloutPercentage: number

    /**
     * 
     * @type {number}
     * @memberof OtaApiExportPreview
     */
    readonly id?: number

    /**
     * 
     * @type {string}
     * @memberof OtaApiExportPreview
     */
    readonly dateRange?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof OtaApiExportPreview
     */
    readonly models?: Array<string>
}

/**
 * Request parameters for getAllOta operation in OtaApi.
 * @export
 * @interface OtaApiGetAllOtaRequest
 */
export interface OtaApiGetAllOtaRequest {
    /**
     * 
     * @type {number}
     * @memberof OtaApiGetAllOta
     */
    readonly page: number

    /**
     * 
     * @type {number}
     * @memberof OtaApiGetAllOta
     */
    readonly limit: number

    /**
     * 
     * @type {string}
     * @memberof OtaApiGetAllOta
     */
    readonly sort: string
}

/**
 * Request parameters for getLatestOta operation in OtaApi.
 * @export
 * @interface OtaApiGetLatestOtaRequest
 */
export interface OtaApiGetLatestOtaRequest {
    /**
     * 
     * @type {string}
     * @memberof OtaApiGetLatestOta
     */
    readonly xAppVersion?: string

    /**
     * 
     * @type {string}
     * @memberof OtaApiGetLatestOta
     */
    readonly serialNumber?: string

    /**
     * 
     * @type {string}
     * @memberof OtaApiGetLatestOta
     */
    readonly model?: string
}

/**
 * Request parameters for getOtaById operation in OtaApi.
 * @export
 * @interface OtaApiGetOtaByIdRequest
 */
export interface OtaApiGetOtaByIdRequest {
    /**
     * 
     * @type {number}
     * @memberof OtaApiGetOtaById
     */
    readonly id: number
}

/**
 * Request parameters for saveTracking operation in OtaApi.
 * @export
 * @interface OtaApiSaveTrackingRequest
 */
export interface OtaApiSaveTrackingRequest {
    /**
     * 
     * @type {OtaTrackingCreateDto}
     * @memberof OtaApiSaveTracking
     */
    readonly otaTrackingCreateDto: OtaTrackingCreateDto
}

/**
 * Request parameters for updateOtaById operation in OtaApi.
 * @export
 * @interface OtaApiUpdateOtaByIdRequest
 */
export interface OtaApiUpdateOtaByIdRequest {
    /**
     * 
     * @type {number}
     * @memberof OtaApiUpdateOtaById
     */
    readonly id: number

    /**
     * 
     * @type {OtaUpdateDto}
     * @memberof OtaApiUpdateOtaById
     */
    readonly otaUpdateDto: OtaUpdateDto
}

/**
 * OtaApi - object-oriented interface
 * @export
 * @class OtaApi
 * @extends {BaseAPI}
 */
export class OtaApi extends BaseAPI {
    /**
     * 
     * @param {OtaApiCreateOtaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OtaApi
     */
    public createOta(requestParameters: OtaApiCreateOtaRequest, options?: RawAxiosRequestConfig) {
        return OtaApiFp(this.configuration).createOta(requestParameters.otaCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OtaApiExportDownloadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OtaApi
     */
    public exportDownload(requestParameters: OtaApiExportDownloadRequest, options?: RawAxiosRequestConfig) {
        return OtaApiFp(this.configuration).exportDownload(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OtaApiExportPreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OtaApi
     */
    public exportPreview(requestParameters: OtaApiExportPreviewRequest, options?: RawAxiosRequestConfig) {
        return OtaApiFp(this.configuration).exportPreview(requestParameters.rolloutPercentage, requestParameters.id, requestParameters.dateRange, requestParameters.models, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OtaApiGetAllOtaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OtaApi
     */
    public getAllOta(requestParameters: OtaApiGetAllOtaRequest, options?: RawAxiosRequestConfig) {
        return OtaApiFp(this.configuration).getAllOta(requestParameters.page, requestParameters.limit, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OtaApiGetLatestOtaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OtaApi
     */
    public getLatestOta(requestParameters: OtaApiGetLatestOtaRequest = {}, options?: RawAxiosRequestConfig) {
        return OtaApiFp(this.configuration).getLatestOta(requestParameters.xAppVersion, requestParameters.serialNumber, requestParameters.model, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OtaApiGetOtaByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OtaApi
     */
    public getOtaById(requestParameters: OtaApiGetOtaByIdRequest, options?: RawAxiosRequestConfig) {
        return OtaApiFp(this.configuration).getOtaById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OtaApi
     */
    public getOtaCount(options?: RawAxiosRequestConfig) {
        return OtaApiFp(this.configuration).getOtaCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OtaApiSaveTrackingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OtaApi
     */
    public saveTracking(requestParameters: OtaApiSaveTrackingRequest, options?: RawAxiosRequestConfig) {
        return OtaApiFp(this.configuration).saveTracking(requestParameters.otaTrackingCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OtaApiUpdateOtaByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OtaApi
     */
    public updateOtaById(requestParameters: OtaApiUpdateOtaByIdRequest, options?: RawAxiosRequestConfig) {
        return OtaApiFp(this.configuration).updateOtaById(requestParameters.id, requestParameters.otaUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PeakDevicesApi - axios parameter creator
 * @export
 */
export const PeakDevicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} serialNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDevice: async (serialNumber: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serialNumber' is not null or undefined
            assertParamExists('deleteDevice', 'serialNumber', serialNumber)
            const localVarPath = `/api/peak-devices/{serialNumber}`
                .replace(`{${"serialNumber"}}`, encodeURIComponent(String(serialNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportDevices: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/peak-devices/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} limit 
         * @param {string} sort 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDevices: async (page: number, limit: number, sort: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getAllDevices', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getAllDevices', 'limit', limit)
            // verify required parameter 'sort' is not null or undefined
            assertParamExists('getAllDevices', 'sort', sort)
            const localVarPath = `/api/peak-devices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevice: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDevice', 'id', id)
            const localVarPath = `/api/peak-devices/by-id/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} serialNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceBySerialNumber: async (serialNumber: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serialNumber' is not null or undefined
            assertParamExists('getDeviceBySerialNumber', 'serialNumber', serialNumber)
            const localVarPath = `/api/peak-devices/{serialNumber}`
                .replace(`{${"serialNumber"}}`, encodeURIComponent(String(serialNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} page 
         * @param {number} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceLogs: async (id: number, page: number, limit: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDeviceLogs', 'id', id)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getDeviceLogs', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getDeviceLogs', 'limit', limit)
            const localVarPath = `/api/peak-devices/{id}/logs`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirmwareCount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/peak-devices/firmware-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogsCount: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLogsCount', 'id', id)
            const localVarPath = `/api/peak-devices/{id}/logs/count`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} serialNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaxOffset: async (serialNumber: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serialNumber' is not null or undefined
            assertParamExists('getMaxOffset', 'serialNumber', serialNumber)
            const localVarPath = `/api/peak-devices/{serialNumber}/logs/max-offset`
                .replace(`{${"serialNumber"}}`, encodeURIComponent(String(serialNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} search 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPeakDeviceCount: async (search: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'search' is not null or undefined
            assertParamExists('getPeakDeviceCount', 'search', search)
            const localVarPath = `/api/peak-devices/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get peak device last dab time.
         * @param {string} serialNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSyncStatus: async (serialNumber: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serialNumber' is not null or undefined
            assertParamExists('getSyncStatus', 'serialNumber', serialNumber)
            const localVarPath = `/api/peak-devices/{serialNumber}/last-dab-time`
                .replace(`{${"serialNumber"}}`, encodeURIComponent(String(serialNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} serialNumber 
         * @param {PeakDeviceIngestLogsDto} peakDeviceIngestLogsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ingestLogs: async (serialNumber: string, peakDeviceIngestLogsDto: PeakDeviceIngestLogsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serialNumber' is not null or undefined
            assertParamExists('ingestLogs', 'serialNumber', serialNumber)
            // verify required parameter 'peakDeviceIngestLogsDto' is not null or undefined
            assertParamExists('ingestLogs', 'peakDeviceIngestLogsDto', peakDeviceIngestLogsDto)
            const localVarPath = `/api/peak-devices/{serialNumber}/logs`
                .replace(`{${"serialNumber"}}`, encodeURIComponent(String(serialNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(peakDeviceIngestLogsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} serialNumber 
         * @param {PeakDeviceUpsertDto} peakDeviceUpsertDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDevice: async (serialNumber: string, peakDeviceUpsertDto: PeakDeviceUpsertDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serialNumber' is not null or undefined
            assertParamExists('putDevice', 'serialNumber', serialNumber)
            // verify required parameter 'peakDeviceUpsertDto' is not null or undefined
            assertParamExists('putDevice', 'peakDeviceUpsertDto', peakDeviceUpsertDto)
            const localVarPath = `/api/peak-devices/{serialNumber}`
                .replace(`{${"serialNumber"}}`, encodeURIComponent(String(serialNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(peakDeviceUpsertDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PeakDevicesApi - functional programming interface
 * @export
 */
export const PeakDevicesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PeakDevicesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} serialNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDevice(serialNumber: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDevice(serialNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PeakDevicesApi.deleteDevice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportDevices(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportDevices(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PeakDevicesApi.exportDevices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} limit 
         * @param {string} sort 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDevices(page: number, limit: number, sort: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PeakDevice>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDevices(page, limit, sort, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PeakDevicesApi.getAllDevices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDevice(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PeakDevice>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDevice(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PeakDevicesApi.getDevice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} serialNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeviceBySerialNumber(serialNumber: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PeakDeviceGetResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeviceBySerialNumber(serialNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PeakDevicesApi.getDeviceBySerialNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} page 
         * @param {number} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeviceLogs(id: number, page: number, limit: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeviceLogDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeviceLogs(id, page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PeakDevicesApi.getDeviceLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFirmwareCount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFirmwareCount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PeakDevicesApi.getFirmwareCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLogsCount(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLogsCount(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PeakDevicesApi.getLogsCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} serialNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMaxOffset(serialNumber: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OffsetMaxDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMaxOffset(serialNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PeakDevicesApi.getMaxOffset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} search 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPeakDeviceCount(search: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPeakDeviceCount(search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PeakDevicesApi.getPeakDeviceCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get peak device last dab time.
         * @param {string} serialNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSyncStatus(serialNumber: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSyncStatus(serialNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PeakDevicesApi.getSyncStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} serialNumber 
         * @param {PeakDeviceIngestLogsDto} peakDeviceIngestLogsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ingestLogs(serialNumber: string, peakDeviceIngestLogsDto: PeakDeviceIngestLogsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ingestLogs(serialNumber, peakDeviceIngestLogsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PeakDevicesApi.ingestLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} serialNumber 
         * @param {PeakDeviceUpsertDto} peakDeviceUpsertDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putDevice(serialNumber: string, peakDeviceUpsertDto: PeakDeviceUpsertDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PeakDevice>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putDevice(serialNumber, peakDeviceUpsertDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PeakDevicesApi.putDevice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PeakDevicesApi - factory interface
 * @export
 */
export const PeakDevicesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PeakDevicesApiFp(configuration)
    return {
        /**
         * 
         * @param {PeakDevicesApiDeleteDeviceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDevice(requestParameters: PeakDevicesApiDeleteDeviceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDevice(requestParameters.serialNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportDevices(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.exportDevices(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PeakDevicesApiGetAllDevicesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDevices(requestParameters: PeakDevicesApiGetAllDevicesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PeakDevice>> {
            return localVarFp.getAllDevices(requestParameters.page, requestParameters.limit, requestParameters.sort, requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PeakDevicesApiGetDeviceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevice(requestParameters: PeakDevicesApiGetDeviceRequest, options?: RawAxiosRequestConfig): AxiosPromise<PeakDevice> {
            return localVarFp.getDevice(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PeakDevicesApiGetDeviceBySerialNumberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceBySerialNumber(requestParameters: PeakDevicesApiGetDeviceBySerialNumberRequest, options?: RawAxiosRequestConfig): AxiosPromise<PeakDeviceGetResponseDto> {
            return localVarFp.getDeviceBySerialNumber(requestParameters.serialNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PeakDevicesApiGetDeviceLogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceLogs(requestParameters: PeakDevicesApiGetDeviceLogsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<DeviceLogDto>> {
            return localVarFp.getDeviceLogs(requestParameters.id, requestParameters.page, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirmwareCount(options?: RawAxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.getFirmwareCount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PeakDevicesApiGetLogsCountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogsCount(requestParameters: PeakDevicesApiGetLogsCountRequest, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getLogsCount(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PeakDevicesApiGetMaxOffsetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaxOffset(requestParameters: PeakDevicesApiGetMaxOffsetRequest, options?: RawAxiosRequestConfig): AxiosPromise<OffsetMaxDto> {
            return localVarFp.getMaxOffset(requestParameters.serialNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PeakDevicesApiGetPeakDeviceCountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPeakDeviceCount(requestParameters: PeakDevicesApiGetPeakDeviceCountRequest, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getPeakDeviceCount(requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get peak device last dab time.
         * @param {PeakDevicesApiGetSyncStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSyncStatus(requestParameters: PeakDevicesApiGetSyncStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<SyncStatusDto> {
            return localVarFp.getSyncStatus(requestParameters.serialNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PeakDevicesApiIngestLogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ingestLogs(requestParameters: PeakDevicesApiIngestLogsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.ingestLogs(requestParameters.serialNumber, requestParameters.peakDeviceIngestLogsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PeakDevicesApiPutDeviceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDevice(requestParameters: PeakDevicesApiPutDeviceRequest, options?: RawAxiosRequestConfig): AxiosPromise<PeakDevice> {
            return localVarFp.putDevice(requestParameters.serialNumber, requestParameters.peakDeviceUpsertDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteDevice operation in PeakDevicesApi.
 * @export
 * @interface PeakDevicesApiDeleteDeviceRequest
 */
export interface PeakDevicesApiDeleteDeviceRequest {
    /**
     * 
     * @type {string}
     * @memberof PeakDevicesApiDeleteDevice
     */
    readonly serialNumber: string
}

/**
 * Request parameters for getAllDevices operation in PeakDevicesApi.
 * @export
 * @interface PeakDevicesApiGetAllDevicesRequest
 */
export interface PeakDevicesApiGetAllDevicesRequest {
    /**
     * 
     * @type {number}
     * @memberof PeakDevicesApiGetAllDevices
     */
    readonly page: number

    /**
     * 
     * @type {number}
     * @memberof PeakDevicesApiGetAllDevices
     */
    readonly limit: number

    /**
     * 
     * @type {string}
     * @memberof PeakDevicesApiGetAllDevices
     */
    readonly sort: string

    /**
     * 
     * @type {string}
     * @memberof PeakDevicesApiGetAllDevices
     */
    readonly search?: string
}

/**
 * Request parameters for getDevice operation in PeakDevicesApi.
 * @export
 * @interface PeakDevicesApiGetDeviceRequest
 */
export interface PeakDevicesApiGetDeviceRequest {
    /**
     * 
     * @type {number}
     * @memberof PeakDevicesApiGetDevice
     */
    readonly id: number
}

/**
 * Request parameters for getDeviceBySerialNumber operation in PeakDevicesApi.
 * @export
 * @interface PeakDevicesApiGetDeviceBySerialNumberRequest
 */
export interface PeakDevicesApiGetDeviceBySerialNumberRequest {
    /**
     * 
     * @type {string}
     * @memberof PeakDevicesApiGetDeviceBySerialNumber
     */
    readonly serialNumber: string
}

/**
 * Request parameters for getDeviceLogs operation in PeakDevicesApi.
 * @export
 * @interface PeakDevicesApiGetDeviceLogsRequest
 */
export interface PeakDevicesApiGetDeviceLogsRequest {
    /**
     * 
     * @type {number}
     * @memberof PeakDevicesApiGetDeviceLogs
     */
    readonly id: number

    /**
     * 
     * @type {number}
     * @memberof PeakDevicesApiGetDeviceLogs
     */
    readonly page: number

    /**
     * 
     * @type {number}
     * @memberof PeakDevicesApiGetDeviceLogs
     */
    readonly limit: number
}

/**
 * Request parameters for getLogsCount operation in PeakDevicesApi.
 * @export
 * @interface PeakDevicesApiGetLogsCountRequest
 */
export interface PeakDevicesApiGetLogsCountRequest {
    /**
     * 
     * @type {number}
     * @memberof PeakDevicesApiGetLogsCount
     */
    readonly id: number
}

/**
 * Request parameters for getMaxOffset operation in PeakDevicesApi.
 * @export
 * @interface PeakDevicesApiGetMaxOffsetRequest
 */
export interface PeakDevicesApiGetMaxOffsetRequest {
    /**
     * 
     * @type {string}
     * @memberof PeakDevicesApiGetMaxOffset
     */
    readonly serialNumber: string
}

/**
 * Request parameters for getPeakDeviceCount operation in PeakDevicesApi.
 * @export
 * @interface PeakDevicesApiGetPeakDeviceCountRequest
 */
export interface PeakDevicesApiGetPeakDeviceCountRequest {
    /**
     * 
     * @type {string}
     * @memberof PeakDevicesApiGetPeakDeviceCount
     */
    readonly search: string
}

/**
 * Request parameters for getSyncStatus operation in PeakDevicesApi.
 * @export
 * @interface PeakDevicesApiGetSyncStatusRequest
 */
export interface PeakDevicesApiGetSyncStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof PeakDevicesApiGetSyncStatus
     */
    readonly serialNumber: string
}

/**
 * Request parameters for ingestLogs operation in PeakDevicesApi.
 * @export
 * @interface PeakDevicesApiIngestLogsRequest
 */
export interface PeakDevicesApiIngestLogsRequest {
    /**
     * 
     * @type {string}
     * @memberof PeakDevicesApiIngestLogs
     */
    readonly serialNumber: string

    /**
     * 
     * @type {PeakDeviceIngestLogsDto}
     * @memberof PeakDevicesApiIngestLogs
     */
    readonly peakDeviceIngestLogsDto: PeakDeviceIngestLogsDto
}

/**
 * Request parameters for putDevice operation in PeakDevicesApi.
 * @export
 * @interface PeakDevicesApiPutDeviceRequest
 */
export interface PeakDevicesApiPutDeviceRequest {
    /**
     * 
     * @type {string}
     * @memberof PeakDevicesApiPutDevice
     */
    readonly serialNumber: string

    /**
     * 
     * @type {PeakDeviceUpsertDto}
     * @memberof PeakDevicesApiPutDevice
     */
    readonly peakDeviceUpsertDto: PeakDeviceUpsertDto
}

/**
 * PeakDevicesApi - object-oriented interface
 * @export
 * @class PeakDevicesApi
 * @extends {BaseAPI}
 */
export class PeakDevicesApi extends BaseAPI {
    /**
     * 
     * @param {PeakDevicesApiDeleteDeviceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeakDevicesApi
     */
    public deleteDevice(requestParameters: PeakDevicesApiDeleteDeviceRequest, options?: RawAxiosRequestConfig) {
        return PeakDevicesApiFp(this.configuration).deleteDevice(requestParameters.serialNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeakDevicesApi
     */
    public exportDevices(options?: RawAxiosRequestConfig) {
        return PeakDevicesApiFp(this.configuration).exportDevices(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PeakDevicesApiGetAllDevicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeakDevicesApi
     */
    public getAllDevices(requestParameters: PeakDevicesApiGetAllDevicesRequest, options?: RawAxiosRequestConfig) {
        return PeakDevicesApiFp(this.configuration).getAllDevices(requestParameters.page, requestParameters.limit, requestParameters.sort, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PeakDevicesApiGetDeviceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeakDevicesApi
     */
    public getDevice(requestParameters: PeakDevicesApiGetDeviceRequest, options?: RawAxiosRequestConfig) {
        return PeakDevicesApiFp(this.configuration).getDevice(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PeakDevicesApiGetDeviceBySerialNumberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeakDevicesApi
     */
    public getDeviceBySerialNumber(requestParameters: PeakDevicesApiGetDeviceBySerialNumberRequest, options?: RawAxiosRequestConfig) {
        return PeakDevicesApiFp(this.configuration).getDeviceBySerialNumber(requestParameters.serialNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PeakDevicesApiGetDeviceLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeakDevicesApi
     */
    public getDeviceLogs(requestParameters: PeakDevicesApiGetDeviceLogsRequest, options?: RawAxiosRequestConfig) {
        return PeakDevicesApiFp(this.configuration).getDeviceLogs(requestParameters.id, requestParameters.page, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeakDevicesApi
     */
    public getFirmwareCount(options?: RawAxiosRequestConfig) {
        return PeakDevicesApiFp(this.configuration).getFirmwareCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PeakDevicesApiGetLogsCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeakDevicesApi
     */
    public getLogsCount(requestParameters: PeakDevicesApiGetLogsCountRequest, options?: RawAxiosRequestConfig) {
        return PeakDevicesApiFp(this.configuration).getLogsCount(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PeakDevicesApiGetMaxOffsetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeakDevicesApi
     */
    public getMaxOffset(requestParameters: PeakDevicesApiGetMaxOffsetRequest, options?: RawAxiosRequestConfig) {
        return PeakDevicesApiFp(this.configuration).getMaxOffset(requestParameters.serialNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PeakDevicesApiGetPeakDeviceCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeakDevicesApi
     */
    public getPeakDeviceCount(requestParameters: PeakDevicesApiGetPeakDeviceCountRequest, options?: RawAxiosRequestConfig) {
        return PeakDevicesApiFp(this.configuration).getPeakDeviceCount(requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get peak device last dab time.
     * @param {PeakDevicesApiGetSyncStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeakDevicesApi
     */
    public getSyncStatus(requestParameters: PeakDevicesApiGetSyncStatusRequest, options?: RawAxiosRequestConfig) {
        return PeakDevicesApiFp(this.configuration).getSyncStatus(requestParameters.serialNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PeakDevicesApiIngestLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeakDevicesApi
     */
    public ingestLogs(requestParameters: PeakDevicesApiIngestLogsRequest, options?: RawAxiosRequestConfig) {
        return PeakDevicesApiFp(this.configuration).ingestLogs(requestParameters.serialNumber, requestParameters.peakDeviceIngestLogsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PeakDevicesApiPutDeviceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeakDevicesApi
     */
    public putDevice(requestParameters: PeakDevicesApiPutDeviceRequest, options?: RawAxiosRequestConfig) {
        return PeakDevicesApiFp(this.configuration).putDevice(requestParameters.serialNumber, requestParameters.peakDeviceUpsertDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RehashApi - axios parameter creator
 * @export
 */
export const RehashApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [timezone] User timezone, to calculate favorite time to dab
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRehash: async (timezone?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/rehash`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RehashApi - functional programming interface
 * @export
 */
export const RehashApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RehashApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [timezone] User timezone, to calculate favorite time to dab
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRehash(timezone?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRehash200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRehash(timezone, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RehashApi.getRehash']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RehashApi - factory interface
 * @export
 */
export const RehashApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RehashApiFp(configuration)
    return {
        /**
         * 
         * @param {RehashApiGetRehashRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRehash(requestParameters: RehashApiGetRehashRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetRehash200Response> {
            return localVarFp.getRehash(requestParameters.timezone, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getRehash operation in RehashApi.
 * @export
 * @interface RehashApiGetRehashRequest
 */
export interface RehashApiGetRehashRequest {
    /**
     * User timezone, to calculate favorite time to dab
     * @type {string}
     * @memberof RehashApiGetRehash
     */
    readonly timezone?: string
}

/**
 * RehashApi - object-oriented interface
 * @export
 * @class RehashApi
 * @extends {BaseAPI}
 */
export class RehashApi extends BaseAPI {
    /**
     * 
     * @param {RehashApiGetRehashRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RehashApi
     */
    public getRehash(requestParameters: RehashApiGetRehashRequest = {}, options?: RawAxiosRequestConfig) {
        return RehashApiFp(this.configuration).getRehash(requestParameters.timezone, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RewardsApi - axios parameter creator
 * @export
 */
export const RewardsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralConfig: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/rewards/referrals/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralLink: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/rewards/referrals/link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferrals: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/rewards/referrals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RewardsApi - functional programming interface
 * @export
 */
export const RewardsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RewardsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReferralConfig(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferralConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferralConfig(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardsApi.getReferralConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReferralLink(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferraLinkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferralLink(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardsApi.getReferralLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReferrals(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReferralDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferrals(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardsApi.getReferrals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RewardsApi - factory interface
 * @export
 */
export const RewardsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RewardsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralConfig(options?: RawAxiosRequestConfig): AxiosPromise<ReferralConfigDto> {
            return localVarFp.getReferralConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralLink(options?: RawAxiosRequestConfig): AxiosPromise<ReferraLinkDto> {
            return localVarFp.getReferralLink(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferrals(options?: RawAxiosRequestConfig): AxiosPromise<Array<ReferralDto>> {
            return localVarFp.getReferrals(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RewardsApi - object-oriented interface
 * @export
 * @class RewardsApi
 * @extends {BaseAPI}
 */
export class RewardsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApi
     */
    public getReferralConfig(options?: RawAxiosRequestConfig) {
        return RewardsApiFp(this.configuration).getReferralConfig(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApi
     */
    public getReferralLink(options?: RawAxiosRequestConfig) {
        return RewardsApiFp(this.configuration).getReferralLink(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApi
     */
    public getReferrals(options?: RawAxiosRequestConfig) {
        return RewardsApiFp(this.configuration).getReferrals(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RoleApi - axios parameter creator
 * @export
 */
export const RoleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRoles: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RoleApi - functional programming interface
 * @export
 */
export const RoleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RoleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllRoles(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Role>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllRoles(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoleApi.getAllRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RoleApi - factory interface
 * @export
 */
export const RoleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RoleApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRoles(options?: RawAxiosRequestConfig): AxiosPromise<Array<Role>> {
            return localVarFp.getAllRoles(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RoleApi - object-oriented interface
 * @export
 * @class RoleApi
 * @extends {BaseAPI}
 */
export class RoleApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public getAllRoles(options?: RawAxiosRequestConfig) {
        return RoleApiFp(this.configuration).getAllRoles(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ShareApi - axios parameter creator
 * @export
 */
export const ShareApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {MoodLightCreateShareDto} moodLightCreateShareDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShareMoodLightId: async (moodLightCreateShareDto: MoodLightCreateShareDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moodLightCreateShareDto' is not null or undefined
            assertParamExists('createShareMoodLightId', 'moodLightCreateShareDto', moodLightCreateShareDto)
            const localVarPath = `/api/share/mood-light`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moodLightCreateShareDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {HeatProfileCreateShareDto} heatProfileCreateShareDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShareProfileId: async (heatProfileCreateShareDto: HeatProfileCreateShareDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'heatProfileCreateShareDto' is not null or undefined
            assertParamExists('createShareProfileId', 'heatProfileCreateShareDto', heatProfileCreateShareDto)
            const localVarPath = `/api/share`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(heatProfileCreateShareDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} shareMoodLightId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoodLightPreviewImg: async (shareMoodLightId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shareMoodLightId' is not null or undefined
            assertParamExists('getMoodLightPreviewImg', 'shareMoodLightId', shareMoodLightId)
            const localVarPath = `/api/share/mood-light/{shareMoodLightId}/preview`
                .replace(`{${"shareMoodLightId"}}`, encodeURIComponent(String(shareMoodLightId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} shareId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfilePreviewImg: async (shareId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shareId' is not null or undefined
            assertParamExists('getProfilePreviewImg', 'shareId', shareId)
            const localVarPath = `/api/share/{shareId}/preview`
                .replace(`{${"shareId"}}`, encodeURIComponent(String(shareId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} shareId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShareProfileLegacy: async (shareId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shareId' is not null or undefined
            assertParamExists('getShareProfileLegacy', 'shareId', shareId)
            const localVarPath = `/api/share`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (shareId !== undefined) {
                localVarQueryParameter['shareId'] = shareId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} shareId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShareSnapshot: async (shareId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shareId' is not null or undefined
            assertParamExists('getShareSnapshot', 'shareId', shareId)
            const localVarPath = `/api/share/snapshot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (shareId !== undefined) {
                localVarQueryParameter['shareId'] = shareId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} shareId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedHeatProfile: async (shareId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shareId' is not null or undefined
            assertParamExists('getSharedHeatProfile', 'shareId', shareId)
            const localVarPath = `/api/share/heat-profiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (shareId !== undefined) {
                localVarQueryParameter['shareId'] = shareId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} shareId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedMoodLight: async (shareId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shareId' is not null or undefined
            assertParamExists('getSharedMoodLight', 'shareId', shareId)
            const localVarPath = `/api/share/mood-light`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (shareId !== undefined) {
                localVarQueryParameter['shareId'] = shareId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} shareMoodLightId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShareMoodLightView: async (shareMoodLightId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shareMoodLightId' is not null or undefined
            assertParamExists('updateShareMoodLightView', 'shareMoodLightId', shareMoodLightId)
            const localVarPath = `/api/share/mood-light/{shareMoodLightId}/view`
                .replace(`{${"shareMoodLightId"}}`, encodeURIComponent(String(shareMoodLightId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShareApi - functional programming interface
 * @export
 */
export const ShareApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShareApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {MoodLightCreateShareDto} moodLightCreateShareDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createShareMoodLightId(moodLightCreateShareDto: MoodLightCreateShareDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MoodLightShareResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createShareMoodLightId(moodLightCreateShareDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShareApi.createShareMoodLightId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {HeatProfileCreateShareDto} heatProfileCreateShareDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createShareProfileId(heatProfileCreateShareDto: HeatProfileCreateShareDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HeatProfileShareResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createShareProfileId(heatProfileCreateShareDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShareApi.createShareProfileId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} shareMoodLightId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMoodLightPreviewImg(shareMoodLightId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMoodLightPreviewImg(shareMoodLightId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShareApi.getMoodLightPreviewImg']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} shareId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfilePreviewImg(shareId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfilePreviewImg(shareId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShareApi.getProfilePreviewImg']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} shareId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShareProfileLegacy(shareId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShareProfileLegacy(shareId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShareApi.getShareProfileLegacy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} shareId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShareSnapshot(shareId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShareSnapshotDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShareSnapshot(shareId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShareApi.getShareSnapshot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} shareId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSharedHeatProfile(shareId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HeatProfileSnapshotDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSharedHeatProfile(shareId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShareApi.getSharedHeatProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} shareId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSharedMoodLight(shareId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MoodLightDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSharedMoodLight(shareId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShareApi.getSharedMoodLight']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} shareMoodLightId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateShareMoodLightView(shareMoodLightId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateShareMoodLightView(shareMoodLightId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShareApi.updateShareMoodLightView']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ShareApi - factory interface
 * @export
 */
export const ShareApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShareApiFp(configuration)
    return {
        /**
         * 
         * @param {ShareApiCreateShareMoodLightIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShareMoodLightId(requestParameters: ShareApiCreateShareMoodLightIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<MoodLightShareResultDto> {
            return localVarFp.createShareMoodLightId(requestParameters.moodLightCreateShareDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ShareApiCreateShareProfileIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShareProfileId(requestParameters: ShareApiCreateShareProfileIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<HeatProfileShareResultDto> {
            return localVarFp.createShareProfileId(requestParameters.heatProfileCreateShareDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ShareApiGetMoodLightPreviewImgRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMoodLightPreviewImg(requestParameters: ShareApiGetMoodLightPreviewImgRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getMoodLightPreviewImg(requestParameters.shareMoodLightId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ShareApiGetProfilePreviewImgRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfilePreviewImg(requestParameters: ShareApiGetProfilePreviewImgRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getProfilePreviewImg(requestParameters.shareId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ShareApiGetShareProfileLegacyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShareProfileLegacy(requestParameters: ShareApiGetShareProfileLegacyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getShareProfileLegacy(requestParameters.shareId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ShareApiGetShareSnapshotRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShareSnapshot(requestParameters: ShareApiGetShareSnapshotRequest, options?: RawAxiosRequestConfig): AxiosPromise<ShareSnapshotDto> {
            return localVarFp.getShareSnapshot(requestParameters.shareId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ShareApiGetSharedHeatProfileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedHeatProfile(requestParameters: ShareApiGetSharedHeatProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<HeatProfileSnapshotDto> {
            return localVarFp.getSharedHeatProfile(requestParameters.shareId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ShareApiGetSharedMoodLightRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedMoodLight(requestParameters: ShareApiGetSharedMoodLightRequest, options?: RawAxiosRequestConfig): AxiosPromise<MoodLightDto> {
            return localVarFp.getSharedMoodLight(requestParameters.shareId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ShareApiUpdateShareMoodLightViewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShareMoodLightView(requestParameters: ShareApiUpdateShareMoodLightViewRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateShareMoodLightView(requestParameters.shareMoodLightId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createShareMoodLightId operation in ShareApi.
 * @export
 * @interface ShareApiCreateShareMoodLightIdRequest
 */
export interface ShareApiCreateShareMoodLightIdRequest {
    /**
     * 
     * @type {MoodLightCreateShareDto}
     * @memberof ShareApiCreateShareMoodLightId
     */
    readonly moodLightCreateShareDto: MoodLightCreateShareDto
}

/**
 * Request parameters for createShareProfileId operation in ShareApi.
 * @export
 * @interface ShareApiCreateShareProfileIdRequest
 */
export interface ShareApiCreateShareProfileIdRequest {
    /**
     * 
     * @type {HeatProfileCreateShareDto}
     * @memberof ShareApiCreateShareProfileId
     */
    readonly heatProfileCreateShareDto: HeatProfileCreateShareDto
}

/**
 * Request parameters for getMoodLightPreviewImg operation in ShareApi.
 * @export
 * @interface ShareApiGetMoodLightPreviewImgRequest
 */
export interface ShareApiGetMoodLightPreviewImgRequest {
    /**
     * 
     * @type {string}
     * @memberof ShareApiGetMoodLightPreviewImg
     */
    readonly shareMoodLightId: string
}

/**
 * Request parameters for getProfilePreviewImg operation in ShareApi.
 * @export
 * @interface ShareApiGetProfilePreviewImgRequest
 */
export interface ShareApiGetProfilePreviewImgRequest {
    /**
     * 
     * @type {string}
     * @memberof ShareApiGetProfilePreviewImg
     */
    readonly shareId: string
}

/**
 * Request parameters for getShareProfileLegacy operation in ShareApi.
 * @export
 * @interface ShareApiGetShareProfileLegacyRequest
 */
export interface ShareApiGetShareProfileLegacyRequest {
    /**
     * 
     * @type {string}
     * @memberof ShareApiGetShareProfileLegacy
     */
    readonly shareId: string
}

/**
 * Request parameters for getShareSnapshot operation in ShareApi.
 * @export
 * @interface ShareApiGetShareSnapshotRequest
 */
export interface ShareApiGetShareSnapshotRequest {
    /**
     * 
     * @type {string}
     * @memberof ShareApiGetShareSnapshot
     */
    readonly shareId: string
}

/**
 * Request parameters for getSharedHeatProfile operation in ShareApi.
 * @export
 * @interface ShareApiGetSharedHeatProfileRequest
 */
export interface ShareApiGetSharedHeatProfileRequest {
    /**
     * 
     * @type {string}
     * @memberof ShareApiGetSharedHeatProfile
     */
    readonly shareId: string
}

/**
 * Request parameters for getSharedMoodLight operation in ShareApi.
 * @export
 * @interface ShareApiGetSharedMoodLightRequest
 */
export interface ShareApiGetSharedMoodLightRequest {
    /**
     * 
     * @type {string}
     * @memberof ShareApiGetSharedMoodLight
     */
    readonly shareId: string
}

/**
 * Request parameters for updateShareMoodLightView operation in ShareApi.
 * @export
 * @interface ShareApiUpdateShareMoodLightViewRequest
 */
export interface ShareApiUpdateShareMoodLightViewRequest {
    /**
     * 
     * @type {string}
     * @memberof ShareApiUpdateShareMoodLightView
     */
    readonly shareMoodLightId: string
}

/**
 * ShareApi - object-oriented interface
 * @export
 * @class ShareApi
 * @extends {BaseAPI}
 */
export class ShareApi extends BaseAPI {
    /**
     * 
     * @param {ShareApiCreateShareMoodLightIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShareApi
     */
    public createShareMoodLightId(requestParameters: ShareApiCreateShareMoodLightIdRequest, options?: RawAxiosRequestConfig) {
        return ShareApiFp(this.configuration).createShareMoodLightId(requestParameters.moodLightCreateShareDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShareApiCreateShareProfileIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShareApi
     */
    public createShareProfileId(requestParameters: ShareApiCreateShareProfileIdRequest, options?: RawAxiosRequestConfig) {
        return ShareApiFp(this.configuration).createShareProfileId(requestParameters.heatProfileCreateShareDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShareApiGetMoodLightPreviewImgRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShareApi
     */
    public getMoodLightPreviewImg(requestParameters: ShareApiGetMoodLightPreviewImgRequest, options?: RawAxiosRequestConfig) {
        return ShareApiFp(this.configuration).getMoodLightPreviewImg(requestParameters.shareMoodLightId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShareApiGetProfilePreviewImgRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShareApi
     */
    public getProfilePreviewImg(requestParameters: ShareApiGetProfilePreviewImgRequest, options?: RawAxiosRequestConfig) {
        return ShareApiFp(this.configuration).getProfilePreviewImg(requestParameters.shareId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShareApiGetShareProfileLegacyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShareApi
     */
    public getShareProfileLegacy(requestParameters: ShareApiGetShareProfileLegacyRequest, options?: RawAxiosRequestConfig) {
        return ShareApiFp(this.configuration).getShareProfileLegacy(requestParameters.shareId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShareApiGetShareSnapshotRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShareApi
     */
    public getShareSnapshot(requestParameters: ShareApiGetShareSnapshotRequest, options?: RawAxiosRequestConfig) {
        return ShareApiFp(this.configuration).getShareSnapshot(requestParameters.shareId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShareApiGetSharedHeatProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShareApi
     */
    public getSharedHeatProfile(requestParameters: ShareApiGetSharedHeatProfileRequest, options?: RawAxiosRequestConfig) {
        return ShareApiFp(this.configuration).getSharedHeatProfile(requestParameters.shareId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShareApiGetSharedMoodLightRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShareApi
     */
    public getSharedMoodLight(requestParameters: ShareApiGetSharedMoodLightRequest, options?: RawAxiosRequestConfig) {
        return ShareApiFp(this.configuration).getSharedMoodLight(requestParameters.shareId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShareApiUpdateShareMoodLightViewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShareApi
     */
    public updateShareMoodLightView(requestParameters: ShareApiUpdateShareMoodLightViewRequest, options?: RawAxiosRequestConfig) {
        return ShareApiFp(this.configuration).updateShareMoodLightView(requestParameters.shareMoodLightId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SupportApi - axios parameter creator
 * @export
 */
export const SupportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateSupportTicketDto} createSupportTicketDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitTicket: async (createSupportTicketDto: CreateSupportTicketDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSupportTicketDto' is not null or undefined
            assertParamExists('submitTicket', 'createSupportTicketDto', createSupportTicketDto)
            const localVarPath = `/api/support`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSupportTicketDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupportApi - functional programming interface
 * @export
 */
export const SupportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateSupportTicketDto} createSupportTicketDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitTicket(createSupportTicketDto: CreateSupportTicketDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitTicket(createSupportTicketDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.submitTicket']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SupportApi - factory interface
 * @export
 */
export const SupportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupportApiFp(configuration)
    return {
        /**
         * 
         * @param {SupportApiSubmitTicketRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitTicket(requestParameters: SupportApiSubmitTicketRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.submitTicket(requestParameters.createSupportTicketDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for submitTicket operation in SupportApi.
 * @export
 * @interface SupportApiSubmitTicketRequest
 */
export interface SupportApiSubmitTicketRequest {
    /**
     * 
     * @type {CreateSupportTicketDto}
     * @memberof SupportApiSubmitTicket
     */
    readonly createSupportTicketDto: CreateSupportTicketDto
}

/**
 * SupportApi - object-oriented interface
 * @export
 * @class SupportApi
 * @extends {BaseAPI}
 */
export class SupportApi extends BaseAPI {
    /**
     * 
     * @param {SupportApiSubmitTicketRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public submitTicket(requestParameters: SupportApiSubmitTicketRequest, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).submitTicket(requestParameters.createSupportTicketDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {UserAppleAuthDto} userAppleAuthDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appleAuth: async (userAppleAuthDto: UserAppleAuthDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAppleAuthDto' is not null or undefined
            assertParamExists('appleAuth', 'userAppleAuthDto', userAppleAuthDto)
            const localVarPath = `/api/users/login/apple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userAppleAuthDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AppleAuthCallbackDto} appleAuthCallbackDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appleCallback: async (appleAuthCallbackDto: AppleAuthCallbackDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'appleAuthCallbackDto' is not null or undefined
            assertParamExists('appleCallback', 'appleAuthCallbackDto', appleAuthCallbackDto)
            const localVarPath = `/api/users/login/apple/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appleAuthCallbackDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetUserByIdIdParameter} id 
         * @param {string} generatedUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkUserPair: async (id: GetUserByIdIdParameter, generatedUserId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('checkUserPair', 'id', id)
            // verify required parameter 'generatedUserId' is not null or undefined
            assertParamExists('checkUserPair', 'generatedUserId', generatedUserId)
            const localVarPath = `/api/users/{id}/user-pair`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (generatedUserId !== undefined) {
                localVarQueryParameter['generatedUserId'] = generatedUserId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetUserByIdIdParameter} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserById: async (id: GetUserByIdIdParameter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteUserById', 'id', id)
            const localVarPath = `/api/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportUsers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetUserByIdIdParameter} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgreements: async (id: GetUserByIdIdParameter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAgreements', 'id', id)
            const localVarPath = `/api/users/{id}/agreements`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} limit 
         * @param {string} sort 
         * @param {string} search 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsers: async (page: number, limit: number, sort: string, search: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getAllUsers', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getAllUsers', 'limit', limit)
            // verify required parameter 'sort' is not null or undefined
            assertParamExists('getAllUsers', 'sort', sort)
            // verify required parameter 'search' is not null or undefined
            assertParamExists('getAllUsers', 'search', search)
            const localVarPath = `/api/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetUserByIdIdParameter} id 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getCustomMoodLights: async (id: GetUserByIdIdParameter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCustomMoodLights', 'id', id)
            const localVarPath = `/api/users/{id}/mood-lights`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user dab summary.
         * @param {GetUserByIdIdParameter} id 
         * @param {TimeFilterPeriod} period 
         * @param {string} timezone 
         * @param {number} [unitId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDabHistorySummary: async (id: GetUserByIdIdParameter, period: TimeFilterPeriod, timezone: string, unitId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDabHistorySummary', 'id', id)
            // verify required parameter 'period' is not null or undefined
            assertParamExists('getDabHistorySummary', 'period', period)
            // verify required parameter 'timezone' is not null or undefined
            assertParamExists('getDabHistorySummary', 'timezone', timezone)
            const localVarPath = `/api/users/{id}/dab-history`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (unitId !== undefined) {
                localVarQueryParameter['unitId'] = unitId;
            }

            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {GetUserByIdIdParameter} id 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getHeatProfilesLegacy: async (id: GetUserByIdIdParameter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getHeatProfilesLegacy', 'id', id)
            const localVarPath = `/api/users/{id}/heat-profiles`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPeakDevices: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPeakDevices', 'id', id)
            const localVarPath = `/api/users/{id}/peak-devices`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetUserByIdIdParameter} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById: async (id: GetUserByIdIdParameter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUserById', 'id', id)
            const localVarPath = `/api/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} search 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCount: async (search: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'search' is not null or undefined
            assertParamExists('getUserCount', 'search', search)
            const localVarPath = `/api/users/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserGoogleAuthDto} userGoogleAuthDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAuth: async (userGoogleAuthDto: UserGoogleAuthDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userGoogleAuthDto' is not null or undefined
            assertParamExists('googleAuth', 'userGoogleAuthDto', userGoogleAuthDto)
            const localVarPath = `/api/users/login/google`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userGoogleAuthDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lock: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('lock', 'id', id)
            const localVarPath = `/api/users/{id}/lock`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserLoginDto} userLoginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (userLoginDto: UserLoginDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userLoginDto' is not null or undefined
            assertParamExists('login', 'userLoginDto', userLoginDto)
            const localVarPath = `/api/users/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userLoginDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserRegisterDto} userRegisterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: async (userRegisterDto: UserRegisterDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userRegisterDto' is not null or undefined
            assertParamExists('register', 'userRegisterDto', userRegisterDto)
            const localVarPath = `/api/users/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userRegisterDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renewTokens: async (authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetUserByIdIdParameter} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestEmailVerification: async (id: GetUserByIdIdParameter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('requestEmailVerification', 'id', id)
            const localVarPath = `/api/users/{id}/request-email-verification`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserRequestResetPasswordDto} userRequestResetPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordReset: async (userRequestResetPasswordDto: UserRequestResetPasswordDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userRequestResetPasswordDto' is not null or undefined
            assertParamExists('requestPasswordReset', 'userRequestResetPasswordDto', userRequestResetPasswordDto)
            const localVarPath = `/api/users/request-password-reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userRequestResetPasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetUserByIdIdParameter} id 
         * @param {ResetPasswordDto} resetPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: async (id: GetUserByIdIdParameter, resetPasswordDto: ResetPasswordDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('resetPassword', 'id', id)
            // verify required parameter 'resetPasswordDto' is not null or undefined
            assertParamExists('resetPassword', 'resetPasswordDto', resetPasswordDto)
            const localVarPath = `/api/users/{id}/reset-password`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync peak device dab information.
         * @param {GetUserByIdIdParameter} id 
         * @param {string} serialNumber 
         * @param {DabHistoryCreateDto} dabHistoryCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sync: async (id: GetUserByIdIdParameter, serialNumber: string, dabHistoryCreateDto: DabHistoryCreateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sync', 'id', id)
            // verify required parameter 'serialNumber' is not null or undefined
            assertParamExists('sync', 'serialNumber', serialNumber)
            // verify required parameter 'dabHistoryCreateDto' is not null or undefined
            assertParamExists('sync', 'dabHistoryCreateDto', dabHistoryCreateDto)
            const localVarPath = `/api/users/{id}/dab-history/{serialNumber}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"serialNumber"}}`, encodeURIComponent(String(serialNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dabHistoryCreateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlock: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('unlock', 'id', id)
            const localVarPath = `/api/users/{id}/unlock`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetUserByIdIdParameter} id 
         * @param {UserUpdateDto} userUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserById: async (id: GetUserByIdIdParameter, userUpdateDto: UserUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateUserById', 'id', id)
            // verify required parameter 'userUpdateDto' is not null or undefined
            assertParamExists('updateUserById', 'userUpdateDto', userUpdateDto)
            const localVarPath = `/api/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetUserByIdIdParameter} id 
         * @param {UsernameUpdateDto} usernameUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUsername: async (id: GetUserByIdIdParameter, usernameUpdateDto: UsernameUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateUsername', 'id', id)
            // verify required parameter 'usernameUpdateDto' is not null or undefined
            assertParamExists('updateUsername', 'usernameUpdateDto', usernameUpdateDto)
            const localVarPath = `/api/users/{id}/username`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(usernameUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserValidateFieldsDto} userValidateFieldsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFields: async (userValidateFieldsDto: UserValidateFieldsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userValidateFieldsDto' is not null or undefined
            assertParamExists('validateFields', 'userValidateFieldsDto', userValidateFieldsDto)
            const localVarPath = `/api/users/validate-fields`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userValidateFieldsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetUserByIdIdParameter} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verify: async (id: GetUserByIdIdParameter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('verify', 'id', id)
            const localVarPath = `/api/users/{id}/verify`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {UserAppleAuthDto} userAppleAuthDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appleAuth(userAppleAuthDto: UserAppleAuthDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthTokensDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appleAuth(userAppleAuthDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.appleAuth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AppleAuthCallbackDto} appleAuthCallbackDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appleCallback(appleAuthCallbackDto: AppleAuthCallbackDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appleCallback(appleAuthCallbackDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.appleCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetUserByIdIdParameter} id 
         * @param {string} generatedUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkUserPair(id: GetUserByIdIdParameter, generatedUserId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgreementUserPairGetResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkUserPair(id, generatedUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.checkUserPair']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetUserByIdIdParameter} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserById(id: GetUserByIdIdParameter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.deleteUserById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportUsers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportUsers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.exportUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetUserByIdIdParameter} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgreements(id: GetUserByIdIdParameter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AgreementTracking>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgreements(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getAgreements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} limit 
         * @param {string} sort 
         * @param {string} search 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllUsers(page: number, limit: number, sort: string, search: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserGetResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllUsers(page, limit, sort, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getAllUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetUserByIdIdParameter} id 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getCustomMoodLights(id: GetUserByIdIdParameter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MoodLight>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomMoodLights(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getCustomMoodLights']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get user dab summary.
         * @param {GetUserByIdIdParameter} id 
         * @param {TimeFilterPeriod} period 
         * @param {string} timezone 
         * @param {number} [unitId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDabHistorySummary(id: GetUserByIdIdParameter, period: TimeFilterPeriod, timezone: string, unitId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DabSummaryGetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDabHistorySummary(id, period, timezone, unitId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getDabHistorySummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {GetUserByIdIdParameter} id 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getHeatProfilesLegacy(id: GetUserByIdIdParameter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHeatProfilesLegacy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getHeatProfilesLegacy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPeakDevices(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PeakDevice>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPeakDevices(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getPeakDevices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetUserByIdIdParameter} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserById(id: GetUserByIdIdParameter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserGetResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getUserById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} search 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserCount(search: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserCount(search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getUserCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UserGoogleAuthDto} userGoogleAuthDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleAuth(userGoogleAuthDto: UserGoogleAuthDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthTokensDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.googleAuth(userGoogleAuthDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.googleAuth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lock(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lock(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.lock']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UserLoginDto} userLoginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(userLoginDto: UserLoginDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserTokensDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(userLoginDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.login']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.logout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UserRegisterDto} userRegisterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async register(userRegisterDto: UserRegisterDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserGetResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.register(userRegisterDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.register']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renewTokens(authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserTokensDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renewTokens(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.renewTokens']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetUserByIdIdParameter} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestEmailVerification(id: GetUserByIdIdParameter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestEmailVerification(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.requestEmailVerification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UserRequestResetPasswordDto} userRequestResetPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestPasswordReset(userRequestResetPasswordDto: UserRequestResetPasswordDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestPasswordReset(userRequestResetPasswordDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.requestPasswordReset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetUserByIdIdParameter} id 
         * @param {ResetPasswordDto} resetPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPassword(id: GetUserByIdIdParameter, resetPasswordDto: ResetPasswordDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserGetResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPassword(id, resetPasswordDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.resetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sync peak device dab information.
         * @param {GetUserByIdIdParameter} id 
         * @param {string} serialNumber 
         * @param {DabHistoryCreateDto} dabHistoryCreateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sync(id: GetUserByIdIdParameter, serialNumber: string, dabHistoryCreateDto: DabHistoryCreateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sync(id, serialNumber, dabHistoryCreateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.sync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlock(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlock(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.unlock']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetUserByIdIdParameter} id 
         * @param {UserUpdateDto} userUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserById(id: GetUserByIdIdParameter, userUpdateDto: UserUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserGetResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserById(id, userUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.updateUserById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetUserByIdIdParameter} id 
         * @param {UsernameUpdateDto} usernameUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUsername(id: GetUserByIdIdParameter, usernameUpdateDto: UsernameUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserGetResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUsername(id, usernameUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.updateUsername']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UserValidateFieldsDto} userValidateFieldsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateFields(userValidateFieldsDto: UserValidateFieldsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateFieldsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateFields(userValidateFieldsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.validateFields']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetUserByIdIdParameter} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verify(id: GetUserByIdIdParameter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verify(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.verify']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @param {UsersApiAppleAuthRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appleAuth(requestParameters: UsersApiAppleAuthRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthTokensDto> {
            return localVarFp.appleAuth(requestParameters.userAppleAuthDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiAppleCallbackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appleCallback(requestParameters: UsersApiAppleCallbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.appleCallback(requestParameters.appleAuthCallbackDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiCheckUserPairRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkUserPair(requestParameters: UsersApiCheckUserPairRequest, options?: RawAxiosRequestConfig): AxiosPromise<AgreementUserPairGetResponseDto> {
            return localVarFp.checkUserPair(requestParameters.id, requestParameters.generatedUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiDeleteUserByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserById(requestParameters: UsersApiDeleteUserByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteUserById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportUsers(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.exportUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiGetAgreementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgreements(requestParameters: UsersApiGetAgreementsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AgreementTracking>> {
            return localVarFp.getAgreements(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiGetAllUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsers(requestParameters: UsersApiGetAllUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserGetResponseDto>> {
            return localVarFp.getAllUsers(requestParameters.page, requestParameters.limit, requestParameters.sort, requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {UsersApiGetCustomMoodLightsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getCustomMoodLights(requestParameters: UsersApiGetCustomMoodLightsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<MoodLight>> {
            return localVarFp.getCustomMoodLights(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user dab summary.
         * @param {UsersApiGetDabHistorySummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDabHistorySummary(requestParameters: UsersApiGetDabHistorySummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<DabSummaryGetDto> {
            return localVarFp.getDabHistorySummary(requestParameters.id, requestParameters.period, requestParameters.timezone, requestParameters.unitId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {UsersApiGetHeatProfilesLegacyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getHeatProfilesLegacy(requestParameters: UsersApiGetHeatProfilesLegacyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getHeatProfilesLegacy(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiGetPeakDevicesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPeakDevices(requestParameters: UsersApiGetPeakDevicesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PeakDevice>> {
            return localVarFp.getPeakDevices(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiGetUserByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById(requestParameters: UsersApiGetUserByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserGetResponseDto> {
            return localVarFp.getUserById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiGetUserCountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCount(requestParameters: UsersApiGetUserCountRequest, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getUserCount(requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiGoogleAuthRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleAuth(requestParameters: UsersApiGoogleAuthRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthTokensDto> {
            return localVarFp.googleAuth(requestParameters.userGoogleAuthDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiLockRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lock(requestParameters: UsersApiLockRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.lock(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiLoginRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(requestParameters: UsersApiLoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserTokensDto> {
            return localVarFp.login(requestParameters.userLoginDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.logout(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiRegisterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(requestParameters: UsersApiRegisterRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserGetResponseDto> {
            return localVarFp.register(requestParameters.userRegisterDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiRenewTokensRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renewTokens(requestParameters: UsersApiRenewTokensRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UserTokensDto> {
            return localVarFp.renewTokens(requestParameters.authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiRequestEmailVerificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestEmailVerification(requestParameters: UsersApiRequestEmailVerificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.requestEmailVerification(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiRequestPasswordResetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordReset(requestParameters: UsersApiRequestPasswordResetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.requestPasswordReset(requestParameters.userRequestResetPasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiResetPasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(requestParameters: UsersApiResetPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserGetResponseDto> {
            return localVarFp.resetPassword(requestParameters.id, requestParameters.resetPasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync peak device dab information.
         * @param {UsersApiSyncRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sync(requestParameters: UsersApiSyncRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sync(requestParameters.id, requestParameters.serialNumber, requestParameters.dabHistoryCreateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiUnlockRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlock(requestParameters: UsersApiUnlockRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unlock(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiUpdateUserByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserById(requestParameters: UsersApiUpdateUserByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserGetResponseDto> {
            return localVarFp.updateUserById(requestParameters.id, requestParameters.userUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiUpdateUsernameRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUsername(requestParameters: UsersApiUpdateUsernameRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserGetResponseDto> {
            return localVarFp.updateUsername(requestParameters.id, requestParameters.usernameUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiValidateFieldsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateFields(requestParameters: UsersApiValidateFieldsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ValidateFieldsResponse> {
            return localVarFp.validateFields(requestParameters.userValidateFieldsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UsersApiVerifyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verify(requestParameters: UsersApiVerifyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.verify(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for appleAuth operation in UsersApi.
 * @export
 * @interface UsersApiAppleAuthRequest
 */
export interface UsersApiAppleAuthRequest {
    /**
     * 
     * @type {UserAppleAuthDto}
     * @memberof UsersApiAppleAuth
     */
    readonly userAppleAuthDto: UserAppleAuthDto
}

/**
 * Request parameters for appleCallback operation in UsersApi.
 * @export
 * @interface UsersApiAppleCallbackRequest
 */
export interface UsersApiAppleCallbackRequest {
    /**
     * 
     * @type {AppleAuthCallbackDto}
     * @memberof UsersApiAppleCallback
     */
    readonly appleAuthCallbackDto: AppleAuthCallbackDto
}

/**
 * Request parameters for checkUserPair operation in UsersApi.
 * @export
 * @interface UsersApiCheckUserPairRequest
 */
export interface UsersApiCheckUserPairRequest {
    /**
     * 
     * @type {GetUserByIdIdParameter}
     * @memberof UsersApiCheckUserPair
     */
    readonly id: GetUserByIdIdParameter

    /**
     * 
     * @type {string}
     * @memberof UsersApiCheckUserPair
     */
    readonly generatedUserId: string
}

/**
 * Request parameters for deleteUserById operation in UsersApi.
 * @export
 * @interface UsersApiDeleteUserByIdRequest
 */
export interface UsersApiDeleteUserByIdRequest {
    /**
     * 
     * @type {GetUserByIdIdParameter}
     * @memberof UsersApiDeleteUserById
     */
    readonly id: GetUserByIdIdParameter
}

/**
 * Request parameters for getAgreements operation in UsersApi.
 * @export
 * @interface UsersApiGetAgreementsRequest
 */
export interface UsersApiGetAgreementsRequest {
    /**
     * 
     * @type {GetUserByIdIdParameter}
     * @memberof UsersApiGetAgreements
     */
    readonly id: GetUserByIdIdParameter
}

/**
 * Request parameters for getAllUsers operation in UsersApi.
 * @export
 * @interface UsersApiGetAllUsersRequest
 */
export interface UsersApiGetAllUsersRequest {
    /**
     * 
     * @type {number}
     * @memberof UsersApiGetAllUsers
     */
    readonly page: number

    /**
     * 
     * @type {number}
     * @memberof UsersApiGetAllUsers
     */
    readonly limit: number

    /**
     * 
     * @type {string}
     * @memberof UsersApiGetAllUsers
     */
    readonly sort: string

    /**
     * 
     * @type {string}
     * @memberof UsersApiGetAllUsers
     */
    readonly search: string
}

/**
 * Request parameters for getCustomMoodLights operation in UsersApi.
 * @export
 * @interface UsersApiGetCustomMoodLightsRequest
 */
export interface UsersApiGetCustomMoodLightsRequest {
    /**
     * 
     * @type {GetUserByIdIdParameter}
     * @memberof UsersApiGetCustomMoodLights
     */
    readonly id: GetUserByIdIdParameter
}

/**
 * Request parameters for getDabHistorySummary operation in UsersApi.
 * @export
 * @interface UsersApiGetDabHistorySummaryRequest
 */
export interface UsersApiGetDabHistorySummaryRequest {
    /**
     * 
     * @type {GetUserByIdIdParameter}
     * @memberof UsersApiGetDabHistorySummary
     */
    readonly id: GetUserByIdIdParameter

    /**
     * 
     * @type {TimeFilterPeriod}
     * @memberof UsersApiGetDabHistorySummary
     */
    readonly period: TimeFilterPeriod

    /**
     * 
     * @type {string}
     * @memberof UsersApiGetDabHistorySummary
     */
    readonly timezone: string

    /**
     * 
     * @type {number}
     * @memberof UsersApiGetDabHistorySummary
     */
    readonly unitId?: number
}

/**
 * Request parameters for getHeatProfilesLegacy operation in UsersApi.
 * @export
 * @interface UsersApiGetHeatProfilesLegacyRequest
 */
export interface UsersApiGetHeatProfilesLegacyRequest {
    /**
     * 
     * @type {GetUserByIdIdParameter}
     * @memberof UsersApiGetHeatProfilesLegacy
     */
    readonly id: GetUserByIdIdParameter
}

/**
 * Request parameters for getPeakDevices operation in UsersApi.
 * @export
 * @interface UsersApiGetPeakDevicesRequest
 */
export interface UsersApiGetPeakDevicesRequest {
    /**
     * 
     * @type {number}
     * @memberof UsersApiGetPeakDevices
     */
    readonly id: number
}

/**
 * Request parameters for getUserById operation in UsersApi.
 * @export
 * @interface UsersApiGetUserByIdRequest
 */
export interface UsersApiGetUserByIdRequest {
    /**
     * 
     * @type {GetUserByIdIdParameter}
     * @memberof UsersApiGetUserById
     */
    readonly id: GetUserByIdIdParameter
}

/**
 * Request parameters for getUserCount operation in UsersApi.
 * @export
 * @interface UsersApiGetUserCountRequest
 */
export interface UsersApiGetUserCountRequest {
    /**
     * 
     * @type {string}
     * @memberof UsersApiGetUserCount
     */
    readonly search: string
}

/**
 * Request parameters for googleAuth operation in UsersApi.
 * @export
 * @interface UsersApiGoogleAuthRequest
 */
export interface UsersApiGoogleAuthRequest {
    /**
     * 
     * @type {UserGoogleAuthDto}
     * @memberof UsersApiGoogleAuth
     */
    readonly userGoogleAuthDto: UserGoogleAuthDto
}

/**
 * Request parameters for lock operation in UsersApi.
 * @export
 * @interface UsersApiLockRequest
 */
export interface UsersApiLockRequest {
    /**
     * 
     * @type {number}
     * @memberof UsersApiLock
     */
    readonly id: number
}

/**
 * Request parameters for login operation in UsersApi.
 * @export
 * @interface UsersApiLoginRequest
 */
export interface UsersApiLoginRequest {
    /**
     * 
     * @type {UserLoginDto}
     * @memberof UsersApiLogin
     */
    readonly userLoginDto: UserLoginDto
}

/**
 * Request parameters for register operation in UsersApi.
 * @export
 * @interface UsersApiRegisterRequest
 */
export interface UsersApiRegisterRequest {
    /**
     * 
     * @type {UserRegisterDto}
     * @memberof UsersApiRegister
     */
    readonly userRegisterDto: UserRegisterDto
}

/**
 * Request parameters for renewTokens operation in UsersApi.
 * @export
 * @interface UsersApiRenewTokensRequest
 */
export interface UsersApiRenewTokensRequest {
    /**
     * 
     * @type {string}
     * @memberof UsersApiRenewTokens
     */
    readonly authorization?: string
}

/**
 * Request parameters for requestEmailVerification operation in UsersApi.
 * @export
 * @interface UsersApiRequestEmailVerificationRequest
 */
export interface UsersApiRequestEmailVerificationRequest {
    /**
     * 
     * @type {GetUserByIdIdParameter}
     * @memberof UsersApiRequestEmailVerification
     */
    readonly id: GetUserByIdIdParameter
}

/**
 * Request parameters for requestPasswordReset operation in UsersApi.
 * @export
 * @interface UsersApiRequestPasswordResetRequest
 */
export interface UsersApiRequestPasswordResetRequest {
    /**
     * 
     * @type {UserRequestResetPasswordDto}
     * @memberof UsersApiRequestPasswordReset
     */
    readonly userRequestResetPasswordDto: UserRequestResetPasswordDto
}

/**
 * Request parameters for resetPassword operation in UsersApi.
 * @export
 * @interface UsersApiResetPasswordRequest
 */
export interface UsersApiResetPasswordRequest {
    /**
     * 
     * @type {GetUserByIdIdParameter}
     * @memberof UsersApiResetPassword
     */
    readonly id: GetUserByIdIdParameter

    /**
     * 
     * @type {ResetPasswordDto}
     * @memberof UsersApiResetPassword
     */
    readonly resetPasswordDto: ResetPasswordDto
}

/**
 * Request parameters for sync operation in UsersApi.
 * @export
 * @interface UsersApiSyncRequest
 */
export interface UsersApiSyncRequest {
    /**
     * 
     * @type {GetUserByIdIdParameter}
     * @memberof UsersApiSync
     */
    readonly id: GetUserByIdIdParameter

    /**
     * 
     * @type {string}
     * @memberof UsersApiSync
     */
    readonly serialNumber: string

    /**
     * 
     * @type {DabHistoryCreateDto}
     * @memberof UsersApiSync
     */
    readonly dabHistoryCreateDto: DabHistoryCreateDto
}

/**
 * Request parameters for unlock operation in UsersApi.
 * @export
 * @interface UsersApiUnlockRequest
 */
export interface UsersApiUnlockRequest {
    /**
     * 
     * @type {number}
     * @memberof UsersApiUnlock
     */
    readonly id: number
}

/**
 * Request parameters for updateUserById operation in UsersApi.
 * @export
 * @interface UsersApiUpdateUserByIdRequest
 */
export interface UsersApiUpdateUserByIdRequest {
    /**
     * 
     * @type {GetUserByIdIdParameter}
     * @memberof UsersApiUpdateUserById
     */
    readonly id: GetUserByIdIdParameter

    /**
     * 
     * @type {UserUpdateDto}
     * @memberof UsersApiUpdateUserById
     */
    readonly userUpdateDto: UserUpdateDto
}

/**
 * Request parameters for updateUsername operation in UsersApi.
 * @export
 * @interface UsersApiUpdateUsernameRequest
 */
export interface UsersApiUpdateUsernameRequest {
    /**
     * 
     * @type {GetUserByIdIdParameter}
     * @memberof UsersApiUpdateUsername
     */
    readonly id: GetUserByIdIdParameter

    /**
     * 
     * @type {UsernameUpdateDto}
     * @memberof UsersApiUpdateUsername
     */
    readonly usernameUpdateDto: UsernameUpdateDto
}

/**
 * Request parameters for validateFields operation in UsersApi.
 * @export
 * @interface UsersApiValidateFieldsRequest
 */
export interface UsersApiValidateFieldsRequest {
    /**
     * 
     * @type {UserValidateFieldsDto}
     * @memberof UsersApiValidateFields
     */
    readonly userValidateFieldsDto: UserValidateFieldsDto
}

/**
 * Request parameters for verify operation in UsersApi.
 * @export
 * @interface UsersApiVerifyRequest
 */
export interface UsersApiVerifyRequest {
    /**
     * 
     * @type {GetUserByIdIdParameter}
     * @memberof UsersApiVerify
     */
    readonly id: GetUserByIdIdParameter
}

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @param {UsersApiAppleAuthRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public appleAuth(requestParameters: UsersApiAppleAuthRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).appleAuth(requestParameters.userAppleAuthDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiAppleCallbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public appleCallback(requestParameters: UsersApiAppleCallbackRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).appleCallback(requestParameters.appleAuthCallbackDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiCheckUserPairRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public checkUserPair(requestParameters: UsersApiCheckUserPairRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).checkUserPair(requestParameters.id, requestParameters.generatedUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiDeleteUserByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public deleteUserById(requestParameters: UsersApiDeleteUserByIdRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).deleteUserById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public exportUsers(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).exportUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiGetAgreementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getAgreements(requestParameters: UsersApiGetAgreementsRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getAgreements(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiGetAllUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getAllUsers(requestParameters: UsersApiGetAllUsersRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getAllUsers(requestParameters.page, requestParameters.limit, requestParameters.sort, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {UsersApiGetCustomMoodLightsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getCustomMoodLights(requestParameters: UsersApiGetCustomMoodLightsRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getCustomMoodLights(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user dab summary.
     * @param {UsersApiGetDabHistorySummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getDabHistorySummary(requestParameters: UsersApiGetDabHistorySummaryRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getDabHistorySummary(requestParameters.id, requestParameters.period, requestParameters.timezone, requestParameters.unitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {UsersApiGetHeatProfilesLegacyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getHeatProfilesLegacy(requestParameters: UsersApiGetHeatProfilesLegacyRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getHeatProfilesLegacy(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiGetPeakDevicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getPeakDevices(requestParameters: UsersApiGetPeakDevicesRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getPeakDevices(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiGetUserByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUserById(requestParameters: UsersApiGetUserByIdRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUserById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiGetUserCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUserCount(requestParameters: UsersApiGetUserCountRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUserCount(requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiGoogleAuthRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public googleAuth(requestParameters: UsersApiGoogleAuthRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).googleAuth(requestParameters.userGoogleAuthDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiLockRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public lock(requestParameters: UsersApiLockRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).lock(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public login(requestParameters: UsersApiLoginRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).login(requestParameters.userLoginDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public logout(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiRegisterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public register(requestParameters: UsersApiRegisterRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).register(requestParameters.userRegisterDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiRenewTokensRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public renewTokens(requestParameters: UsersApiRenewTokensRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).renewTokens(requestParameters.authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiRequestEmailVerificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public requestEmailVerification(requestParameters: UsersApiRequestEmailVerificationRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).requestEmailVerification(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiRequestPasswordResetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public requestPasswordReset(requestParameters: UsersApiRequestPasswordResetRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).requestPasswordReset(requestParameters.userRequestResetPasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiResetPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public resetPassword(requestParameters: UsersApiResetPasswordRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).resetPassword(requestParameters.id, requestParameters.resetPasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync peak device dab information.
     * @param {UsersApiSyncRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public sync(requestParameters: UsersApiSyncRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).sync(requestParameters.id, requestParameters.serialNumber, requestParameters.dabHistoryCreateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiUnlockRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public unlock(requestParameters: UsersApiUnlockRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).unlock(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiUpdateUserByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateUserById(requestParameters: UsersApiUpdateUserByIdRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).updateUserById(requestParameters.id, requestParameters.userUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiUpdateUsernameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateUsername(requestParameters: UsersApiUpdateUsernameRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).updateUsername(requestParameters.id, requestParameters.usernameUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiValidateFieldsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public validateFields(requestParameters: UsersApiValidateFieldsRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).validateFields(requestParameters.userValidateFieldsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UsersApiVerifyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public verify(requestParameters: UsersApiVerifyRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).verify(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



